let emojiList = [
  {
    "name": "100",
    "unicode": "\u{1f4af}",
    // "shortname": ":100:",

    "category": "s",
    "emoji_order": "2119"
  },
  {
    "name": "1234",
    "unicode": "\u{1f522}",
    // "shortname": ":1234:",

    "category": "s",
    "emoji_order": "2122"
  },
  {
    "name": "grinning",
    "unicode": "\u{1f600}",
    // "shortname": ":grinning:",

    "category": "p",
    "emoji_order": "1"
  },
  {
    "name": "grin",
    "unicode": "\u{1f601}",
    // "shortname": ":grin:",

    "category": "p",
    "emoji_order": "2"
  },
  {
    "name": "joy",
    "unicode": "\u{1f602}",
    // "shortname": ":joy:",

    "category": "p",
    "emoji_order": "3"
  },
  {
    "name": "rolling_on_the_floor_laughing",
    "unicode": "\u{1f923}",
    // "shortname": ":rofl:",

    "category": "p",
    "emoji_order": "4"
  },
  {
    "name": "smiley",
    "unicode": "\u{1f603}",
    // "shortname": ":smiley:",

    "category": "p",
    "emoji_order": "5"
  },
  {
    "name": "smile",
    "unicode": "\u{1f604}",
    // "shortname": ":smile:",

    "category": "p",
    "emoji_order": "6"
  },
  {
    "name": "sweat_smile",
    "unicode": "\u{1f605}",
    // "shortname": ":sweat_smile:",

    "category": "p",
    "emoji_order": "7"
  },
  {
    "name": "laughing",
    "unicode": "\u{1f606}",
    // "shortname": ":laughing:",

    "category": "p",
    "emoji_order": "8"
  },
  {
    "name": "wink",
    "unicode": "\u{1f609}",
    // "shortname": ":wink:",

    "category": "p",
    "emoji_order": "9"
  },
  {
    "name": "blush",
    "unicode": "\u{1f60a}",
    // "shortname": ":blush:",

    "category": "p",
    "emoji_order": "10"
  },
  {
    "name": "yum",
    "unicode": "\u{1f60b}",
    // "shortname": ":yum:",

    "category": "p",
    "emoji_order": "11"
  },
  {
    "name": "sunglasses",
    "unicode": "\u{1f60e}",
    // "shortname": ":sunglasses:",

    "category": "p",
    "emoji_order": "12"
  },
  {
    "name": "heart_eyes",
    "unicode": "\u{1f60d}",
    // "shortname": ":heart_eyes:",

    "category": "p",
    "emoji_order": "13"
  },
  {
    "name": "kissing_heart",
    "unicode": "\u{1f618}",
    // "shortname": ":kissing_heart:",

    "category": "p",
    "emoji_order": "14"
  },
  {
    "name": "kissing",
    "unicode": "\u{1f617}",
    // "shortname": ":kissing:",

    "category": "p",
    "emoji_order": "15"
  },
  {
    "name": "kissing_smiling_eyes",
    "unicode": "\u{1f619}",
    // "shortname": ":kissing_smiling_eyes:",

    "category": "p",
    "emoji_order": "16"
  },
  {
    "name": "kissing_closed_eyes",
    "unicode": "\u{1f61a}",
    // "shortname": ":kissing_closed_eyes:",

    "category": "p",
    "emoji_order": "17"
  },
  {
    "name": "slightly_smiling_face",
    "unicode": "\u{1f642}",
    // "shortname": ":slight_smile:",

    "category": "p",
    "emoji_order": "19"
  },
  {
    "name": "hugging_face",
    "unicode": "\u{1f917}",
    // "shortname": ":hugging:",

    "category": "p",
    "emoji_order": "20"
  },
  {
    "name": "thinking_face",
    "unicode": "\u{1f914}",
    // "shortname": ":thinking:",

    "category": "p",
    "emoji_order": "21"
  },
  {
    "name": "neutral_face",
    "unicode": "\u{1f610}",
    // "shortname": ":neutral_face:",

    "category": "p",
    "emoji_order": "22"
  },
  {
    "name": "expressionless",
    "unicode": "\u{1f611}",
    // "shortname": ":expressionless:",

    "category": "p",
    "emoji_order": "23"
  },
  {
    "name": "no_mouth",
    "unicode": "\u{1f636}",
    // "shortname": ":no_mouth:",

    "category": "p",
    "emoji_order": "24"
  },
  {
    "name": "face_with_rolling_eyes",
    "unicode": "\u{1f644}",
    // "shortname": ":rolling_eyes:",

    "category": "p",
    "emoji_order": "25"
  },
  {
    "name": "smirk",
    "unicode": "\u{1f60f}",
    // "shortname": ":smirk:",

    "category": "p",
    "emoji_order": "26"
  },
  {
    "name": "persevere",
    "unicode": "\u{1f623}",
    // "shortname": ":persevere:",

    "category": "p",
    "emoji_order": "27"
  },
  {
    "name": "disappointed_relieved",
    "unicode": "\u{1f625}",
    // "shortname": ":disappointed_relieved:",

    "category": "p",
    "emoji_order": "28"
  },
  {
    "name": "open_mouth",
    "unicode": "\u{1f62e}",
    // "shortname": ":open_mouth:",

    "category": "p",
    "emoji_order": "29"
  },
  {
    "name": "zipper_mouth_face",
    "unicode": "\u{1f910}",
    // "shortname": ":zipper_mouth:",

    "category": "p",
    "emoji_order": "30"
  },
  {
    "name": "hushed",
    "unicode": "\u{1f62f}",
    // "shortname": ":hushed:",

    "category": "p",
    "emoji_order": "31"
  },
  {
    "name": "sleepy",
    "unicode": "\u{1f62a}",
    // "shortname": ":sleepy:",

    "category": "p",
    "emoji_order": "32"
  },
  {
    "name": "tired_face",
    "unicode": "\u{1f62b}",
    // "shortname": ":tired_face:",

    "category": "p",
    "emoji_order": "33"
  },
  {
    "name": "sleeping",
    "unicode": "\u{1f634}",
    // "shortname": ":sleeping:",

    "category": "p",
    "emoji_order": "34"
  },
  {
    "name": "relieved",
    "unicode": "\u{1f60c}",
    // "shortname": ":relieved:",

    "category": "p",
    "emoji_order": "35"
  },
  {
    "name": "nerd_face",
    "unicode": "\u{1f913}",
    // "shortname": ":nerd:",

    "category": "p",
    "emoji_order": "36"
  },
  {
    "name": "stuck_out_tongue",
    "unicode": "\u{1f61b}",
    // "shortname": ":stuck_out_tongue:",

    "category": "p",
    "emoji_order": "37"
  },
  {
    "name": "stuck_out_tongue_winking_eye",
    "unicode": "\u{1f61c}",
    // "shortname": ":stuck_out_tongue_winking_eye:",

    "category": "p",
    "emoji_order": "38"
  },
  {
    "name": "stuck_out_tongue_closed_eyes",
    "unicode": "\u{1f61d}",
    // "shortname": ":stuck_out_tongue_closed_eyes:",

    "category": "p",
    "emoji_order": "39"
  },
  {
    "name": "drooling_face",
    "unicode": "\u{1f924}",
    // "shortname": ":drooling_face:",

    "category": "p",
    "emoji_order": "40"
  },
  {
    "name": "unamused",
    "unicode": "\u{1f612}",
    // "shortname": ":unamused:",

    "category": "p",
    "emoji_order": "41"
  },
  {
    "name": "sweat",
    "unicode": "\u{1f613}",
    // "shortname": ":sweat:",

    "category": "p",
    "emoji_order": "42"
  },
  {
    "name": "pensive",
    "unicode": "\u{1f614}",
    // "shortname": ":pensive:",

    "category": "p",
    "emoji_order": "43"
  },
  {
    "name": "confused",
    "unicode": "\u{1f615}",
    // "shortname": ":confused:",

    "category": "p",
    "emoji_order": "44"
  },
  {
    "name": "upside_down_face",
    "unicode": "\u{1f643}",
    // "shortname": ":upside_down:",

    "category": "p",
    "emoji_order": "45"
  },
  {
    "name": "money_mouth_face",
    "unicode": "\u{1f911}",
    // "shortname": ":money_mouth:",

    "category": "p",
    "emoji_order": "46"
  },
  {
    "name": "astonished",
    "unicode": "\u{1f632}",
    // "shortname": ":astonished:",

    "category": "p",
    "emoji_order": "47"
  },
  {
    "name": "slightly_frowning_face",
    "unicode": "\u{1f641}",
    // "shortname": ":slight_frown:",

    "category": "p",
    "emoji_order": "49"
  },
  {
    "name": "confounded",
    "unicode": "\u{1f616}",
    // "shortname": ":confounded:",

    "category": "p",
    "emoji_order": "50"
  },
  {
    "name": "disappointed",
    "unicode": "\u{1f61e}",
    // "shortname": ":disappointed:",

    "category": "p",
    "emoji_order": "51"
  },
  {
    "name": "worried",
    "unicode": "\u{1f61f}",
    // "shortname": ":worried:",

    "category": "p",
    "emoji_order": "52"
  },
  {
    "name": "triumph",
    "unicode": "\u{1f624}",
    // "shortname": ":triumph:",

    "category": "p",
    "emoji_order": "53"
  },
  {
    "name": "cry",
    "unicode": "\u{1f622}",
    // "shortname": ":cry:",

    "category": "p",
    "emoji_order": "54"
  },
  {
    "name": "sob",
    "unicode": "\u{1f62d}",
    // "shortname": ":sob:",

    "category": "p",
    "emoji_order": "55"
  },
  {
    "name": "frowning",
    "unicode": "\u{1f626}",
    // "shortname": ":frowning:",

    "category": "p",
    "emoji_order": "56"
  },
  {
    "name": "anguished",
    "unicode": "\u{1f627}",
    // "shortname": ":anguished:",

    "category": "p",
    "emoji_order": "57"
  },
  {
    "name": "fearful",
    "unicode": "\u{1f628}",
    // "shortname": ":fearful:",

    "category": "p",
    "emoji_order": "58"
  },
  {
    "name": "weary",
    "unicode": "\u{1f629}",
    // "shortname": ":weary:",

    "category": "p",
    "emoji_order": "59"
  },
  {
    "name": "grimacing",
    "unicode": "\u{1f62c}",
    // "shortname": ":grimacing:",

    "category": "p",
    "emoji_order": "60"
  },
  {
    "name": "cold_sweat",
    "unicode": "\u{1f630}",
    // "shortname": ":cold_sweat:",

    "category": "p",
    "emoji_order": "61"
  },
  {
    "name": "scream",
    "unicode": "\u{1f631}",
    // "shortname": ":scream:",

    "category": "p",
    "emoji_order": "62"
  },
  {
    "name": "flushed",
    "unicode": "\u{1f633}",
    // "shortname": ":flushed:",

    "category": "p",
    "emoji_order": "63"
  },
  {
    "name": "dizzy_face",
    "unicode": "\u{1f635}",
    // "shortname": ":dizzy_face:",

    "category": "p",
    "emoji_order": "64"
  },
  {
    "name": "rage",
    "unicode": "\u{1f621}",
    // "shortname": ":rage:",

    "category": "p",
    "emoji_order": "65"
  },
  {
    "name": "angry",
    "unicode": "\u{1f620}",
    // "shortname": ":angry:",

    "category": "p",
    "emoji_order": "66"
  },
  {
    "name": "innocent",
    "unicode": "\u{1f607}",
    // "shortname": ":innocent:",

    "category": "p",
    "emoji_order": "67"
  },
  {
    "name": "face_with_cowboy_hat",
    "unicode": "\u{1f920}",
    // "shortname": ":cowboy:",

    "category": "p",
    "emoji_order": "68"
  },
  {
    "name": "clown_face",
    "unicode": "\u{1f921}",
    // "shortname": ":clown:",

    "category": "p",
    "emoji_order": "69"
  },
  { //@todo not founf on image
    "name": "lying_face",
    "unicode": "\u{1f925}",
    // "shortname": ":lying_face:",

    "category": "p",
    "emoji_order": "70"
  },
  {
    "name": "mask",
    "unicode": "\u{1f637}",
    // "shortname": ":mask:",

    "category": "p",
    "emoji_order": "71"
  },
  {
    "name": "face_with_thermometer",
    "unicode": "\u{1f912}",
    // "shortname": ":thermometer_face:",

    "category": "p",
    "emoji_order": "72"
  },
  {
    "name": "face_with_head_bandage",
    "unicode": "\u{1f915}",
    // "shortname": ":head_bandage:",

    "category": "p",
    "emoji_order": "73"
  },
  {
    "name": "nauseated_face",
    "unicode": "\u{1f922}",
    // "shortname": ":nauseated_face:",

    "category": "p",
    "emoji_order": "74"
  },
  {
    "name": "sneezing_face",
    "unicode": "\u{1f927}",
    // "shortname": ":sneezing_face:",

    "category": "p",
    "emoji_order": "75"
  },
  {
    "name": "smiling_imp",
    "unicode": "\u{1f608}",
    // "shortname": ":smiling_imp:",

    "category": "p",
    "emoji_order": "76"
  },
  {
    "name": "imp",
    "unicode": "\u{1f47f}",
    // "shortname": ":imp:",

    "category": "p",
    "emoji_order": "77"
  },
  {
    "name": "japanese_ogre",
    "unicode": "\u{1f479}",
    // "shortname": ":japanese_ogre:",

    "category": "p",
    "emoji_order": "78"
  },
  {
    "name": "japanese_goblin",
    "unicode": "\u{1f47a}",
    // "shortname": ":japanese_goblin:",

    "category": "p",
    "emoji_order": "79"
  },
  {
    "name": "skull",
    "unicode": "\u{1f480}",
    // "shortname": ":skull:",

    "category": "p",
    "emoji_order": "80"
  },
  {
    "name": "skull_and_crossbones",
    "unicode": "\u{2620}",
    // "shortname": ":skull_crossbones:",

    "category": "o",
    "emoji_order": "81"
  },
  {
    "name": "ghost",
    "unicode": "\u{1f47b}",
    // "shortname": ":ghost:",

    "category": "p",
    "emoji_order": "82"
  },
  {
    "name": "alien",
    "unicode": "\u{1f47d}",
    // "shortname": ":alien:",

    "category": "p",
    "emoji_order": "83"
  },
  {
    "name": "space_invader",
    "unicode": "\u{1f47e}",
    // "shortname": ":space_invader:",

    "category": "a",
    "emoji_order": "84"
  },
  {
    "name": "robot_face",
    "unicode": "\u{1f916}",
    // "shortname": ":robot:",

    "category": "p",
    "emoji_order": "85"
  },
  {
    "name": "hankey",
    "unicode": "\u{1f4a9}",
    // "shortname": ":poop:",

    "category": "p",
    "emoji_order": "86"
  },
  {
    "name": "smiley_cat",
    "unicode": "\u{1f63a}",
    // "shortname": ":smiley_cat:",

    "category": "p",
    "emoji_order": "87"
  },
  {
    "name": "smile_cat",
    "unicode": "\u{1f638}",
    // "shortname": ":smile_cat:",

    "category": "p",
    "emoji_order": "88"
  },
  {
    "name": "joy_cat",
    "unicode": "\u{1f639}",
    // "shortname": ":joy_cat:",

    "category": "p",
    "emoji_order": "89"
  },
  {
    "name": "heart_eyes_cat",
    "unicode": "\u{1f63b}",
    // "shortname": ":heart_eyes_cat:",

    "category": "p",
    "emoji_order": "90"
  },
  {
    "name": "smirk_cat",
    "unicode": "\u{1f63c}",
    // "shortname": ":smirk_cat:",

    "category": "p",
    "emoji_order": "91"
  },
  {
    "name": "kissing_cat",
    "unicode": "\u{1f63d}",
    // "shortname": ":kissing_cat:",

    "category": "p",
    "emoji_order": "92"
  },
  {
    "name": "scream_cat",
    "unicode": "\u{1f640}",
    // "shortname": ":scream_cat:",

    "category": "p",
    "emoji_order": "93"
  },
  {
    "name": "crying_cat_face",
    "unicode": "\u{1f63f}",
    // "shortname": ":crying_cat_face:",

    "category": "p",
    "emoji_order": "94"
  },
  {
    "name": "pouting_cat",
    "unicode": "\u{1f63e}",
    // "shortname": ":pouting_cat:",

    "category": "p",
    "emoji_order": "95"
  },
  {
    "name": "see_no_evil",
    "unicode": "\u{1f648}",
    // "shortname": ":see_no_evil:",

    "category": "n",
    "emoji_order": "96"
  },
  {
    "name": "hear_no_evil",
    "unicode": "\u{1f649}",
    // "shortname": ":hear_no_evil:",

    "category": "n",
    "emoji_order": "97"
  },
  {
    "name": "speak_no_evil",
    "unicode": "\u{1f64a}",
    // "shortname": ":speak_no_evil:",

    "category": "n",
    "emoji_order": "98"
  },
  {
    "name": "boy",
    "unicode": "\u{1f466}",
    // "shortname": ":boy:",

    "category": "p",
    "emoji_order": "99"
  },
  {
    "name": "girl",
    "unicode": "\u{1f467}",
    // "shortname": ":girl:",

    "category": "p",
    "emoji_order": "105"
  },
  {
    "name": "man",
    "unicode": "\u{1f468}",
    // "shortname": ":man:",

    "category": "p",
    "emoji_order": "111"
  },
  {
    "name": "woman",
    "unicode": "\u{1f469}",
    // "shortname": ":woman:",

    "category": "p",
    "emoji_order": "117"
  },
  {
    "name": "older_man",
    "unicode": "\u{1f474}",
    // "shortname": ":older_man:",

    "category": "p",
    "emoji_order": "123"
  },
  {
    "name": "older_woman",
    "unicode": "\u{1f475}",
    // "shortname": ":older_woman:",

    "category": "p",
    "emoji_order": "129"
  },
  {
    "name": "baby",
    "unicode": "\u{1f476}",
    // "shortname": ":baby:",

    "category": "p",
    "emoji_order": "135"
  },
  {
    "name": "angel",
    "unicode": "\u{1f47c}",
    // "shortname": ":angel:",

    "category": "p",
    "emoji_order": "141"
  },
  {
    "name": "cop",
    "unicode": "\u{1f46e}",
    // "shortname": ":cop:",

    "category": "p",
    "emoji_order": "339"
  },
  {
    "name": "sleuth_or_spy",
    "unicode": "\u{1f575}",
    // "shortname": ":spy:",

    "category": "p",
    "emoji_order": "357"
  },
  {
    "name": "guardsman",
    "unicode": "\u{1f482}",
    // "shortname": ":guardsman:",

    "category": "p",
    "emoji_order": "375"
  },
  {
    "name": "construction_worker",
    "unicode": "\u{1f477}",
    // "shortname": ":construction_worker:",

    "category": "p",
    "emoji_order": "393"
  },
  {
    "name": "man_with_turban",
    "unicode": "\u{1f473}",
    // "shortname": ":man_with_turban:",

    "category": "p",
    "emoji_order": "411"
  },
  {
    "name": "person_with_blond_hair",
    "unicode": "\u{1f471}",
    // "shortname": ":person_with_blond_hair:",

    "category": "p",
    "emoji_order": "429"
  },
  {
    "name": "santa",
    "unicode": "\u{1f385}",
    // "shortname": ":santa:",

    "category": "p",
    "emoji_order": "447"
  },
  {
    "name": "mrs_claus",
    "unicode": "\u{1f936}",
    // "shortname": ":mrs_claus:",

    "category": "p",
    "emoji_order": "453"
  },
  {
    "name": "princess",
    "unicode": "\u{1f478}",
    // "shortname": ":princess:",

    "category": "p",
    "emoji_order": "459"
  },
  {
    "name": "prince",
    "unicode": "\u{1f934}",
    // "shortname": ":prince:",

    "category": "p",
    "emoji_order": "465"
  },
  {
    "name": "bride_with_veil",
    "unicode": "\u{1f470}",
    // "shortname": ":bride_with_veil:",

    "category": "p",
    "emoji_order": "471"
  },
  {
    "name": "man_in_tuxedo",
    "unicode": "\u{1f935}",
    // "shortname": ":man_in_tuxedo:",

    "category": "p",
    "emoji_order": "477"
  },
  {
    "name": "pregnant_woman",
    "unicode": "\u{1f930}",
    // "shortname": ":pregnant_woman:",

    "category": "p",
    "emoji_order": "483"
  },
  {
    "name": "man_with_gua_pi_mao",
    "unicode": "\u{1f472}",
    // "shortname": ":man_with_gua_pi_mao:",

    "category": "p",
    "emoji_order": "489"
  },
  {
    "name": "person_frowning",
    "unicode": "\u{1f64d}",
    // "shortname": ":person_frowning:",

    "category": "p",
    "emoji_order": "495"
  },
  {
    "name": "person_with_pouting_face",
    "unicode": "\u{1f64e}",
    // "shortname": ":person_with_pouting_face:",

    "category": "p",
    "emoji_order": "513"
  },
  {
    "name": "no_good",
    "unicode": "\u{1f645}",
    // "shortname": ":no_good:",

    "category": "p",
    "emoji_order": "531"
  },
  {
    "name": "ok_woman",
    "unicode": "\u{1f646}",
    // "shortname": ":ok_woman:",

    "category": "p",
    "emoji_order": "549"
  },
  {
    "name": "information_desk_person",
    "unicode": "\u{1f481}",
    // "shortname": ":information_desk_person:",

    "category": "p",
    "emoji_order": "567"
  },
  {
    "name": "raising_hand",
    "unicode": "\u{1f64b}",
    // "shortname": ":raising_hand:",

    "category": "p",
    "emoji_order": "585"
  },
  {
    "name": "bow",
    "unicode": "\u{1f647}",
    // "shortname": ":bow:",

    "category": "p",
    "emoji_order": "603"
  },
  {
    "name": "face_palm",
    "unicode": "\u{1f926}",
    // "shortname": ":face_palm:",

    "category": "p",
    "emoji_order": "621"
  },
  {
    "name": "shrug",
    "unicode": "\u{1f937}",
    // "shortname": ":shrug:",

    "category": "p",
    "emoji_order": "639"
  },
  {
    "name": "massage",
    "unicode": "\u{1f486}",
    // "shortname": ":massage:",

    "category": "p",
    "emoji_order": "657"
  },
  {
    "name": "haircut",
    "unicode": "\u{1f487}",
    // "shortname": ":haircut:",

    "category": "p",
    "emoji_order": "675"
  },
  {
    "name": "walking",
    "unicode": "\u{1f6b6}",
    // "shortname": ":walking:",

    "category": "p",
    "emoji_order": "693"
  },
  {
    "name": "runner",
    "unicode": "\u{1f3c3}",
    // "shortname": ":runner:",

    "category": "p",
    "emoji_order": "711"
  },
  {
    "name": "dancer",
    "unicode": "\u{1f483}",
    // "shortname": ":dancer:",

    "category": "p",
    "emoji_order": "729"
  },
  {
    "name": "man_dancing",
    "unicode": "\u{1f57a}",
    // "shortname": ":man_dancing:",

    "category": "p",
    "emoji_order": "735"
  },
  {
    "name": "dancers",
    "unicode": "\u{1f46f}",
    // "shortname": ":dancers:",

    "category": "p",
    "emoji_order": "741"
  },
  {
    "name": "man_in_business_suit_levitating",
    "unicode": "\u{1f574}",
    // "shortname": ":levitate:",

    "category": "a",
    "emoji_order": "759"
  },
  {
    "name": "speaking_head_in_silhouette",
    "unicode": "\u{1f5e3}",
    // "shortname": ":speaking_head:",

    "category": "p",
    "emoji_order": "765"
  },
  {
    "name": "bust_in_silhouette",
    "unicode": "\u{1f464}",
    // "shortname": ":bust_in_silhouette:",

    "category": "p",
    "emoji_order": "766"
  },
  {
    "name": "busts_in_silhouette",
    "unicode": "\u{1f465}",
    // "shortname": ":busts_in_silhouette:",

    "category": "p",
    "emoji_order": "767"
  },
  {
    "name": "fencer",
    "unicode": "\u{1f93a}",
    // "shortname": ":fencer:",

    "category": "a",
    "emoji_order": "768"
  },
  {
    "name": "horse_racing",
    "unicode": "\u{1f3c7}",
    // "shortname": ":horse_racing:",

    "category": "a",
    "emoji_order": "769"
  },
  {
    "name": "skier",
    "unicode": "\u{26f7}",
    // "shortname": ":skier:",

    "category": "a",
    "emoji_order": "775"
  },
  {
    "name": "snowboarder",
    "unicode": "\u{1f3c2}",
    // "shortname": ":snowboarder:",

    "category": "a",
    "emoji_order": "776"
  },
  {
    "name": "golfer",
    "unicode": "\u{1f3cc}",
    // "shortname": ":golfer:",

    "category": "a",
    "emoji_order": "782"
  },
  {
    "name": "surfer",
    "unicode": "\u{1f3c4}",
    // "shortname": ":surfer:",

    "category": "a",
    "emoji_order": "800"
  },
  {
    "name": "rowboat",
    "unicode": "\u{1f6a3}",
    // "shortname": ":rowboat:",

    "category": "a",
    "emoji_order": "818"
  },
  {
    "name": "swimmer",
    "unicode": "\u{1f3ca}",
    // "shortname": ":swimmer:",

    "category": "a",
    "emoji_order": "836"
  },
  {
    "name": "person_with_ball",
    "unicode": "\u{26f9}",
    // "shortname": ":basketball_player:",

    "category": "a",
    "emoji_order": "854"
  },
  {
    "name": "weight_lifter",
    "unicode": "\u{1f3cb}",
    // "shortname": ":lifter:",

    "category": "a",
    "emoji_order": "872"
  },
  {
    "name": "bicyclist",
    "unicode": "\u{1f6b4}",
    // "shortname": ":bicyclist:",

    "category": "a",
    "emoji_order": "890"
  },
  {
    "name": "mountain_bicyclist",
    "unicode": "\u{1f6b5}",
    // "shortname": ":mountain_bicyclist:",

    "category": "a",
    "emoji_order": "908"
  },
  {
    "name": "racing_car",
    "unicode": "\u{1f3ce}",
    // "shortname": ":race_car:",

    "category": "t",
    "emoji_order": "926"
  },
  {
    "name": "racing_motorcycle",
    "unicode": "\u{1f3cd}",
    // "shortname": ":motorcycle:",

    "category": "t",
    "emoji_order": "927"
  },
  {
    "name": "cartwheel",
    "unicode": "\u{1f938}",
    // "shortname": ":cartwheel:",

    "category": "a",
    "emoji_order": "928"
  },
  {
    "name": "wrestlers",
    "unicode": "\u{1f93c}",
    // "shortname": ":wrestlers:",

    "category": "a",
    "emoji_order": "946"
  },
  {
    "name": "water_polo",
    "unicode": "\u{1f93d}",
    // "shortname": ":water_polo:",

    "category": "a",
    "emoji_order": "964"
  },
  {
    "name": "handball",
    "unicode": "\u{1f93e}",
    // "shortname": ":handball:",

    "category": "a",
    "emoji_order": "982"
  },
  {
    "name": "juggling",
    "unicode": "\u{1f939}",
    // "shortname": ":juggling:",

    "category": "a",
    "emoji_order": "1000"
  },
  {
    "name": "couple",
    "unicode": "\u{1f46b}",
    // "shortname": ":couple:",

    "category": "p",
    "emoji_order": "1018"
  },
  {
    "name": "two_men_holding_hands",
    "unicode": "\u{1f46c}",
    // "shortname": ":two_men_holding_hands:",

    "category": "p",
    "emoji_order": "1024"
  },
  {
    "name": "two_women_holding_hands",
    "unicode": "\u{1f46d}",
    // "shortname": ":two_women_holding_hands:",

    "category": "p",
    "emoji_order": "1030"
  },
  {
    "name": "couplekiss",
    "unicode": "\u{1f48f}",
    // "shortname": ":couplekiss:",

    "category": "p",
    "emoji_order": "1036"
  },

  {
    "name": "couple_with_heart",
    "unicode": "\u{1f491}",
    // "shortname": ":couple_with_heart:",

    "category": "p",
    "emoji_order": "1040"
  },
  {
    "name": "family",
    "unicode": "\u{1f46a}",
    // "shortname": ":family:",

    "category": "p",
    "emoji_order": "1044"
  },
  {
    "name": "muscle",
    "unicode": "\u{1f4aa}",
    // "shortname": ":muscle:",

    "category": "p",
    "emoji_order": "1080"
  },
  {
    "name": "selfie",
    "unicode": "\u{1f933}",
    // "shortname": ":selfie:",

    "category": "p",
    "emoji_order": "1086"
  },
  {
    "name": "point_left",
    "unicode": "\u{1f448}",
    // "shortname": ":point_left:",

    "category": "p",
    "emoji_order": "1092"
  },
  {
    "name": "point_right",
    "unicode": "\u{1f449}",
    // "shortname": ":point_right:",

    "category": "p",
    "emoji_order": "1098"
  },
  {
    "name": "point_up",
    "unicode": "\u{261d}",
    // "shortname": ":point_up:",

    "category": "p",
    "emoji_order": "1104"
  },
  {
    "name": "point_up_2",
    "unicode": "\u{1f446}",
    // "shortname": ":point_up_2:",

    "category": "p",
    "emoji_order": "1110"
  },
  {
    "name": "middle_finger",
    "unicode": "\u{1f595}",
    // "shortname": ":middle_finger:",

    "category": "p",
    "emoji_order": "1116"
  },
  {
    "name": "point_down",
    "unicode": "\u{1f447}",
    // "shortname": ":point_down:",

    "category": "p",
    "emoji_order": "1122"
  },
  {
    "name": "v",
    "unicode": "\u{270c}",
    // "shortname": ":v:",

    "category": "p",
    "emoji_order": "1128"
  },
  {
    "name": "fingers_crossed",
    "unicode": "\u{1f91e}",
    // "shortname": ":fingers_crossed:",

    "category": "p",
    "emoji_order": "1134"
  },
  {
    "name": "vulcan",
    "unicode": "\u{1f596}",
    // "shortname": ":vulcan:",

    "category": "p",
    "emoji_order": "1140"
  },
  {
    "name": "the_horns",
    "unicode": "\u{1f918}",
    // "shortname": ":metal_tone2:",

    "category": "p",
    "emoji_order": "1146"
  },
  {
    "name": "call_me",
    "unicode": "\u{1f919}",
    // "shortname": ":call_me:",

    "category": "p",
    "emoji_order": "1152"
  },
  {
    "name": "raised_hand_with_fingers_splayed",
    "unicode": "\u{1f590}",
    // "shortname": ":hand_splayed:",

    "category": "p",
    "emoji_order": "1158"
  },
  {
    "name": "raised_hand",
    "unicode": "\u{270b}",
    // "shortname": ":raised_hand:",

    "category": "p",
    "emoji_order": "1164"
  },
  {
    "name": "ok_hand",
    "unicode": "\u{1f44c}",
    // "shortname": ":ok_hand:",

    "category": "p",
    "emoji_order": "1170"
  },
  {
    "name": "thumbsup",
    "unicode": "\u{1f44d}",
    // "shortname": ":thumbsup:",

    "category": "p",
    "emoji_order": "1176"
  },
  {
    "name": "thumbsdown",
    "unicode": "\u{1f44e}",
    // "shortname": ":thumbsdown:",

    "category": "p",
    "emoji_order": "1182"
  },
  {
    "name": "fist",
    "unicode": "\u{270a}",
    // "shortname": ":fist:",

    "category": "p",
    "emoji_order": "1188"
  },
  {
    "name": "facepunch",
    "unicode": "\u{1f44a}",
    // "shortname": ":punch:",

    "category": "p",
    "emoji_order": "1194"
  },
  {
    "name": "left_facing_fist",
    "unicode": "\u{1f91b}",
    // "shortname": ":left_facing_fist:",

    "category": "p",
    "emoji_order": "1200"
  },
  {
    "name": "right_facing_fist",
    "unicode": "\u{1f91c}",
    // "shortname": ":right_facing_fist:",

    "category": "p",
    "emoji_order": "1206"
  },
  {
    "name": "raised_back_of_hand",
    "unicode": "\u{1f91a}",
    // "shortname": ":raised_back_of_hand:",

    "category": "p",
    "emoji_order": "1212"
  },
  {
    "name": "wave",
    "unicode": "\u{1f44b}",
    // "shortname": ":wave:",

    "category": "p",
    "emoji_order": "1218"
  },
  {
    "name": "clap",
    "unicode": "\u{1f44f}",
    // "shortname": ":clap:",

    "category": "p",
    "emoji_order": "1224"
  },
  {
    "name": "writing_hand",
    "unicode": "\u{270d}",
    // "shortname": ":writing_hand:",

    "category": "p",
    "emoji_order": "1230"
  },
  {
    "name": "open_hands",
    "unicode": "\u{1f450}",
    // "shortname": ":open_hands:",

    "category": "p",
    "emoji_order": "1236"
  },
  {
    "name": "raised_hands",
    "unicode": "\u{1f64c}",
    // "shortname": ":raised_hands:",

    "category": "p",
    "emoji_order": "1242"
  },
  {
    "name": "pray",
    "unicode": "\u{1f64f}",
    // "shortname": ":pray:",

    "category": "p",
    "emoji_order": "1248"
  },
  {
    "name": "handshake",
    "unicode": "\u{1f91d}",
    // "shortname": ":handshake:",

    "category": "p",
    "emoji_order": "1254"
  },
  {
    "name": "nail_care",
    "unicode": "\u{1f485}",
    // "shortname": ":nail_care:",

    "category": "p",
    "emoji_order": "1260"
  },
  {
    "name": "ear",
    "unicode": "\u{1f442}",
    // "shortname": ":ear:",

    "category": "p",
    "emoji_order": "1266"
  },
  {
    "name": "nose",
    "unicode": "\u{1f443}",
    // "shortname": ":nose:",

    "category": "p",
    "emoji_order": "1272"
  },
  {
    "name": "footprints",
    "unicode": "\u{1f463}",
    // "shortname": ":footprints:",

    "category": "p",
    "emoji_order": "1278"
  },
  {
    "name": "eyes",
    "unicode": "\u{1f440}",
    // "shortname": ":eyes:",

    "category": "p",
    "emoji_order": "1279"
  },
  {
    "name": "eye",
    "unicode": "\u{1f441}",
    // "shortname": ":eye:",

    "category": "p",
    "emoji_order": "1280"
  },
  {
    "name": "tongue",
    "unicode": "\u{1f445}",
    // "shortname": ":tongue:",

    "category": "p",
    "emoji_order": "1282"
  },
  {
    "name": "lips",
    "unicode": "\u{1f444}",
    // "shortname": ":lips:",

    "category": "p",
    "emoji_order": "1283"
  },
  {
    "name": "kiss",
    "unicode": "\u{1f48b}",
    // "shortname": ":kiss:",

    "category": "p",
    "emoji_order": "1284"
  },
  {
    "name": "cupid",
    "unicode": "\u{1f498}",
    // "shortname": ":cupid:",

    "category": "s",
    "emoji_order": "1285"
  },
  {
    "name": "heart",
    "unicode": "\u{2764}",
    // "shortname": ":heart:",

    "category": "s",
    "emoji_order": "1286"
  },
  {
    "name": "heartbeat",
    "unicode": "\u{1f493}",
    // "shortname": ":heartbeat:",

    "category": "s",
    "emoji_order": "1287"
  },
  {
    "name": "broken_heart",
    "unicode": "\u{1f494}",
    // "shortname": ":broken_heart:",

    "category": "s",
    "emoji_order": "1288"
  },
  {
    "name": "two_hearts",
    "unicode": "\u{1f495}",
    // "shortname": ":two_hearts:",

    "category": "s",
    "emoji_order": "1289"
  },
  {
    "name": "sparkling_heart",
    "unicode": "\u{1f496}",
    // "shortname": ":sparkling_heart:",

    "category": "s",
    "emoji_order": "1290"
  },
  {
    "name": "heartpulse",
    "unicode": "\u{1f497}",
    // "shortname": ":heartpulse:",

    "category": "s",
    "emoji_order": "1291"
  },
  {
    "name": "blue_heart",
    "unicode": "\u{1f499}",
    // "shortname": ":blue_heart:",

    "category": "s",
    "emoji_order": "1292"
  },
  {
    "name": "green_heart",
    "unicode": "\u{1f49a}",
    // "shortname": ":green_heart:",

    "category": "s",
    "emoji_order": "1293"
  },
  {
    "name": "yellow_heart",
    "unicode": "\u{1f49b}",
    // "shortname": ":yellow_heart:",

    "category": "s",
    "emoji_order": "1294"
  },
  {
    "name": "purple_heart",
    "unicode": "\u{1f49c}",
    // "shortname": ":purple_heart:",

    "category": "s",
    "emoji_order": "1295"
  },
  {
    "name": "black_heart",
    "unicode": "\u{1f5a4}",
    // "shortname": ":black_heart:",

    "category": "s",
    "emoji_order": "1296"
  },
  {
    "name": "gift_heart",
    "unicode": "\u{1f49d}",
    // "shortname": ":gift_heart:",

    "category": "s",
    "emoji_order": "1297"
  },
  {
    "name": "revolving_hearts",
    "unicode": "\u{1f49e}",
    // "shortname": ":revolving_hearts:",

    "category": "s",
    "emoji_order": "1298"
  },
  {
    "name": "heart_decoration",
    "unicode": "\u{1f49f}",
    // "shortname": ":heart_decoration:",

    "category": "s",
    "emoji_order": "1299"
  },
  {
    "name": "heart_exclamation",
    "unicode": "\u{2763}",
    // "shortname": ":heart_exclamation:",

    "category": "s",
    "emoji_order": "1300"
  },
  {
    "name": "love_letter",
    "unicode": "\u{1f48c}",
    // "shortname": ":love_letter:",

    "category": "o",
    "emoji_order": "1301"
  },
  {
    "name": "zzz",
    "unicode": "\u{1f4a4}",
    // "shortname": ":zzz:",

    "category": "p",
    "emoji_order": "1302"
  },
  {
    "name": "anger",
    "unicode": "\u{1f4a2}",
    // "shortname": ":anger:",

    "category": "s",
    "emoji_order": "1303"
  },
  {
    "name": "bomb",
    "unicode": "\u{1f4a3}",
    // "shortname": ":bomb:",

    "category": "o",
    "emoji_order": "1304"
  },
  {
    "name": "boom",
    "unicode": "\u{1f4a5}",
    // "shortname": ":boom:",

    "category": "s",
    "emoji_order": "1305"
  },
  {
    "name": "sweat_drops",
    "unicode": "\u{1f4a6}",
    // "shortname": ":sweat_drops:",

    "category": "n",
    "emoji_order": "1306"
  },
  {
    "name": "dash",
    "unicode": "\u{1f4a8}",
    // "shortname": ":dash:",

    "category": "n",
    "emoji_order": "1307"
  },
  {
    "name": "dizzy",
    "unicode": "\u{1f4ab}",
    // "shortname": ":dizzy:",

    "category": "s",
    "emoji_order": "1308"
  },
  {
    "name": "speech_balloon",
    "unicode": "\u{1f4ac}",
    // "shortname": ":speech_balloon:",

    "category": "s",
    "emoji_order": "1309"
  },
  {
    "name": "left_speech_bubble",
    "unicode": "\u{1f5e8}",
    // "shortname": ":speech_left:",

    "category": "s",
    "emoji_order": "1310"
  },
  {
    "name": "right_anger_bubble",
    "unicode": "\u{1f5ef}",
    // "shortname": ":anger_right:",

    "category": "s",
    "emoji_order": "1311"
  },
  {
    "name": "thought_balloon",
    "unicode": "\u{1f4ad}",
    // "shortname": ":thought_balloon:",

    "category": "s",
    "emoji_order": "1312"
  },
  {
    "name": "hole",
    "unicode": "\u{1f573}",
    // "shortname": ":hole:",

    "category": "o",
    "emoji_order": "1313"
  },
  {
    "name": "eyeglasses",
    "unicode": "\u{1f453}",
    // "shortname": ":eyeglasses:",

    "category": "p",
    "emoji_order": "1314"
  },
  {
    "name": "dark_sunglasses",
    "unicode": "\u{1f576}",
    // "shortname": ":dark_sunglasses:",

    "category": "p",
    "emoji_order": "1315"
  },
  {
    "name": "necktie",
    "unicode": "\u{1f454}",
    // "shortname": ":necktie:",

    "category": "p",
    "emoji_order": "1316"
  },
  {
    "name": "shirt",
    "unicode": "\u{1f455}",
    // "shortname": ":shirt:",

    "category": "p",
    "emoji_order": "1317"
  },
  {
    "name": "jeans",
    "unicode": "\u{1f456}",
    // "shortname": ":jeans:",

    "category": "p",
    "emoji_order": "1318"
  },
  {
    "name": "dress",
    "unicode": "\u{1f457}",
    // "shortname": ":dress:",

    "category": "p",
    "emoji_order": "1319"
  },
  {
    "name": "kimono",
    "unicode": "\u{1f458}",
    // "shortname": ":kimono:",

    "category": "p",
    "emoji_order": "1320"
  },
  {
    "name": "bikini",
    "unicode": "\u{1f459}",
    // "shortname": ":bikini:",

    "category": "p",
    "emoji_order": "1321"
  },
  {
    "name": "womans_clothes",
    "unicode": "\u{1f45a}",
    // "shortname": ":womans_clothes:",

    "category": "p",
    "emoji_order": "1322"
  },
  {
    "name": "purse",
    "unicode": "\u{1f45b}",
    // "shortname": ":purse:",

    "category": "p",
    "emoji_order": "1323"
  },
  {
    "name": "handbag",
    "unicode": "\u{1f45c}",
    // "shortname": ":handbag:",

    "category": "p",
    "emoji_order": "1324"
  },
  {
    "name": "pouch",
    "unicode": "\u{1f45d}",
    // "shortname": ":pouch:",

    "category": "p",
    "emoji_order": "1325"
  },
  {
    "name": "shopping_bags",
    "unicode": "\u{1f6cd}",
    // "shortname": ":shopping_bags:",

    "category": "o",
    "emoji_order": "1326"
  },
  {
    "name": "school_satchel",
    "unicode": "\u{1f392}",
    // "shortname": ":school_satchel:",

    "category": "p",
    "emoji_order": "1327"
  },
  {
    "name": "mans_shoe",
    "unicode": "\u{1f45e}",
    // "shortname": ":mans_shoe:",

    "category": "p",
    "emoji_order": "1328"
  },
  {
    "name": "athletic_shoe",
    "unicode": "\u{1f45f}",
    // "shortname": ":athletic_shoe:",

    "category": "p",
    "emoji_order": "1329"
  },
  {
    "name": "high_heel",
    "unicode": "\u{1f460}",
    // "shortname": ":high_heel:",

    "category": "p",
    "emoji_order": "1330"
  },
  {
    "name": "sandal",
    "unicode": "\u{1f461}",
    // "shortname": ":sandal:",

    "category": "p",
    "emoji_order": "1331"
  },
  {
    "name": "boot",
    "unicode": "\u{1f462}",
    // "shortname": ":boot:",

    "category": "p",
    "emoji_order": "1332"
  },
  {
    "name": "crown",
    "unicode": "\u{1f451}",
    // "shortname": ":crown:",

    "category": "p",
    "emoji_order": "1333"
  },
  {
    "name": "womans_hat",
    "unicode": "\u{1f452}",
    // "shortname": ":womans_hat:",

    "category": "p",
    "emoji_order": "1334"
  },
  {
    "name": "tophat",
    "unicode": "\u{1f3a9}",
    // "shortname": ":tophat:",

    "category": "p",
    "emoji_order": "1335"
  },
  {
    "name": "mortar_board",
    "unicode": "\u{1f393}",
    // "shortname": ":mortar_board:",

    "category": "p",
    "emoji_order": "1336"
  },
  {
    "name": "helmet_with_white_cross",
    "unicode": "\u{26d1}",
    // "shortname": ":helmet_with_cross:",

    "category": "p",
    "emoji_order": "1337"
  },
  {
    "name": "prayer_beads",
    "unicode": "\u{1f4ff}",
    // "shortname": ":prayer_beads:",

    "category": "o",
    "emoji_order": "1338"
  },
  {
    "name": "lipstick",
    "unicode": "\u{1f484}",
    // "shortname": ":lipstick:",

    "category": "p",
    "emoji_order": "1339"
  },
  {
    "name": "ring",
    "unicode": "\u{1f48d}",
    // "shortname": ":ring:",

    "category": "p",
    "emoji_order": "1340"
  },
  {
    "name": "gem",
    "unicode": "\u{1f48e}",
    // "shortname": ":gem:",

    "category": "o",
    "emoji_order": "1341"
  },
  {
    "name": "monkey_face",
    "unicode": "\u{1f435}",
    // "shortname": ":monkey_face:",

    "category": "n",
    "emoji_order": "1342"
  },
  {
    "name": "monkey",
    "unicode": "\u{1f412}",
    // "shortname": ":monkey:",

    "category": "n",
    "emoji_order": "1343"
  },
  {
    "name": "gorilla",
    "unicode": "\u{1f98d}",
    // "shortname": ":gorilla:",

    "category": "n",
    "emoji_order": "1344"
  },
  {
    "name": "dog",
    "unicode": "\u{1f436}",
    // "shortname": ":dog:",

    "category": "n",
    "emoji_order": "1345"
  },
  {
    "name": "dog2",
    "unicode": "\u{1f415}",
    // "shortname": ":dog2:",

    "category": "n",
    "emoji_order": "1346"
  },
  {
    "name": "poodle",
    "unicode": "\u{1f429}",
    // "shortname": ":poodle:",

    "category": "n",
    "emoji_order": "1347"
  },
  {
    "name": "wolf",
    "unicode": "\u{1f43a}",
    // "shortname": ":wolf:",

    "category": "n",
    "emoji_order": "1348"
  },
  {
    "name": "fox",
    "unicode": "\u{1f98a}",
    // "shortname": ":fox:",

    "category": "n",
    "emoji_order": "1349"
  },
  {
    "name": "cat",
    "unicode": "\u{1f431}",
    // "shortname": ":cat:",

    "category": "n",
    "emoji_order": "1350"
  },
  {
    "name": "cat2",
    "unicode": "\u{1f408}",
    // "shortname": ":cat2:",

    "category": "n",
    "emoji_order": "1351"
  },
  {
    "name": "lion_face",
    "unicode": "\u{1f981}",
    // "shortname": ":lion_face:",

    "category": "n",
    "emoji_order": "1352"
  },
  {
    "name": "tiger",
    "unicode": "\u{1f42f}",
    // "shortname": ":tiger:",

    "category": "n",
    "emoji_order": "1353"
  },
  {
    "name": "tiger2",
    "unicode": "\u{1f405}",
    // "shortname": ":tiger2:",

    "category": "n",
    "emoji_order": "1354"
  },
  {
    "name": "leopard",
    "unicode": "\u{1f406}",
    // "shortname": ":leopard:",

    "category": "n",
    "emoji_order": "1355"
  },
  {
    "name": "horse",
    "unicode": "\u{1f434}",
    // "shortname": ":horse:",

    "category": "n",
    "emoji_order": "1356"
  },
  {
    "name": "racehorse",
    "unicode": "\u{1f40e}",
    // "shortname": ":racehorse:",

    "category": "n",
    "emoji_order": "1357"
  },
  {
    "name": "deer",
    "unicode": "\u{1f98c}",
    // "shortname": ":deer:",

    "category": "n",
    "emoji_order": "1358"
  },
  {
    "name": "unicorn_face",
    "unicode": "\u{1f984}",
    // "shortname": ":unicorn:",

    "category": "n",
    "emoji_order": "1359"
  },
  {
    "name": "cow",
    "unicode": "\u{1f42e}",
    // "shortname": ":cow:",

    "category": "n",
    "emoji_order": "1360"
  },
  {
    "name": "ox",
    "unicode": "\u{1f402}",
    // "shortname": ":ox:",

    "category": "n",
    "emoji_order": "1361"
  },
  {
    "name": "water_buffalo",
    "unicode": "\u{1f403}",
    // "shortname": ":water_buffalo:",

    "category": "n",
    "emoji_order": "1362"
  },
  {
    "name": "cow2",
    "unicode": "\u{1f404}",
    // "shortname": ":cow2:",

    "category": "n",
    "emoji_order": "1363"
  },
  {
    "name": "pig",
    "unicode": "\u{1f437}",
    // "shortname": ":pig:",

    "category": "n",
    "emoji_order": "1364"
  },
  {
    "name": "pig2",
    "unicode": "\u{1f416}",
    // "shortname": ":pig2:",

    "category": "n",
    "emoji_order": "1365"
  },
  {
    "name": "boar",
    "unicode": "\u{1f417}",
    // "shortname": ":boar:",

    "category": "n",
    "emoji_order": "1366"
  },
  {
    "name": "pig_nose",
    "unicode": "\u{1f43d}",
    // "shortname": ":pig_nose:",

    "category": "n",
    "emoji_order": "1367"
  },
  {
    "name": "ram",
    "unicode": "\u{1f40f}",
    // "shortname": ":ram:",

    "category": "n",
    "emoji_order": "1368"
  },
  {
    "name": "sheep",
    "unicode": "\u{1f411}",
    // "shortname": ":sheep:",

    "category": "n",
    "emoji_order": "1369"
  },
  {
    "name": "goat",
    "unicode": "\u{1f410}",
    // "shortname": ":goat:",

    "category": "n",
    "emoji_order": "1370"
  },
  {
    "name": "dromedary_camel",
    "unicode": "\u{1f42a}",
    // "shortname": ":dromedary_camel:",

    "category": "n",
    "emoji_order": "1371"
  },
  {
    "name": "camel",
    "unicode": "\u{1f42b}",
    // "shortname": ":camel:",

    "category": "n",
    "emoji_order": "1372"
  },
  {
    "name": "elephant",
    "unicode": "\u{1f418}",
    // "shortname": ":elephant:",

    "category": "n",
    "emoji_order": "1373"
  },
  {
    "name": "rhino",
    "unicode": "\u{1f98f}",
    // "shortname": ":rhino:",

    "category": "n",
    "emoji_order": "1374"
  },
  {
    "name": "mouse",
    "unicode": "\u{1f42d}",
    // "shortname": ":mouse:",

    "category": "n",
    "emoji_order": "1375"
  },
  {
    "name": "mouse2",
    "unicode": "\u{1f401}",
    // "shortname": ":mouse2:",

    "category": "n",
    "emoji_order": "1376"
  },
  {
    "name": "rat",
    "unicode": "\u{1f400}",
    // "shortname": ":rat:",

    "category": "n",
    "emoji_order": "1377"
  },
  {
    "name": "hamster",
    "unicode": "\u{1f439}",
    // "shortname": ":hamster:",

    "category": "n",
    "emoji_order": "1378"
  },
  {
    "name": "rabbit",
    "unicode": "\u{1f430}",
    // "shortname": ":rabbit:",

    "category": "n",
    "emoji_order": "1379"
  },
  {
    "name": "rabbit2",
    "unicode": "\u{1f407}",
    // "shortname": ":rabbit2:",

    "category": "n",
    "emoji_order": "1380"
  },
  {
    "name": "chipmunk",
    "unicode": "\u{1f43f}",
    // "shortname": ":chipmunk:",

    "category": "n",
    "emoji_order": "1381"
  },
  {
    "name": "bat",
    "unicode": "\u{1f987}",
    // "shortname": ":bat:",

    "category": "n",
    "emoji_order": "1382"
  },
  {
    "name": "bear",
    "unicode": "\u{1f43b}",
    // "shortname": ":bear:",

    "category": "n",
    "emoji_order": "1383"
  },
  {
    "name": "koala",
    "unicode": "\u{1f428}",
    // "shortname": ":koala:",

    "category": "n",
    "emoji_order": "1384"
  },
  {
    "name": "panda_face",
    "unicode": "\u{1f43c}",
    // "shortname": ":panda_face:",

    "category": "n",
    "emoji_order": "1385"
  },
  {
    "name": "feet",
    "unicode": "\u{1f43e}",
    // "shortname": ":feet:",

    "category": "n",
    "emoji_order": "1386"
  },
  {
    "name": "turkey",
    "unicode": "\u{1f983}",
    // "shortname": ":turkey:",

    "category": "n",
    "emoji_order": "1387"
  },
  {
    "name": "chicken",
    "unicode": "\u{1f414}",
    // "shortname": ":chicken:",

    "category": "n",
    "emoji_order": "1388"
  },
  {
    "name": "rooster",
    "unicode": "\u{1f413}",
    // "shortname": ":rooster:",

    "category": "n",
    "emoji_order": "1389"
  },
  {
    "name": "hatching_chick",
    "unicode": "\u{1f423}",
    // "shortname": ":hatching_chick:",

    "category": "n",
    "emoji_order": "1390"
  },
  {
    "name": "baby_chick",
    "unicode": "\u{1f424}",
    // "shortname": ":baby_chick:",

    "category": "n",
    "emoji_order": "1391"
  },
  {
    "name": "hatched_chick",
    "unicode": "\u{1f425}",
    // "shortname": ":hatched_chick:",

    "category": "n",
    "emoji_order": "1392"
  },
  {
    "name": "bird",
    "unicode": "\u{1f426}",
    // "shortname": ":bird:",

    "category": "n",
    "emoji_order": "1393"
  },
  {
    "name": "penguin",
    "unicode": "\u{1f427}",
    // "shortname": ":penguin:",

    "category": "n",
    "emoji_order": "1394"
  },
  {
    "name": "dove_of_peace",
    "unicode": "\u{1f54a}",
    // "shortname": ":dove:",

    "category": "n",
    "emoji_order": "1395"
  },
  {
    "name": "eagle",
    "unicode": "\u{1f985}",
    // "shortname": ":eagle:",

    "category": "n",
    "emoji_order": "1396"
  },
  {
    "name": "duck",
    "unicode": "\u{1f986}",
    // "shortname": ":duck:",

    "category": "n",
    "emoji_order": "1397"
  },
  {
    "name": "owl",
    "unicode": "\u{1f989}",
    // "shortname": ":owl:",

    "category": "n",
    "emoji_order": "1398"
  },
  {
    "name": "frog",
    "unicode": "\u{1f438}",
    // "shortname": ":frog:",

    "category": "n",
    "emoji_order": "1399"
  },
  {
    "name": "crocodile",
    "unicode": "\u{1f40a}",
    // "shortname": ":crocodile:",

    "category": "n",
    "emoji_order": "1400"
  },
  {
    "name": "turtle",
    "unicode": "\u{1f422}",
    // "shortname": ":turtle:",

    "category": "n",
    "emoji_order": "1401"
  },
  {
    "name": "lizard",
    "unicode": "\u{1f98e}",
    // "shortname": ":lizard:",

    "category": "n",
    "emoji_order": "1402"
  },
  {
    "name": "snake",
    "unicode": "\u{1f40d}",
    // "shortname": ":snake:",

    "category": "n",
    "emoji_order": "1403"
  },
  {
    "name": "dragon_face",
    "unicode": "\u{1f432}",
    // "shortname": ":dragon_face:",

    "category": "n",
    "emoji_order": "1404"
  },
  {
    "name": "dragon",
    "unicode": "\u{1f409}",
    // "shortname": ":dragon:",

    "category": "n",
    "emoji_order": "1405"
  },
  {
    "name": "whale",
    "unicode": "\u{1f433}",
    // "shortname": ":whale:",

    "category": "n",
    "emoji_order": "1406"
  },
  {
    "name": "whale2",
    "unicode": "\u{1f40b}",
    // "shortname": ":whale2:",

    "category": "n",
    "emoji_order": "1407"
  },
  {
    "name": "dolphin",
    "unicode": "\u{1f42c}",
    // "shortname": ":dolphin:",

    "category": "n",
    "emoji_order": "1408"
  },
  {
    "name": "fish",
    "unicode": "\u{1f41f}",
    // "shortname": ":fish:",

    "category": "n",
    "emoji_order": "1409"
  },
  {
    "name": "tropical_fish",
    "unicode": "\u{1f420}",
    // "shortname": ":tropical_fish:",

    "category": "n",
    "emoji_order": "1410"
  },
  {
    "name": "blowfish",
    "unicode": "\u{1f421}",
    // "shortname": ":blowfish:",

    "category": "n",
    "emoji_order": "1411"
  },
  {
    "name": "shark",
    "unicode": "\u{1f988}",
    // "shortname": ":shark:",

    "category": "n",
    "emoji_order": "1412"
  },
  {
    "name": "octopus",
    "unicode": "\u{1f419}",
    // "shortname": ":octopus:",

    "category": "n",
    "emoji_order": "1413"
  },
  {
    "name": "shell",
    "unicode": "\u{1f41a}",
    // "shortname": ":shell:",

    "category": "n",
    "emoji_order": "1414"
  },
  {
    "name": "crab",
    "unicode": "\u{1f980}",
    // "shortname": ":crab:",

    "category": "n",
    "emoji_order": "1415"
  },
  {
    "name": "shrimp",
    "unicode": "\u{1f990}",
    // "shortname": ":shrimp:",

    "category": "n",
    "emoji_order": "1416"
  },
  {
    "name": "squid",
    "unicode": "\u{1f991}",
    // "shortname": ":squid:",

    "category": "n",
    "emoji_order": "1417"
  },
  {
    "name": "butterfly",
    "unicode": "\u{1f98b}",
    // "shortname": ":butterfly:",

    "category": "n",
    "emoji_order": "1418"
  },
  {
    "name": "snail",
    "unicode": "\u{1f40c}",
    // "shortname": ":snail:",

    "category": "n",
    "emoji_order": "1419"
  },
  {
    "name": "bug",
    "unicode": "\u{1f41b}",
    // "shortname": ":bug:",

    "category": "n",
    "emoji_order": "1420"
  },
  {
    "name": "ant",
    "unicode": "\u{1f41c}",
    // "shortname": ":ant:",

    "category": "n",
    "emoji_order": "1421"
  },
  {
    "name": "bee",
    "unicode": "\u{1f41d}",
    // "shortname": ":bee:",

    "category": "n",
    "emoji_order": "1422"
  },
  {
    "name": "beetle",
    "unicode": "\u{1f41e}",
    // "shortname": ":beetle:",

    "category": "n",
    "emoji_order": "1423"
  },
  {
    "name": "spider",
    "unicode": "\u{1f577}",
    // "shortname": ":spider:",

    "category": "n",
    "emoji_order": "1424"
  },
  {
    "name": "spider_web",
    "unicode": "\u{1f578}",
    // "shortname": ":spider_web:",

    "category": "n",
    "emoji_order": "1425"
  },
  {
    "name": "scorpion",
    "unicode": "\u{1f982}",
    // "shortname": ":scorpion:",

    "category": "n",
    "emoji_order": "1426"
  },
  {
    "name": "bouquet",
    "unicode": "\u{1f490}",
    // "shortname": ":bouquet:",

    "category": "n",
    "emoji_order": "1427"
  },
  {
    "name": "cherry_blossom",
    "unicode": "\u{1f338}",
    // "shortname": ":cherry_blossom:",

    "category": "n",
    "emoji_order": "1428"
  },
  {
    "name": "white_flower",
    "unicode": "\u{1f4ae}",
    // "shortname": ":white_flower:",

    "category": "s",
    "emoji_order": "1429"
  },
  {
    "name": "rosette",
    "unicode": "\u{1f3f5}",
    // "shortname": ":rosette:",

    "category": "n",
    "emoji_order": "1430"
  },
  {
    "name": "rose",
    "unicode": "\u{1f339}",
    // "shortname": ":rose:",

    "category": "n",
    "emoji_order": "1431"
  },
  {
    "name": "wilted_rose",
    "unicode": "\u{1f940}",
    // "shortname": ":wilted_rose:",

    "category": "n",
    "emoji_order": "1432"
  },
  {
    "name": "hibiscus",
    "unicode": "\u{1f33a}",
    // "shortname": ":hibiscus:",

    "category": "n",
    "emoji_order": "1433"
  },
  {
    "name": "sunflower",
    "unicode": "\u{1f33b}",
    // "shortname": ":sunflower:",

    "category": "n",
    "emoji_order": "1434"
  },
  {
    "name": "blossom",
    "unicode": "\u{1f33c}",
    // "shortname": ":blossom:",

    "category": "n",
    "emoji_order": "1435"
  },
  {
    "name": "tulip",
    "unicode": "\u{1f337}",
    // "shortname": ":tulip:",

    "category": "n",
    "emoji_order": "1436"
  },
  {
    "name": "seedling",
    "unicode": "\u{1f331}",
    // "shortname": ":seedling:",

    "category": "n",
    "emoji_order": "1437"
  },
  {
    "name": "evergreen_tree",
    "unicode": "\u{1f332}",
    // "shortname": ":evergreen_tree:",

    "category": "n",
    "emoji_order": "1438"
  },
  {
    "name": "deciduous_tree",
    "unicode": "\u{1f333}",
    // "shortname": ":deciduous_tree:",

    "category": "n",
    "emoji_order": "1439"
  },
  {
    "name": "palm_tree",
    "unicode": "\u{1f334}",
    // "shortname": ":palm_tree:",

    "category": "n",
    "emoji_order": "1440"
  },
  {
    "name": "cactus",
    "unicode": "\u{1f335}",
    // "shortname": ":cactus:",

    "category": "n",
    "emoji_order": "1441"
  },
  {
    "name": "ear_of_rice",
    "unicode": "\u{1f33e}",
    // "shortname": ":ear_of_rice:",

    "category": "n",
    "emoji_order": "1442"
  },
  {
    "name": "herb",
    "unicode": "\u{1f33f}",
    // "shortname": ":herb:",

    "category": "n",
    "emoji_order": "1443"
  },
  {
    "name": "shamrock",
    "unicode": "\u{2618}",
    // "shortname": ":shamrock:",

    "category": "n",
    "emoji_order": "1444"
  },
  {
    "name": "four_leaf_clover",
    "unicode": "\u{1f340}",
    // "shortname": ":four_leaf_clover:",

    "category": "n",
    "emoji_order": "1445"
  },
  {
    "name": "maple_leaf",
    "unicode": "\u{1f341}",
    // "shortname": ":maple_leaf:",

    "category": "n",
    "emoji_order": "1446"
  },
  {
    "name": "fallen_leaf",
    "unicode": "\u{1f342}",
    // "shortname": ":fallen_leaf:",

    "category": "n",
    "emoji_order": "1447"
  },
  {
    "name": "leaves",
    "unicode": "\u{1f343}",
    // "shortname": ":leaves:",

    "category": "n",
    "emoji_order": "1448"
  },
  {
    "name": "grapes",
    "unicode": "\u{1f347}",
    // "shortname": ":grapes:",

    "category": "d",
    "emoji_order": "1449"
  },
  {
    "name": "melon",
    "unicode": "\u{1f348}",
    // "shortname": ":melon:",

    "category": "d",
    "emoji_order": "1450"
  },
  {
    "name": "watermelon",
    "unicode": "\u{1f349}",
    // "shortname": ":watermelon:",

    "category": "d",
    "emoji_order": "1451"
  },
  {
    "name": "tangerine",
    "unicode": "\u{1f34a}",
    // "shortname": ":tangerine:",

    "category": "d",
    "emoji_order": "1452"
  },
  {
    "name": "lemon",
    "unicode": "\u{1f34b}",
    // "shortname": ":lemon:",

    "category": "d",
    "emoji_order": "1453"
  },
  {
    "name": "banana",
    "unicode": "\u{1f34c}",
    // "shortname": ":banana:",

    "category": "d",
    "emoji_order": "1454"
  },
  {
    "name": "pineapple",
    "unicode": "\u{1f34d}",
    // "shortname": ":pineapple:",

    "category": "d",
    "emoji_order": "1455"
  },
  {
    "name": "apple",
    "unicode": "\u{1f34e}",
    // "shortname": ":apple:",

    "category": "d",
    "emoji_order": "1456"
  },
  {
    "name": "green_apple",
    "unicode": "\u{1f34f}",
    // "shortname": ":green_apple:",

    "category": "d",
    "emoji_order": "1457"
  },
  {
    "name": "pear",
    "unicode": "\u{1f350}",
    // "shortname": ":pear:",

    "category": "d",
    "emoji_order": "1458"
  },
  {
    "name": "peach",
    "unicode": "\u{1f351}",
    // "shortname": ":peach:",

    "category": "d",
    "emoji_order": "1459"
  },
  {
    "name": "cherries",
    "unicode": "\u{1f352}",
    // "shortname": ":cherries:",

    "category": "d",
    "emoji_order": "1460"
  },
  {
    "name": "strawberry",
    "unicode": "\u{1f353}",
    // "shortname": ":strawberry:",

    "category": "d",
    "emoji_order": "1461"
  },
  {
    "name": "kiwi",
    "unicode": "\u{1f95d}",
    // "shortname": ":kiwi:",

    "category": "d",
    "emoji_order": "1462"
  },
  {
    "name": "tomato",
    "unicode": "\u{1f345}",
    // "shortname": ":tomato:",

    "category": "d",
    "emoji_order": "1463"
  },
  {
    "name": "avocado",
    "unicode": "\u{1f951}",
    // "shortname": ":avocado:",

    "category": "d",
    "emoji_order": "1464"
  },
  {
    "name": "eggplant",
    "unicode": "\u{1f346}",
    // "shortname": ":eggplant:",

    "category": "d",
    "emoji_order": "1465"
  },
  {
    "name": "potato",
    "unicode": "\u{1f954}",
    // "shortname": ":potato:",

    "category": "d",
    "emoji_order": "1466"
  },
  {
    "name": "carrot",
    "unicode": "\u{1f955}",
    // "shortname": ":carrot:",

    "category": "d",
    "emoji_order": "1467"
  },
  {
    "name": "corn",
    "unicode": "\u{1f33d}",
    // "shortname": ":corn:",

    "category": "d",
    "emoji_order": "1468"
  },
  {
    "name": "hot_pepper",
    "unicode": "\u{1f336}",
    // "shortname": ":hot_pepper:",

    "category": "d",
    "emoji_order": "1469"
  },
  {
    "name": "cucumber",
    "unicode": "\u{1f952}",
    // "shortname": ":cucumber:",

    "category": "d",
    "emoji_order": "1470"
  },
  {
    "name": "mushroom",
    "unicode": "\u{1f344}",
    // "shortname": ":mushroom:",

    "category": "n",
    "emoji_order": "1471"
  },
  {
    "name": "peanuts",
    "unicode": "\u{1f95c}",
    // "shortname": ":peanuts:",

    "category": "d",
    "emoji_order": "1472"
  },
  {
    "name": "chestnut",
    "unicode": "\u{1f330}",
    // "shortname": ":chestnut:",

    "category": "n",
    "emoji_order": "1473"
  },
  {
    "name": "bread",
    "unicode": "\u{1f35e}",
    // "shortname": ":bread:",

    "category": "d",
    "emoji_order": "1474"
  },
  {
    "name": "croissant",
    "unicode": "\u{1f950}",
    // "shortname": ":croissant:",

    "category": "d",
    "emoji_order": "1475"
  },
  {
    "name": "french_bread",
    "unicode": "\u{1f956}",
    // "shortname": ":french_bread:",

    "category": "d",
    "emoji_order": "1476"
  },
  {
    "name": "pancakes",
    "unicode": "\u{1f95e}",
    // "shortname": ":pancakes:",

    "category": "d",
    "emoji_order": "1477"
  },
  {
    "name": "cheese_wedge",
    "unicode": "\u{1f9c0}",
    // "shortname": ":cheese:",

    "category": "d",
    "emoji_order": "1478"
  },
  {
    "name": "meat_on_bone",
    "unicode": "\u{1f356}",
    // "shortname": ":meat_on_bone:",

    "category": "d",
    "emoji_order": "1479"
  },
  {
    "name": "poultry_leg",
    "unicode": "\u{1f357}",
    // "shortname": ":poultry_leg:",

    "category": "d",
    "emoji_order": "1480"
  },
  {
    "name": "bacon",
    "unicode": "\u{1f953}",
    // "shortname": ":bacon:",

    "category": "d",
    "emoji_order": "1481"
  },
  {
    "name": "hamburger",
    "unicode": "\u{1f354}",
    // "shortname": ":hamburger:",

    "category": "d",
    "emoji_order": "1482"
  },
  {
    "name": "fries",
    "unicode": "\u{1f35f}",
    // "shortname": ":fries:",

    "category": "d",
    "emoji_order": "1483"
  },
  {
    "name": "pizza",
    "unicode": "\u{1f355}",
    // "shortname": ":pizza:",

    "category": "d",
    "emoji_order": "1484"
  },
  {
    "name": "hotdog",
    "unicode": "\u{1f32d}",
    // "shortname": ":hotdog:",

    "category": "d",
    "emoji_order": "1485"
  },
  {
    "name": "taco",
    "unicode": "\u{1f32e}",
    // "shortname": ":taco:",

    "category": "d",
    "emoji_order": "1486"
  },
  {
    "name": "burrito",
    "unicode": "\u{1f32f}",
    // "shortname": ":burrito:",

    "category": "d",
    "emoji_order": "1487"
  },
  {
    "name": "stuffed_flatbread",
    "unicode": "\u{1f959}",
    // "shortname": ":stuffed_flatbread:",

    "category": "d",
    "emoji_order": "1488"
  },
  {
    "name": "egg",
    "unicode": "\u{1f95a}",
    // "shortname": ":egg:",

    "category": "d",
    "emoji_order": "1489"
  },
  {
    "name": "cooking",
    "unicode": "\u{1f373}",
    // "shortname": ":cooking:",

    "category": "d",
    "emoji_order": "1490"
  },
  {
    "name": "shallow_pan_of_f",
    "unicode": "\u{1f958}",
    // "shortname": ":shallow_pan_of_f:",

    "category": "d",
    "emoji_order": "1491"
  },
  {
    "name": "stew",
    "unicode": "\u{1f372}",
    // "shortname": ":stew:",

    "category": "d",
    "emoji_order": "1492"
  },
  {
    "name": "salad",
    "unicode": "\u{1f957}",
    // "shortname": ":salad:",

    "category": "d",
    "emoji_order": "1493"
  },
  {
    "name": "popcorn",
    "unicode": "\u{1f37f}",
    // "shortname": ":popcorn:",

    "category": "d",
    "emoji_order": "1494"
  },
  {
    "name": "bento",
    "unicode": "\u{1f371}",
    // "shortname": ":bento:",

    "category": "d",
    "emoji_order": "1495"
  },
  {
    "name": "rice_cracker",
    "unicode": "\u{1f358}",
    // "shortname": ":rice_cracker:",

    "category": "d",
    "emoji_order": "1496"
  },
  {
    "name": "rice_ball",
    "unicode": "\u{1f359}",
    // "shortname": ":rice_ball:",

    "category": "d",
    "emoji_order": "1497"
  },
  {
    "name": "rice",
    "unicode": "\u{1f35a}",
    // "shortname": ":rice:",

    "category": "d",
    "emoji_order": "1498"
  },
  {
    "name": "curry",
    "unicode": "\u{1f35b}",
    // "shortname": ":curry:",

    "category": "d",
    "emoji_order": "1499"
  },
  {
    "name": "ramen",
    "unicode": "\u{1f35c}",
    // "shortname": ":ramen:",

    "category": "d",
    "emoji_order": "1500"
  },
  {
    "name": "spaghetti",
    "unicode": "\u{1f35d}",
    // "shortname": ":spaghetti:",

    "category": "d",
    "emoji_order": "1501"
  },
  {
    "name": "sweet_potato",
    "unicode": "\u{1f360}",
    // "shortname": ":sweet_potato:",

    "category": "d",
    "emoji_order": "1502"
  },
  {
    "name": "oden",
    "unicode": "\u{1f362}",
    // "shortname": ":oden:",

    "category": "d",
    "emoji_order": "1503"
  },
  {
    "name": "sushi",
    "unicode": "\u{1f363}",
    // "shortname": ":sushi:",

    "category": "d",
    "emoji_order": "1504"
  },
  {
    "name": "fried_shrimp",
    "unicode": "\u{1f364}",
    // "shortname": ":fried_shrimp:",

    "category": "d",
    "emoji_order": "1505"
  },
  {
    "name": "fish_cake",
    "unicode": "\u{1f365}",
    // "shortname": ":fish_cake:",

    "category": "d",
    "emoji_order": "1506"
  },
  {
    "name": "dango",
    "unicode": "\u{1f361}",
    // "shortname": ":dango:",

    "category": "d",
    "emoji_order": "1507"
  },
  {
    "name": "icecream",
    "unicode": "\u{1f366}",
    // "shortname": ":icecream:",

    "category": "d",
    "emoji_order": "1508"
  },
  {
    "name": "shaved_ice",
    "unicode": "\u{1f367}",
    // "shortname": ":shaved_ice:",

    "category": "d",
    "emoji_order": "1509"
  },
  {
    "name": "ice_cream",
    "unicode": "\u{1f368}",
    // "shortname": ":ice_cream:",

    "category": "d",
    "emoji_order": "1510"
  },
  {
    "name": "doughnut",
    "unicode": "\u{1f369}",
    // "shortname": ":doughnut:",

    "category": "d",
    "emoji_order": "1511"
  },
  {
    "name": "cookie",
    "unicode": "\u{1f36a}",
    // "shortname": ":cookie:",

    "category": "d",
    "emoji_order": "1512"
  },
  {
    "name": "birthday",
    "unicode": "\u{1f382}",
    // "shortname": ":birthday:",

    "category": "d",
    "emoji_order": "1513"
  },
  {
    "name": "cake",
    "unicode": "\u{1f370}",
    // "shortname": ":cake:",

    "category": "d",
    "emoji_order": "1514"
  },
  {
    "name": "chocolate_bar",
    "unicode": "\u{1f36b}",
    // "shortname": ":chocolate_bar:",

    "category": "d",
    "emoji_order": "1515"
  },
  {
    "name": "candy",
    "unicode": "\u{1f36c}",
    // "shortname": ":candy:",

    "category": "d",
    "emoji_order": "1516"
  },
  {
    "name": "lollipop",
    "unicode": "\u{1f36d}",
    // "shortname": ":lollipop:",

    "category": "d",
    "emoji_order": "1517"
  },
  {
    "name": "custard",
    "unicode": "\u{1f36e}",
    // "shortname": ":custard:",

    "category": "d",
    "emoji_order": "1518"
  },
  {
    "name": "honey_pot",
    "unicode": "\u{1f36f}",
    // "shortname": ":honey_pot:",

    "category": "d",
    "emoji_order": "1519"
  },
  {
    "name": "baby_bottle",
    "unicode": "\u{1f37c}",
    // "shortname": ":baby_bottle:",

    "category": "d",
    "emoji_order": "1520"
  },
  {
    "name": "milk",
    "unicode": "\u{1f95b}",
    // "shortname": ":milk:",

    "category": "d",
    "emoji_order": "1521"
  },
  {
    "name": "coffee",
    "unicode": "\u{2615}",
    // "shortname": ":coffee:",

    "category": "d",
    "emoji_order": "1522"
  },
  {
    "name": "tea",
    "unicode": "\u{1f375}",
    // "shortname": ":tea:",

    "category": "d",
    "emoji_order": "1523"
  },
  {
    "name": "sake",
    "unicode": "\u{1f376}",
    // "shortname": ":sake:",

    "category": "d",
    "emoji_order": "1524"
  },
  {
    "name": "champagne",
    "unicode": "\u{1f37e}",
    // "shortname": ":champagne:",

    "category": "d",
    "emoji_order": "1525"
  },
  {
    "name": "wine_glass",
    "unicode": "\u{1f377}",
    // "shortname": ":wine_glass:",

    "category": "d",
    "emoji_order": "1526"
  },
  {
    "name": "cocktail",
    "unicode": "\u{1f378}",
    // "shortname": ":cocktail:",

    "category": "d",
    "emoji_order": "1527"
  },
  {
    "name": "tropical_drink",
    "unicode": "\u{1f379}",
    // "shortname": ":tropical_drink:",

    "category": "d",
    "emoji_order": "1528"
  },
  {
    "name": "beer",
    "unicode": "\u{1f37a}",
    // "shortname": ":beer:",

    "category": "d",
    "emoji_order": "1529"
  },
  {
    "name": "beers",
    "unicode": "\u{1f37b}",
    // "shortname": ":beers:",

    "category": "d",
    "emoji_order": "1530"
  },
  {
    "name": "champagne_glass",
    "unicode": "\u{1f942}",
    // "shortname": ":champagne_glass:",

    "category": "d",
    "emoji_order": "1531"
  },
  {
    "name": "tumbler_glass",
    "unicode": "\u{1f943}",
    // "shortname": ":tumbler_glass:",

    "category": "d",
    "emoji_order": "1532"
  },
  {
    "name": "knife_fork_plate",
    "unicode": "\u{1f37d}",
    // "shortname": ":fork_knife_plate:",

    "category": "d",
    "emoji_order": "1533"
  },
  {
    "name": "fork_and_knife",
    "unicode": "\u{1f374}",
    // "shortname": ":fork_and_knife:",

    "category": "d",
    "emoji_order": "1534"
  },
  {
    "name": "spoon",
    "unicode": "\u{1f944}",
    // "shortname": ":spoon:",

    "category": "d",
    "emoji_order": "1535"
  },
  {
    "name": "knife",
    "unicode": "\u{1f52a}",
    // "shortname": ":knife:",

    "category": "o",
    "emoji_order": "1536"
  },
  {
    "name": "amphora",
    "unicode": "\u{1f3fa}",
    // "shortname": ":amphora:",

    "category": "o",
    "emoji_order": "1537"
  },
  {
    "name": "earth_africa",
    "unicode": "\u{1f30d}",
    // "shortname": ":earth_africa:",

    "category": "n",
    "emoji_order": "1538"
  },
  {
    "name": "earth_americas",
    "unicode": "\u{1f30e}",
    // "shortname": ":earth_americas:",

    "category": "n",
    "emoji_order": "1539"
  },
  {
    "name": "earth_asia",
    "unicode": "\u{1f30f}",
    // "shortname": ":earth_asia:",

    "category": "n",
    "emoji_order": "1540"
  },
  {
    "name": "globe_with_meridians",
    "unicode": "\u{1f310}",
    // "shortname": ":globe_with_meridians:",

    "category": "s",
    "emoji_order": "1541"
  },
  {
    "name": "world_map",
    "unicode": "\u{1f5fa}",
    // "shortname": ":map:",

    "category": "o",
    "emoji_order": "1542"
  },
  {
    "name": "japan",
    "unicode": "\u{1f5fe}",
    // "shortname": ":japan:",

    "category": "t",
    "emoji_order": "1543"
  },
  {
    "name": "snow_capped_mountain",
    "unicode": "\u{1f3d4}",
    // "shortname": ":mountain_snow:",

    "category": "t",
    "emoji_order": "1544"
  },
  {
    "name": "mountain",
    "unicode": "\u{26f0}",
    // "shortname": ":mountain:",

    "category": "t",
    "emoji_order": "1545"
  },
  {
    "name": "volcano",
    "unicode": "\u{1f30b}",
    // "shortname": ":volcano:",

    "category": "t",
    "emoji_order": "1546"
  },
  {
    "name": "mount_fuji",
    "unicode": "\u{1f5fb}",
    // "shortname": ":mount_fuji:",

    "category": "t",
    "emoji_order": "1547"
  },
  {
    "name": "camping",
    "unicode": "\u{1f3d5}",
    // "shortname": ":camping:",

    "category": "t",
    "emoji_order": "1548"
  },
  {
    "name": "beach_with_umbrella",
    "unicode": "\u{1f3d6}",
    // "shortname": ":beach:",

    "category": "t",
    "emoji_order": "1549"
  },
  {
    "name": "desert",
    "unicode": "\u{1f3dc}",
    // "shortname": ":desert:",

    "category": "t",
    "emoji_order": "1550"
  },
  {
    "name": "desert_island",
    "unicode": "\u{1f3dd}",
    // "shortname": ":island:",

    "category": "t",
    "emoji_order": "1551"
  },
  {
    "name": "national_park",
    "unicode": "\u{1f3de}",
    // "shortname": ":park:",

    "category": "t",
    "emoji_order": "1552"
  },
  {
    "name": "stadium",
    "unicode": "\u{1f3df}",
    // "shortname": ":stadium:",

    "category": "t",
    "emoji_order": "1553"
  },
  {
    "name": "classical_building",
    "unicode": "\u{1f3db}",
    // "shortname": ":classical_building:",

    "category": "t",
    "emoji_order": "1554"
  },
  {
    "name": "building_construction",
    "unicode": "\u{1f3d7}",
    // "shortname": ":construction_site:",

    "category": "t",
    "emoji_order": "1555"
  },
  {
    "name": "house_buildings",
    "unicode": "\u{1f3d8}",
    // "shortname": ":homes:",

    "category": "t",
    "emoji_order": "1556"
  },
  {
    "name": "cityscape",
    "unicode": "\u{1f3d9}",
    // "shortname": ":cityscape:",

    "category": "t",
    "emoji_order": "1557"
  },
  {
    "name": "derelict_house_building",
    "unicode": "\u{1f3da}",
    // "shortname": ":house_abandoned:",

    "category": "t",
    "emoji_order": "1558"
  },
  {
    "name": "house",
    "unicode": "\u{1f3e0}",
    // "shortname": ":house:",

    "category": "t",
    "emoji_order": "1559"
  },
  {
    "name": "house_with_garden",
    "unicode": "\u{1f3e1}",
    // "shortname": ":house_with_garden:",

    "category": "t",
    "emoji_order": "1560"
  },
  {
    "name": "office",
    "unicode": "\u{1f3e2}",
    // "shortname": ":office:",

    "category": "t",
    "emoji_order": "1561"
  },
  {
    "name": "post_office",
    "unicode": "\u{1f3e3}",
    // "shortname": ":post_office:",

    "category": "t",
    "emoji_order": "1562"
  },
  {
    "name": "european_post_office",
    "unicode": "\u{1f3e4}",
    // "shortname": ":european_post_office:",

    "category": "t",
    "emoji_order": "1563"
  },
  {
    "name": "hospital",
    "unicode": "\u{1f3e5}",
    // "shortname": ":hospital:",

    "category": "t",
    "emoji_order": "1564"
  },
  {
    "name": "bank",
    "unicode": "\u{1f3e6}",
    // "shortname": ":bank:",

    "category": "t",
    "emoji_order": "1565"
  },
  {
    "name": "hotel",
    "unicode": "\u{1f3e8}",
    // "shortname": ":hotel:",

    "category": "t",
    "emoji_order": "1566"
  },
  {
    "name": "love_hotel",
    "unicode": "\u{1f3e9}",
    // "shortname": ":love_hotel:",

    "category": "t",
    "emoji_order": "1567"
  },
  {
    "name": "convenience_store",
    "unicode": "\u{1f3ea}",
    // "shortname": ":convenience_store:",

    "category": "t",
    "emoji_order": "1568"
  },
  {
    "name": "school",
    "unicode": "\u{1f3eb}",
    // "shortname": ":school:",

    "category": "t",
    "emoji_order": "1569"
  },
  {
    "name": "department_store",
    "unicode": "\u{1f3ec}",
    // "shortname": ":department_store:",

    "category": "t",
    "emoji_order": "1570"
  },
  {
    "name": "factory",
    "unicode": "\u{1f3ed}",
    // "shortname": ":factory:",

    "category": "t",
    "emoji_order": "1571"
  },
  {
    "name": "japanese_castle",
    "unicode": "\u{1f3ef}",
    // "shortname": ":japanese_castle:",

    "category": "t",
    "emoji_order": "1572"
  },
  {
    "name": "european_castle",
    "unicode": "\u{1f3f0}",
    // "shortname": ":european_castle:",

    "category": "t",
    "emoji_order": "1573"
  },
  {
    "name": "wedding",
    "unicode": "\u{1f492}",
    // "shortname": ":wedding:",

    "category": "t",
    "emoji_order": "1574"
  },
  {
    "name": "tokyo_tower",
    "unicode": "\u{1f5fc}",
    // "shortname": ":tokyo_tower:",

    "category": "t",
    "emoji_order": "1575"
  },
  {
    "name": "statue_of_liberty",
    "unicode": "\u{1f5fd}",
    // "shortname": ":statue_of_liberty:",

    "category": "t",
    "emoji_order": "1576"
  },
  {
    "name": "church",
    "unicode": "\u{26ea}",
    // "shortname": ":church:",

    "category": "t",
    "emoji_order": "1577"
  },
  {
    "name": "mosque",
    "unicode": "\u{1f54c}",
    // "shortname": ":mosque:",

    "category": "t",
    "emoji_order": "1578"
  },
  {
    "name": "synagogue",
    "unicode": "\u{1f54d}",
    // "shortname": ":synagogue:",

    "category": "t",
    "emoji_order": "1579"
  },
  {
    "name": "shinto_shrine",
    "unicode": "\u{26e9}",
    // "shortname": ":shinto_shrine:",

    "category": "t",
    "emoji_order": "1580"
  },
  {
    "name": "kaaba",
    "unicode": "\u{1f54b}",
    // "shortname": ":kaaba:",

    "category": "t",
    "emoji_order": "1581"
  },
  {
    "name": "fountain",
    "unicode": "\u{26f2}",
    // "shortname": ":fountain:",

    "category": "t",
    "emoji_order": "1582"
  },
  {
    "name": "tent",
    "unicode": "\u{26fa}",
    // "shortname": ":tent:",

    "category": "t",
    "emoji_order": "1583"
  },
  {
    "name": "foggy",
    "unicode": "\u{1f301}",
    // "shortname": ":foggy:",

    "category": "t",
    "emoji_order": "1584"
  },
  {
    "name": "night_with_stars",
    "unicode": "\u{1f303}",
    // "shortname": ":night_with_stars:",

    "category": "t",
    "emoji_order": "1585"
  },
  {
    "name": "sunrise_over_mountains",
    "unicode": "\u{1f304}",
    // "shortname": ":sunrise_over_mountains:",

    "category": "t",
    "emoji_order": "1586"
  },
  {
    "name": "sunrise",
    "unicode": "\u{1f305}",
    // "shortname": ":sunrise:",

    "category": "t",
    "emoji_order": "1587"
  },
  {
    "name": "city_dusk",
    "unicode": "\u{1f306}",
    // "shortname": ":city_dusk:",

    "category": "t",
    "emoji_order": "1588"
  },
  {
    "name": "city_sunset",
    "unicode": "\u{1f307}",
    // "shortname": ":city_sunset:",

    "category": "t",
    "emoji_order": "1589"
  },
  {
    "name": "bridge_at_night",
    "unicode": "\u{1f309}",
    // "shortname": ":bridge_at_night:",

    "category": "t",
    "emoji_order": "1590"
  },
  {
    "name": "hotsprings",
    "unicode": "\u{2668}",
    // "shortname": ":hotsprings:",

    "category": "s",
    "emoji_order": "1591"
  },
  {
    "name": "milky_way",
    "unicode": "\u{1f30c}",
    // "shortname": ":milky_way:",

    "category": "t",
    "emoji_order": "1592"
  },
  {
    "name": "carousel_horse",
    "unicode": "\u{1f3a0}",
    // "shortname": ":carousel_horse:",

    "category": "t",
    "emoji_order": "1593"
  },
  {
    "name": "ferris_wheel",
    "unicode": "\u{1f3a1}",
    // "shortname": ":ferris_wheel:",

    "category": "t",
    "emoji_order": "1594"
  },
  {
    "name": "roller_coaster",
    "unicode": "\u{1f3a2}",
    // "shortname": ":roller_coaster:",

    "category": "t",
    "emoji_order": "1595"
  },
  {
    "name": "barber",
    "unicode": "\u{1f488}",
    // "shortname": ":barber:",

    "category": "o",
    "emoji_order": "1596"
  },
  {
    "name": "circus_tent",
    "unicode": "\u{1f3aa}",
    // "shortname": ":circus_tent:",

    "category": "a",
    "emoji_order": "1597"
  },
  {
    "name": "performing_arts",
    "unicode": "\u{1f3ad}",
    // "shortname": ":performing_arts:",

    "category": "a",
    "emoji_order": "1598"
  },
  {
    "name": "frame_with_picture",
    "unicode": "\u{1f5bc}",
    // "shortname": ":frame_photo:",

    "category": "o",
    "emoji_order": "1599"
  },
  {
    "name": "art",
    "unicode": "\u{1f3a8}",
    // "shortname": ":art:",

    "category": "a",
    "emoji_order": "1600"
  },
  {
    "name": "slot_machine",
    "unicode": "\u{1f3b0}",
    // "shortname": ":slot_machine:",

    "category": "a",
    "emoji_order": "1601"
  },
  {
    "name": "steam_locomotive",
    "unicode": "\u{1f682}",
    // "shortname": ":steam_locomotive:",

    "category": "t",
    "emoji_order": "1602"
  },
  {
    "name": "railway_car",
    "unicode": "\u{1f683}",
    // "shortname": ":railway_car:",

    "category": "t",
    "emoji_order": "1603"
  },
  {
    "name": "bullettrain_side",
    "unicode": "\u{1f684}",
    // "shortname": ":bullettrain_side:",

    "category": "t",
    "emoji_order": "1604"
  },
  {
    "name": "bullettrain_front",
    "unicode": "\u{1f685}",
    // "shortname": ":bullettrain_front:",

    "category": "t",
    "emoji_order": "1605"
  },
  {
    "name": "train2",
    "unicode": "\u{1f686}",
    // "shortname": ":train2:",

    "category": "t",
    "emoji_order": "1606"
  },
  {
    "name": "metro",
    "unicode": "\u{1f687}",
    // "shortname": ":metro:",

    "category": "t",
    "emoji_order": "1607"
  },
  {
    "name": "light_rail",
    "unicode": "\u{1f688}",
    // "shortname": ":light_rail:",

    "category": "t",
    "emoji_order": "1608"
  },
  {
    "name": "station",
    "unicode": "\u{1f689}",
    // "shortname": ":station:",

    "category": "t",
    "emoji_order": "1609"
  },
  {
    "name": "tram",
    "unicode": "\u{1f68a}",
    // "shortname": ":tram:",

    "category": "t",
    "emoji_order": "1610"
  },
  {
    "name": "monorail",
    "unicode": "\u{1f69d}",
    // "shortname": ":monorail:",

    "category": "t",
    "emoji_order": "1611"
  },
  {
    "name": "mountain_railway",
    "unicode": "\u{1f69e}",
    // "shortname": ":mountain_railway:",

    "category": "t",
    "emoji_order": "1612"
  },
  {
    "name": "train",
    "unicode": "\u{1f68b}",
    // "shortname": ":train:",

    "category": "t",
    "emoji_order": "1613"
  },
  {
    "name": "bus",
    "unicode": "\u{1f68c}",
    // "shortname": ":bus:",

    "category": "t",
    "emoji_order": "1614"
  },
  {
    "name": "oncoming_bus",
    "unicode": "\u{1f68d}",
    // "shortname": ":oncoming_bus:",

    "category": "t",
    "emoji_order": "1615"
  },
  {
    "name": "trolleybus",
    "unicode": "\u{1f68e}",
    // "shortname": ":trolleybus:",

    "category": "t",
    "emoji_order": "1616"
  },
  {
    "name": "minibus",
    "unicode": "\u{1f690}",
    // "shortname": ":minibus:",

    "category": "t",
    "emoji_order": "1617"
  },
  {
    "name": "ambulance",
    "unicode": "\u{1f691}",
    // "shortname": ":ambulance:",

    "category": "t",
    "emoji_order": "1618"
  },
  {
    "name": "fire_engine",
    "unicode": "\u{1f692}",
    // "shortname": ":fire_engine:",

    "category": "t",
    "emoji_order": "1619"
  },
  {
    "name": "police_car",
    "unicode": "\u{1f693}",
    // "shortname": ":police_car:",

    "category": "t",
    "emoji_order": "1620"
  },
  {
    "name": "oncoming_police_car",
    "unicode": "\u{1f694}",
    // "shortname": ":oncoming_police_car:",

    "category": "t",
    "emoji_order": "1621"
  },
  {
    "name": "taxi",
    "unicode": "\u{1f695}",
    // "shortname": ":taxi:",

    "category": "t",
    "emoji_order": "1622"
  },
  {
    "name": "oncoming_taxi",
    "unicode": "\u{1f696}",
    // "shortname": ":oncoming_taxi:",

    "category": "t",
    "emoji_order": "1623"
  },
  {
    "name": "car",
    "unicode": "\u{1f697}",
    // "shortname": ":red_car:",

    "category": "t",
    "emoji_order": "1624"
  },
  {
    "name": "oncoming_automobile",
    "unicode": "\u{1f698}",
    // "shortname": ":oncoming_automobile:",

    "category": "t",
    "emoji_order": "1625"
  },
  {
    "name": "blue_car",
    "unicode": "\u{1f699}",
    // "shortname": ":blue_car:",

    "category": "t",
    "emoji_order": "1626"
  },
  {
    "name": "truck",
    "unicode": "\u{1f69a}",
    // "shortname": ":truck:",

    "category": "t",
    "emoji_order": "1627"
  },
  {
    "name": "articulated_lorry",
    "unicode": "\u{1f69b}",
    // "shortname": ":articulated_lorry:",

    "category": "t",
    "emoji_order": "1628"
  },
  {
    "name": "tractor",
    "unicode": "\u{1f69c}",
    // "shortname": ":tractor:",

    "category": "t",
    "emoji_order": "1629"
  },
  {
    "name": "bike",
    "unicode": "\u{1f6b2}",
    // "shortname": ":bike:",

    "category": "t",
    "emoji_order": "1630"
  },
  {
    "name": "scooter",
    "unicode": "\u{1f6f4}",
    // "shortname": ":scooter:",

    "category": "t",
    "emoji_order": "1631"
  },
  {
    "name": "motor_scooter",
    "unicode": "\u{1f6f5}",
    // "shortname": ":motor_scooter:",

    "category": "t",
    "emoji_order": "1632"
  },
  {
    "name": "busstop",
    "unicode": "\u{1f68f}",
    // "shortname": ":busstop:",

    "category": "t",
    "emoji_order": "1633"
  },
  {
    "name": "motorway",
    "unicode": "\u{1f6e3}",
    // "shortname": ":motorway:",

    "category": "t",
    "emoji_order": "1634"
  },
  {
    "name": "railway_track",
    "unicode": "\u{1f6e4}",
    // "shortname": ":railway_track:",

    "category": "t",
    "emoji_order": "1635"
  },
  {
    "name": "fuelpump",
    "unicode": "\u{26fd}",
    // "shortname": ":fuelpump:",

    "category": "t",
    "emoji_order": "1636"
  },
  {
    "name": "rotating_light",
    "unicode": "\u{1f6a8}",
    // "shortname": ":rotating_light:",

    "category": "t",
    "emoji_order": "1637"
  },
  {
    "name": "traffic_light",
    "unicode": "\u{1f6a5}",
    // "shortname": ":traffic_light:",

    "category": "t",
    "emoji_order": "1638"
  },
  {
    "name": "vertical_traffic_light",
    "unicode": "\u{1f6a6}",
    // "shortname": ":vertical_traffic_light:",

    "category": "t",
    "emoji_order": "1639"
  },
  {
    "name": "construction",
    "unicode": "\u{1f6a7}",
    // "shortname": ":construction:",

    "category": "t",
    "emoji_order": "1640"
  },
  {
    "name": "octagonal_sign",
    "unicode": "\u{1f6d1}",
    // "shortname": ":octagonal_sign:",

    "category": "s",
    "emoji_order": "1641"
  },
  {
    "name": "anchor",
    "unicode": "\u{2693}",
    // "shortname": ":anchor:",

    "category": "t",
    "emoji_order": "1642"
  },
  {
    "name": "boat",
    "unicode": "\u{26f5}",
    // "shortname": ":sailboat:",

    "category": "t",
    "emoji_order": "1643"
  },
  {
    "name": "canoe",
    "unicode": "\u{1f6f6}",
    // "shortname": ":canoe:",

    "category": "t",
    "emoji_order": "1644"
  },
  {
    "name": "speedboat",
    "unicode": "\u{1f6a4}",
    // "shortname": ":speedboat:",

    "category": "t",
    "emoji_order": "1645"
  },
  {
    "name": "passenger_ship",
    "unicode": "\u{1f6f3}",
    // "shortname": ":cruise_ship:",

    "category": "t",
    "emoji_order": "1646"
  },
  {
    "name": "ferry",
    "unicode": "\u{26f4}",
    // "shortname": ":ferry:",

    "category": "t",
    "emoji_order": "1647"
  },
  {
    "name": "motor_boat",
    "unicode": "\u{1f6e5}",
    // "shortname": ":motorboat:",

    "category": "t",
    "emoji_order": "1648"
  },
  {
    "name": "ship",
    "unicode": "\u{1f6a2}",
    // "shortname": ":ship:",

    "category": "t",
    "emoji_order": "1649"
  },
  {
    "name": "airplane",
    "unicode": "\u{2708}",
    // "shortname": ":airplane:",

    "category": "t",
    "emoji_order": "1650"
  },
  {
    "name": "small_airplane",
    "unicode": "\u{1f6e9}",
    // "shortname": ":airplane_small:",

    "category": "t",
    "emoji_order": "1651"
  },
  {
    "name": "airplane_departure",
    "unicode": "\u{1f6eb}",
    // "shortname": ":airplane_departure:",

    "category": "t",
    "emoji_order": "1652"
  },
  {
    "name": "airplane_arriving",
    "unicode": "\u{1f6ec}",
    // "shortname": ":airplane_arriving:",

    "category": "t",
    "emoji_order": "1653"
  },
  {
    "name": "seat",
    "unicode": "\u{1f4ba}",
    // "shortname": ":seat:",

    "category": "t",
    "emoji_order": "1654"
  },
  {
    "name": "helicopter",
    "unicode": "\u{1f681}",
    // "shortname": ":helicopter:",

    "category": "t",
    "emoji_order": "1655"
  },
  {
    "name": "suspension_railway",
    "unicode": "\u{1f69f}",
    // "shortname": ":suspension_railway:",

    "category": "t",
    "emoji_order": "1656"
  },
  {
    "name": "mountain_cableway",
    "unicode": "\u{1f6a0}",
    // "shortname": ":mountain_cableway:",

    "category": "t",
    "emoji_order": "1657"
  },
  {
    "name": "aerial_tramway",
    "unicode": "\u{1f6a1}",
    // "shortname": ":aerial_tramway:",

    "category": "t",
    "emoji_order": "1658"
  },
  {
    "name": "rocket",
    "unicode": "\u{1f680}",
    // "shortname": ":rocket:",

    "category": "t",
    "emoji_order": "1659"
  },
  {
    "name": "satellite",
    "unicode": "\u{1f6f0}",
    // "shortname": ":satellite_orbital:",

    "category": "t",
    "emoji_order": "1660"
  },
  {
    "name": "bellhop_bell",
    "unicode": "\u{1f6ce}",
    // "shortname": ":bellhop:",

    "category": "o",
    "emoji_order": "1661"
  },
  {
    "name": "door",
    "unicode": "\u{1f6aa}",
    // "shortname": ":door:",

    "category": "o",
    "emoji_order": "1662"
  },
  {
    "name": "sleeping_accommodation",
    "unicode": "\u{1f6cc}",
    // "shortname": ":sleeping_accommodation:",

    "category": "o",
    "emoji_order": "1663"
  },
  {
    "name": "bed",
    "unicode": "\u{1f6cf}",
    // "shortname": ":bed:",

    "category": "o",
    "emoji_order": "1669"
  },
  {
    "name": "couch_and_lamp",
    "unicode": "\u{1f6cb}",
    // "shortname": ":couch:",

    "category": "o",
    "emoji_order": "1670"
  },
  {
    "name": "toilet",
    "unicode": "\u{1f6bd}",
    // "shortname": ":toilet:",

    "category": "o",
    "emoji_order": "1671"
  },
  {
    "name": "shower",
    "unicode": "\u{1f6bf}",
    // "shortname": ":shower:",

    "category": "o",
    "emoji_order": "1672"
  },
  {
    "name": "bath",
    "unicode": "\u{1f6c0}",
    // "shortname": ":bath:",

    "category": "a",
    "emoji_order": "1673"
  },
  {
    "name": "bathtub",
    "unicode": "\u{1f6c1}",
    // "shortname": ":bathtub:",

    "category": "o",
    "emoji_order": "1679"
  },
  {
    "name": "hourglass",
    "unicode": "\u{231b}",
    // "shortname": ":hourglass:",

    "category": "o",
    "emoji_order": "1680"
  },
  {
    "name": "hourglass_flowing_sand",
    "unicode": "\u{23f3}",
    // "shortname": ":hourglass_flowing_sand:",

    "category": "o",
    "emoji_order": "1681"
  },
  {
    "name": "watch",
    "unicode": "\u{231a}",
    // "shortname": ":watch:",

    "category": "o",
    "emoji_order": "1682"
  },
  {
    "name": "alarm_clock",
    "unicode": "\u{23f0}",
    // "shortname": ":alarm_clock:",

    "category": "o",
    "emoji_order": "1683"
  },
  {
    "name": "stopwatch",
    "unicode": "\u{23f1}",
    // "shortname": ":stopwatch:",

    "category": "o",
    "emoji_order": "1684"
  },
  {
    "name": "timer_clock",
    "unicode": "\u{23f2}",
    // "shortname": ":timer:",

    "category": "o",
    "emoji_order": "1685"
  },
  {
    "name": "mantelpiece_clock",
    "unicode": "\u{1f570}",
    // "shortname": ":clock:",

    "category": "o",
    "emoji_order": "1686"
  },
  {
    "name": "clock12",
    "unicode": "\u{1f55b}",
    // "shortname": ":clock12:",

    "category": "s",
    "emoji_order": "1687"
  },
  {
    "name": "clock1230",
    "unicode": "\u{1f567}",
    // "shortname": ":clock1230:",

    "category": "s",
    "emoji_order": "1688"
  },
  {
    "name": "clock1",
    "unicode": "\u{1f550}",
    // "shortname": ":clock1:",

    "category": "s",
    "emoji_order": "1689"
  },
  {
    "name": "clock130",
    "unicode": "\u{1f55c}",
    // "shortname": ":clock130:",

    "category": "s",
    "emoji_order": "1690"
  },
  {
    "name": "clock2",
    "unicode": "\u{1f551}",
    // "shortname": ":clock2:",

    "category": "s",
    "emoji_order": "1691"
  },
  {
    "name": "clock230",
    "unicode": "\u{1f55d}",
    // "shortname": ":clock230:",

    "category": "s",
    "emoji_order": "1692"
  },
  {
    "name": "clock3",
    "unicode": "\u{1f552}",
    // "shortname": ":clock3:",

    "category": "s",
    "emoji_order": "1693"
  },
  {
    "name": "clock330",
    "unicode": "\u{1f55e}",
    // "shortname": ":clock330:",

    "category": "s",
    "emoji_order": "1694"
  },
  {
    "name": "clock4",
    "unicode": "\u{1f553}",
    // "shortname": ":clock4:",

    "category": "s",
    "emoji_order": "1695"
  },
  {
    "name": "clock430",
    "unicode": "\u{1f55f}",
    // "shortname": ":clock430:",

    "category": "s",
    "emoji_order": "1696"
  },
  {
    "name": "clock5",
    "unicode": "\u{1f554}",
    // "shortname": ":clock5:",

    "category": "s",
    "emoji_order": "1697"
  },
  {
    "name": "clock530",
    "unicode": "\u{1f560}",
    // "shortname": ":clock530:",

    "category": "s",
    "emoji_order": "1698"
  },
  {
    "name": "clock6",
    "unicode": "\u{1f555}",
    // "shortname": ":clock6:",

    "category": "s",
    "emoji_order": "1699"
  },
  {
    "name": "clock630",
    "unicode": "\u{1f561}",
    // "shortname": ":clock630:",

    "category": "s",
    "emoji_order": "1700"
  },
  {
    "name": "clock7",
    "unicode": "\u{1f556}",
    // "shortname": ":clock7:",

    "category": "s",
    "emoji_order": "1701"
  },
  {
    "name": "clock730",
    "unicode": "\u{1f562}",
    // "shortname": ":clock730:",

    "category": "s",
    "emoji_order": "1702"
  },
  {
    "name": "clock8",
    "unicode": "\u{1f557}",
    // "shortname": ":clock8:",

    "category": "s",
    "emoji_order": "1703"
  },
  {
    "name": "clock830",
    "unicode": "\u{1f563}",
    // "shortname": ":clock830:",

    "category": "s",
    "emoji_order": "1704"
  },
  {
    "name": "clock9",
    "unicode": "\u{1f558}",
    // "shortname": ":clock9:",

    "category": "s",
    "emoji_order": "1705"
  },
  {
    "name": "clock930",
    "unicode": "\u{1f564}",
    // "shortname": ":clock930:",

    "category": "s",
    "emoji_order": "1706"
  },
  {
    "name": "clock10",
    "unicode": "\u{1f559}",
    // "shortname": ":clock10:",

    "category": "s",
    "emoji_order": "1707"
  },
  {
    "name": "clock1030",
    "unicode": "\u{1f565}",
    // "shortname": ":clock1030:",

    "category": "s",
    "emoji_order": "1708"
  },
  {
    "name": "clock11",
    "unicode": "\u{1f55a}",
    // "shortname": ":clock11:",

    "category": "s",
    "emoji_order": "1709"
  },
  {
    "name": "clock1130",
    "unicode": "\u{1f566}",
    // "shortname": ":clock1130:",

    "category": "s",
    "emoji_order": "1710"
  },
  {
    "name": "new_moon",
    "unicode": "\u{1f311}",
    // "shortname": ":new_moon:",

    "category": "n",
    "emoji_order": "1711"
  },
  {
    "name": "waxing_crescent_moon",
    "unicode": "\u{1f312}",
    // "shortname": ":waxing_crescent_moon:",

    "category": "n",
    "emoji_order": "1712"
  },
  {
    "name": "first_quarter_moon",
    "unicode": "\u{1f313}",
    // "shortname": ":first_quarter_moon:",

    "category": "n",
    "emoji_order": "1713"
  },
  {
    "name": "waxing_gibbous_moon",
    "unicode": "\u{1f314}",
    // "shortname": ":waxing_gibbous_moon:",

    "category": "n",
    "emoji_order": "1714"
  },
  {
    "name": "full_moon",
    "unicode": "\u{1f315}",
    // "shortname": ":full_moon:",

    "category": "n",
    "emoji_order": "1715"
  },
  {
    "name": "waning_gibbous_moon",
    "unicode": "\u{1f316}",
    // "shortname": ":waning_gibbous_moon:",

    "category": "n",
    "emoji_order": "1716"
  },
  {
    "name": "last_quarter_moon",
    "unicode": "\u{1f317}",
    // "shortname": ":last_quarter_moon:",

    "category": "n",
    "emoji_order": "1717"
  },
  {
    "name": "waning_crescent_moon",
    "unicode": "\u{1f318}",
    // "shortname": ":waning_crescent_moon:",

    "category": "n",
    "emoji_order": "1718"
  },
  {
    "name": "crescent_moon",
    "unicode": "\u{1f319}",
    // "shortname": ":crescent_moon:",

    "category": "n",
    "emoji_order": "1719"
  },
  {
    "name": "new_moon_with_face",
    "unicode": "\u{1f31a}",
    // "shortname": ":new_moon_with_face:",

    "category": "n",
    "emoji_order": "1720"
  },
  {
    "name": "first_quarter_moon_with_face",
    "unicode": "\u{1f31b}",
    // "shortname": ":first_quarter_moon_with_face:",

    "category": "n",
    "emoji_order": "1721"
  },
  {
    "name": "last_quarter_moon_with_face",
    "unicode": "\u{1f31c}",
    // "shortname": ":last_quarter_moon_with_face:",

    "category": "n",
    "emoji_order": "1722"
  },
  {
    "name": "thermometer",
    "unicode": "\u{1f321}",
    // "shortname": ":thermometer:",

    "category": "o",
    "emoji_order": "1723"
  },
  {
    "name": "sunny",
    "unicode": "\u{2600}",
    // "shortname": ":sunny:",

    "category": "n",
    "emoji_order": "1724"
  },
  {
    "name": "full_moon_with_face",
    "unicode": "\u{1f31d}",
    // "shortname": ":full_moon_with_face:",

    "category": "n",
    "emoji_order": "1725"
  },
  {
    "name": "sun_with_face",
    "unicode": "\u{1f31e}",
    // "shortname": ":sun_with_face:",

    "category": "n",
    "emoji_order": "1726"
  },
  {
    "name": "star",
    "unicode": "\u{2b50}",
    // "shortname": ":star:",

    "category": "n",
    "emoji_order": "1727"
  },
  {
    "name": "star2",
    "unicode": "\u{1f31f}",
    // "shortname": ":star2:",

    "category": "n",
    "emoji_order": "1728"
  },
  {
    "name": "stars",
    "unicode": "\u{1f320}",
    // "shortname": ":stars:",

    "category": "t",
    "emoji_order": "1729"
  },
  {
    "name": "cloud",
    "unicode": "\u{2601}",
    // "shortname": ":cloud:",

    "category": "n",
    "emoji_order": "1730"
  },
  {
    "name": "partly_sunny",
    "unicode": "\u{26c5}",
    // "shortname": ":partly_sunny:",

    "category": "n",
    "emoji_order": "1731"
  },
  {
    "name": "thunder_cloud_and_rain",
    "unicode": "\u{26c8}",
    // "shortname": ":thunder_cloud_rain:",

    "category": "n",
    "emoji_order": "1732"
  },
  {
    "name": "white_sun_small_cloud",
    "unicode": "\u{1f324}",
    // "shortname": ":white_sun_small_cloud:",

    "category": "n",
    "emoji_order": "1733"
  },
  {
    "name": "white_sun_cloud",
    "unicode": "\u{1f325}",
    // "shortname": ":white_sun_cloud:",

    "category": "n",
    "emoji_order": "1734"
  },
  {
    "name": "white_sun_rain_cloud",
    "unicode": "\u{1f326}",
    // "shortname": ":white_sun_rain_cloud:",

    "category": "n",
    "emoji_order": "1735"
  },
  {
    "name": "rain_cloud",
    "unicode": "\u{1f327}",
    // "shortname": ":cloud_rain:",

    "category": "n",
    "emoji_order": "1736"
  },
  {
    "name": "snow_cloud",
    "unicode": "\u{1f328}",
    // "shortname": ":cloud_snow:",

    "category": "n",
    "emoji_order": "1737"
  },
  {
    "name": "cloud_lightning",
    "unicode": "\u{1f329}",
    // "shortname": ":cloud_lightning:",

    "category": "n",
    "emoji_order": "1738"
  },
  {
    "name": "cloud_tornado",
    "unicode": "\u{1f32a}",
    // "shortname": ":cloud_tornado:",

    "category": "n",
    "emoji_order": "1739"
  },
  {
    "name": "fog",
    "unicode": "\u{1f32b}",
    // "shortname": ":fog:",

    "category": "n",
    "emoji_order": "1740"
  },
  {
    "name": "wind_blowing_face",
    "unicode": "\u{1f32c}",
    // "shortname": ":wind_blowing_face:",

    "category": "n",
    "emoji_order": "1741"
  },
  {
    "name": "cyclone",
    "unicode": "\u{1f300}",
    // "shortname": ":cyclone:",

    "category": "s",
    "emoji_order": "1742"
  },
  {
    "name": "rainbow",
    "unicode": "\u{1f308}",
    // "shortname": ":rainbow:",

    "category": "t",
    "emoji_order": "1743"
  },
  {
    "name": "closed_umbrella",
    "unicode": "\u{1f302}",
    // "shortname": ":closed_umbrella:",

    "category": "p",
    "emoji_order": "1744"
  },
  {
    "name": "umbrella",
    "unicode": "\u{2602}",
    // "shortname": ":umbrella2:",

    "category": "n",
    "emoji_order": "1745"
  },
  {
    "name": "umbrella_with_rain_drops",
    "unicode": "\u{2614}",
    // "shortname": ":umbrella:",

    "category": "n",
    "emoji_order": "1746"
  },
  {
    "name": "beach_umbrella",
    "unicode": "\u{26f1}",
    // "shortname": ":beach_umbrella:",

    "category": "o",
    "emoji_order": "1747"
  },
  {
    "name": "zap",
    "unicode": "\u{26a1}",
    // "shortname": ":zap:",

    "category": "n",
    "emoji_order": "1748"
  },
  {
    "name": "snowflake",
    "unicode": "\u{2744}",
    // "shortname": ":snowflake:",

    "category": "n",
    "emoji_order": "1749"
  },
  {
    "name": "snowman",
    "unicode": "\u{2603}",
    // "shortname": ":snowman2:",

    "category": "n",
    "emoji_order": "1750"
  },
  {
    "name": "snowman_without_snow",
    "unicode": "\u{26c4}",
    // "shortname": ":snowman:",

    "category": "n",
    "emoji_order": "1751"
  },
  {
    "name": "comet",
    "unicode": "\u{2604}",
    // "shortname": ":comet:",

    "category": "n",
    "emoji_order": "1752"
  },
  {
    "name": "fire",
    "unicode": "\u{1f525}",
    // "shortname": ":fire:",

    "category": "n",
    "emoji_order": "1753"
  },
  {
    "name": "droplet",
    "unicode": "\u{1f4a7}",
    // "shortname": ":droplet:",

    "category": "n",
    "emoji_order": "1754"
  },
  {
    "name": "ocean",
    "unicode": "\u{1f30a}",
    // "shortname": ":ocean:",

    "category": "n",
    "emoji_order": "1755"
  },
  {
    "name": "jack_o_lantern",
    "unicode": "\u{1f383}",
    // "shortname": ":jack_o_lantern:",

    "category": "n",
    "emoji_order": "1756"
  },
  {
    "name": "christmas_tree",
    "unicode": "\u{1f384}",
    // "shortname": ":christmas_tree:",

    "category": "n",
    "emoji_order": "1757"
  },
  {
    "name": "fireworks",
    "unicode": "\u{1f386}",
    // "shortname": ":fireworks:",

    "category": "t",
    "emoji_order": "1758"
  },
  {
    "name": "sparkler",
    "unicode": "\u{1f387}",
    // "shortname": ":sparkler:",

    "category": "t",
    "emoji_order": "1759"
  },
  {
    "name": "sparkles",
    "unicode": "\u{2728}",
    // "shortname": ":sparkles:",

    "category": "n",
    "emoji_order": "1760"
  },
  {
    "name": "balloon",
    "unicode": "\u{1f388}",
    // "shortname": ":balloon:",

    "category": "o",
    "emoji_order": "1761"
  },
  {
    "name": "tada",
    "unicode": "\u{1f389}",
    // "shortname": ":tada:",

    "category": "o",
    "emoji_order": "1762"
  },
  {
    "name": "confetti_ball",
    "unicode": "\u{1f38a}",
    // "shortname": ":confetti_ball:",

    "category": "o",
    "emoji_order": "1763"
  },
  {
    "name": "tanabata_tree",
    "unicode": "\u{1f38b}",
    // "shortname": ":tanabata_tree:",

    "category": "n",
    "emoji_order": "1764"
  },
  {
    "name": "bamboo",
    "unicode": "\u{1f38d}",
    // "shortname": ":bamboo:",

    "category": "n",
    "emoji_order": "1765"
  },
  {
    "name": "dolls",
    "unicode": "\u{1f38e}",
    // "shortname": ":dolls:",

    "category": "o",
    "emoji_order": "1766"
  },
  {
    "name": "f",
    "unicode": "\u{1f38f}",
    // "shortname": ":flags:",

    "category": "o",
    "emoji_order": "1767"
  },
  {
    "name": "wind_chime",
    "unicode": "\u{1f390}",
    // "shortname": ":wind_chime:",

    "category": "o",
    "emoji_order": "1768"
  },
  {
    "name": "rice_scene",
    "unicode": "\u{1f391}",
    // "shortname": ":rice_scene:",

    "category": "t",
    "emoji_order": "1769"
  },
  {
    "name": "ribbon",
    "unicode": "\u{1f380}",
    // "shortname": ":ribbon:",

    "category": "o",
    "emoji_order": "1770"
  },
  {
    "name": "gift",
    "unicode": "\u{1f381}",
    // "shortname": ":gift:",

    "category": "o",
    "emoji_order": "1771"
  },
  {
    "name": "reminder_ribbon",
    "unicode": "\u{1f397}",
    // "shortname": ":reminder_ribbon:",

    "category": "a",
    "emoji_order": "1772"
  },
  {
    "name": "admission_tickets",
    "unicode": "\u{1f39f}",
    // "shortname": ":tickets:",

    "category": "a",
    "emoji_order": "1773"
  },
  {
    "name": "ticket",
    "unicode": "\u{1f3ab}",
    // "shortname": ":ticket:",

    "category": "a",
    "emoji_order": "1774"
  },
  {
    "name": "medal",
    "unicode": "\u{1f396}",
    // "shortname": ":military_medal:",

    "category": "a",
    "emoji_order": "1775"
  },
  {
    "name": "trophy",
    "unicode": "\u{1f3c6}",
    // "shortname": ":trophy:",

    "category": "a",
    "emoji_order": "1776"
  },
  {
    "name": "sports_medal",
    "unicode": "\u{1f3c5}",
    // "shortname": ":medal:",

    "category": "a",
    "emoji_order": "1777"
  },
  {
    "name": "first_place",
    "unicode": "\u{1f947}",
    // "shortname": ":first_place:",

    "category": "a",
    "emoji_order": "1778"
  },
  {
    "name": "second_place",
    "unicode": "\u{1f948}",
    // "shortname": ":second_place:",

    "category": "a",
    "emoji_order": "1779"
  },
  {
    "name": "third_place",
    "unicode": "\u{1f949}",
    // "shortname": ":third_place:",

    "category": "a",
    "emoji_order": "1780"
  },
  {
    "name": "soccer",
    "unicode": "\u{26bd}",
    // "shortname": ":soccer:",

    "category": "a",
    "emoji_order": "1781"
  },
  {
    "name": "baseball",
    "unicode": "\u{26be}",
    // "shortname": ":baseball:",

    "category": "a",
    "emoji_order": "1782"
  },
  {
    "name": "basketball",
    "unicode": "\u{1f3c0}",
    // "shortname": ":basketball:",

    "category": "a",
    "emoji_order": "1783"
  },
  {
    "name": "volleyball",
    "unicode": "\u{1f3d0}",
    // "shortname": ":volleyball:",

    "category": "a",
    "emoji_order": "1784"
  },
  {
    "name": "football",
    "unicode": "\u{1f3c8}",
    // "shortname": ":football:",

    "category": "a",
    "emoji_order": "1785"
  },
  {
    "name": "rugby_football",
    "unicode": "\u{1f3c9}",
    // "shortname": ":rugby_football:",

    "category": "a",
    "emoji_order": "1786"
  },
  {
    "name": "tennis",
    "unicode": "\u{1f3be}",
    // "shortname": ":tennis:",

    "category": "a",
    "emoji_order": "1787"
  },
  {
    "name": "8ball",
    "unicode": "\u{1f3b1}",
    // "shortname": ":8ball:",

    "category": "a",
    "emoji_order": "1788"
  },
  {
    "name": "bowling",
    "unicode": "\u{1f3b3}",
    // "shortname": ":bowling:",

    "category": "a",
    "emoji_order": "1789"
  },
  {
    "name": "cricket_bat_and_ball",
    "unicode": "\u{1f3cf}",
    // "shortname": ":cricket_game:",

    "category": "a",
    "emoji_order": "1790"
  },
  {
    "name": "field_hockey_stick_and_ball",
    "unicode": "\u{1f3d1}",
    // "shortname": ":field_hockey:",

    "category": "a",
    "emoji_order": "1791"
  },
  {
    "name": "ice_hockey_stick_and_puck",
    "unicode": "\u{1f3d2}",
    // "shortname": ":hockey:",

    "category": "a",
    "emoji_order": "1792"
  },
  {
    "name": "table_tennis_paddle_and_ball",
    "unicode": "\u{1f3d3}",
    // "shortname": ":ping_pong:",

    "category": "a",
    "emoji_order": "1793"
  },
  {
    "name": "badminton_racquet_and_shuttlecock",
    "unicode": "\u{1f3f8}",
    // "shortname": ":badminton:",

    "category": "a",
    "emoji_order": "1794"
  },
  {
    "name": "boxing_glove",
    "unicode": "\u{1f94a}",
    // "shortname": ":boxing_glove:",

    "category": "a",
    "emoji_order": "1795"
  },
  {
    "name": "martial_arts_uniform",
    "unicode": "\u{1f94b}",
    // "shortname": ":martial_arts_uniform:",

    "category": "a",
    "emoji_order": "1796"
  },
  {
    "name": "goal",
    "unicode": "\u{1f945}",
    // "shortname": ":goal:",

    "category": "a",
    "emoji_order": "1797"
  },
  {
    "name": "dart",
    "unicode": "\u{1f3af}",
    // "shortname": ":dart:",

    "category": "a",
    "emoji_order": "1798"
  },
  {
    "name": "golf",
    "unicode": "\u{26f3}",
    // "shortname": ":golf:",

    "category": "a",
    "emoji_order": "1799"
  },
  {
    "name": "ice_skate",
    "unicode": "\u{26f8}",
    // "shortname": ":ice_skate:",

    "category": "a",
    "emoji_order": "1800"
  },
  {
    "name": "fishing_pole_and_fish",
    "unicode": "\u{1f3a3}",
    // "shortname": ":fishing_pole_and_fish:",

    "category": "a",
    "emoji_order": "1801"
  },
  {
    "name": "running_shirt_with_sash",
    "unicode": "\u{1f3bd}",
    // "shortname": ":running_shirt_with_sash:",

    "category": "a",
    "emoji_order": "1802"
  },
  {
    "name": "ski",
    "unicode": "\u{1f3bf}",
    // "shortname": ":ski:",

    "category": "a",
    "emoji_order": "1803"
  },
  {
    "name": "video_game",
    "unicode": "\u{1f3ae}",
    // "shortname": ":video_game:",

    "category": "a",
    "emoji_order": "1804"
  },
  {
    "name": "joystick",
    "unicode": "\u{1f579}",
    // "shortname": ":joystick:",

    "category": "o",
    "emoji_order": "1805"
  },
  {
    "name": "game_die",
    "unicode": "\u{1f3b2}",
    // "shortname": ":game_die:",

    "category": "a",
    "emoji_order": "1806"
  },
  {
    "name": "spades",
    "unicode": "\u{2660}",
    // "shortname": ":spades:",

    "category": "s",
    "emoji_order": "1807"
  },
  {
    "name": "hearts",
    "unicode": "\u{2665}",
    // "shortname": ":hearts:",

    "category": "s",
    "emoji_order": "1808"
  },
  {
    "name": "diamonds",
    "unicode": "\u{2666}",
    // "shortname": ":diamonds:",

    "category": "s",
    "emoji_order": "1809"
  },
  {
    "name": "clubs",
    "unicode": "\u{2663}",
    // "shortname": ":clubs:",

    "category": "s",
    "emoji_order": "1810"
  },
  {
    "name": "black_joker",
    "unicode": "\u{1f0cf}",
    // "shortname": ":black_joker:",

    "category": "s",
    "emoji_order": "1811"
  },
  {
    "name": "mahjong",
    "unicode": "\u{1f004}",
    // "shortname": ":mahjong:",

    "category": "s",
    "emoji_order": "1812"
  },
  {
    "name": "flower_playing_cards",
    "unicode": "\u{1f3b4}",
    // "shortname": ":flower_playing_cards:",

    "category": "s",
    "emoji_order": "1813"
  },
  {
    "name": "mute",
    "unicode": "\u{1f507}",
    // "shortname": ":mute:",

    "category": "s",
    "emoji_order": "1814"
  },
  {
    "name": "speaker",
    "unicode": "\u{1f508}",
    // "shortname": ":speaker:",

    "category": "s",
    "emoji_order": "1815"
  },
  {
    "name": "sound",
    "unicode": "\u{1f509}",
    // "shortname": ":sound:",

    "category": "s",
    "emoji_order": "1816"
  },
  {
    "name": "loud_sound",
    "unicode": "\u{1f50a}",
    // "shortname": ":loud_sound:",

    "category": "s",
    "emoji_order": "1817"
  },
  {
    "name": "loudspeaker",
    "unicode": "\u{1f4e2}",
    // "shortname": ":loudspeaker:",

    "category": "s",
    "emoji_order": "1818"
  },
  {
    "name": "mega",
    "unicode": "\u{1f4e3}",
    // "shortname": ":mega:",

    "category": "s",
    "emoji_order": "1819"
  },
  {
    "name": "postal_horn",
    "unicode": "\u{1f4ef}",
    // "shortname": ":postal_horn:",

    "category": "o",
    "emoji_order": "1820"
  },
  {
    "name": "bell",
    "unicode": "\u{1f514}",
    // "shortname": ":bell:",

    "category": "s",
    "emoji_order": "1821"
  },
  {
    "name": "no_bell",
    "unicode": "\u{1f515}",
    // "shortname": ":no_bell:",

    "category": "s",
    "emoji_order": "1822"
  },
  {
    "name": "musical_score",
    "unicode": "\u{1f3bc}",
    // "shortname": ":musical_score:",

    "category": "a",
    "emoji_order": "1823"
  },
  {
    "name": "musical_note",
    "unicode": "\u{1f3b5}",
    // "shortname": ":musical_note:",

    "category": "s",
    "emoji_order": "1824"
  },
  {
    "name": "notes",
    "unicode": "\u{1f3b6}",
    // "shortname": ":notes:",

    "category": "s",
    "emoji_order": "1825"
  },
  {
    "name": "studio_microphone",
    "unicode": "\u{1f399}",
    // "shortname": ":microphone2:",

    "category": "o",
    "emoji_order": "1826"
  },
  {
    "name": "level_slider",
    "unicode": "\u{1f39a}",
    // "shortname": ":level_slider:",

    "category": "o",
    "emoji_order": "1827"
  },
  {
    "name": "control_knobs",
    "unicode": "\u{1f39b}",
    // "shortname": ":control_knobs:",

    "category": "o",
    "emoji_order": "1828"
  },
  {
    "name": "microphone",
    "unicode": "\u{1f3a4}",
    // "shortname": ":microphone:",

    "category": "a",
    "emoji_order": "1829"
  },
  {
    "name": "headphones",
    "unicode": "\u{1f3a7}",
    // "shortname": ":headphones:",

    "category": "a",
    "emoji_order": "1830"
  },
  {
    "name": "radio",
    "unicode": "\u{1f4fb}",
    // "shortname": ":radio:",

    "category": "o",
    "emoji_order": "1831"
  },
  {
    "name": "saxophone",
    "unicode": "\u{1f3b7}",
    // "shortname": ":saxophone:",

    "category": "a",
    "emoji_order": "1832"
  },
  {
    "name": "guitar",
    "unicode": "\u{1f3b8}",
    // "shortname": ":guitar:",

    "category": "a",
    "emoji_order": "1833"
  },
  {
    "name": "musical_keyboard",
    "unicode": "\u{1f3b9}",
    // "shortname": ":musical_keyboard:",

    "category": "a",
    "emoji_order": "1834"
  },
  {
    "name": "trumpet",
    "unicode": "\u{1f3ba}",
    // "shortname": ":trumpet:",

    "category": "a",
    "emoji_order": "1835"
  },
  {
    "name": "violin",
    "unicode": "\u{1f3bb}",
    // "shortname": ":violin:",

    "category": "a",
    "emoji_order": "1836"
  },
  {
    "name": "drum",
    "unicode": "\u{1f941}",
    // "shortname": ":drum:",

    "category": "a",
    "emoji_order": "1837"
  },
  {
    "name": "iphone",
    "unicode": "\u{1f4f1}",
    // "shortname": ":iphone:",

    "category": "o",
    "emoji_order": "1838"
  },
  {
    "name": "calling",
    "unicode": "\u{1f4f2}",
    // "shortname": ":calling:",

    "category": "o",
    "emoji_order": "1839"
  },
  {
    "name": "telephone",
    "unicode": "\u{260e}",
    // "shortname": ":telephone:",

    "category": "o",
    "emoji_order": "1840"
  },
  {
    "name": "telephone_receiver",
    "unicode": "\u{1f4de}",
    // "shortname": ":telephone_receiver:",

    "category": "o",
    "emoji_order": "1841"
  },
  {
    "name": "pager",
    "unicode": "\u{1f4df}",
    // "shortname": ":pager:",

    "category": "o",
    "emoji_order": "1842"
  },
  {
    "name": "fax",
    "unicode": "\u{1f4e0}",
    // "shortname": ":fax:",

    "category": "o",
    "emoji_order": "1843"
  },
  {
    "name": "battery",
    "unicode": "\u{1f50b}",
    // "shortname": ":battery:",

    "category": "o",
    "emoji_order": "1844"
  },
  {
    "name": "electric_plug",
    "unicode": "\u{1f50c}",
    // "shortname": ":electric_plug:",

    "category": "o",
    "emoji_order": "1845"
  },
  {
    "name": "computer",
    "unicode": "\u{1f4bb}",
    // "shortname": ":computer:",

    "category": "o",
    "emoji_order": "1846"
  },
  {
    "name": "desktop_computer",
    "unicode": "\u{1f5a5}",
    // "shortname": ":desktop:",

    "category": "o",
    "emoji_order": "1847"
  },
  {
    "name": "printer",
    "unicode": "\u{1f5a8}",
    // "shortname": ":printer:",

    "category": "o",
    "emoji_order": "1848"
  },
  {
    "name": "keyboard",
    "unicode": "\u{2328}",
    // "shortname": ":keyboard:",

    "category": "o",
    "emoji_order": "1849"
  },
  {
    "name": "three_button_mouse",
    "unicode": "\u{1f5b1}",
    // "shortname": ":mouse_three_button:",

    "category": "o",
    "emoji_order": "1850"
  },
  {
    "name": "trackball",
    "unicode": "\u{1f5b2}",
    // "shortname": ":trackball:",

    "category": "o",
    "emoji_order": "1851"
  },
  {
    "name": "minidisc",
    "unicode": "\u{1f4bd}",
    // "shortname": ":minidisc:",

    "category": "o",
    "emoji_order": "1852"
  },
  {
    "name": "floppy_disk",
    "unicode": "\u{1f4be}",
    // "shortname": ":floppy_disk:",

    "category": "o",
    "emoji_order": "1853"
  },
  {
    "name": "cd",
    "unicode": "\u{1f4bf}",
    // "shortname": ":cd:",

    "category": "o",
    "emoji_order": "1854"
  },
  {
    "name": "dvd",
    "unicode": "\u{1f4c0}",
    // "shortname": ":dvd:",

    "category": "o",
    "emoji_order": "1855"
  },
  {
    "name": "movie_camera",
    "unicode": "\u{1f3a5}",
    // "shortname": ":movie_camera:",

    "category": "o",
    "emoji_order": "1856"
  },
  {
    "name": "film_frames",
    "unicode": "\u{1f39e}",
    // "shortname": ":film_frames:",

    "category": "o",
    "emoji_order": "1857"
  },
  {
    "name": "film_projector",
    "unicode": "\u{1f4fd}",
    // "shortname": ":projector:",

    "category": "o",
    "emoji_order": "1858"
  },
  {
    "name": "clapper",
    "unicode": "\u{1f3ac}",
    // "shortname": ":clapper:",

    "category": "a",
    "emoji_order": "1859"
  },
  {
    "name": "tv",
    "unicode": "\u{1f4fa}",
    // "shortname": ":tv:",

    "category": "o",
    "emoji_order": "1860"
  },
  {
    "name": "camera",
    "unicode": "\u{1f4f7}",
    // "shortname": ":camera:",

    "category": "o",
    "emoji_order": "1861"
  },
  {
    "name": "camera_with_flash",
    "unicode": "\u{1f4f8}",
    // "shortname": ":camera_with_flash:",

    "category": "o",
    "emoji_order": "1862"
  },
  {
    "name": "video_camera",
    "unicode": "\u{1f4f9}",
    // "shortname": ":video_camera:",

    "category": "o",
    "emoji_order": "1863"
  },
  {
    "name": "vhs",
    "unicode": "\u{1f4fc}",
    // "shortname": ":vhs:",

    "category": "o",
    "emoji_order": "1864"
  },
  {
    "name": "mag",
    "unicode": "\u{1f50d}",
    // "shortname": ":mag:",

    "category": "o",
    "emoji_order": "1865"
  },
  {
    "name": "mag_right",
    "unicode": "\u{1f50e}",
    // "shortname": ":mag_right:",

    "category": "o",
    "emoji_order": "1866"
  },
  {
    "name": "microscope",
    "unicode": "\u{1f52c}",
    // "shortname": ":microscope:",

    "category": "o",
    "emoji_order": "1867"
  },
  {
    "name": "telescope",
    "unicode": "\u{1f52d}",
    // "shortname": ":telescope:",

    "category": "o",
    "emoji_order": "1868"
  },
  {
    "name": "satellite_antenna",
    "unicode": "\u{1f4e1}",
    // "shortname": ":satellite:",

    "category": "o",
    "emoji_order": "1869"
  },
  {
    "name": "candle",
    "unicode": "\u{1f56f}",
    // "shortname": ":candle:",

    "category": "o",
    "emoji_order": "1870"
  },
  {
    "name": "bulb",
    "unicode": "\u{1f4a1}",
    // "shortname": ":bulb:",

    "category": "o",
    "emoji_order": "1871"
  },
  {
    "name": "flashlight",
    "unicode": "\u{1f526}",
    // "shortname": ":flashlight:",

    "category": "o",
    "emoji_order": "1872"
  },
  {
    "name": "izakaya_lantern",
    "unicode": "\u{1f3ee}",
    // "shortname": ":izakaya_lantern:",

    "category": "o",
    "emoji_order": "1873"
  },
  {
    "name": "notebook_with_decorative_cover",
    "unicode": "\u{1f4d4}",
    // "shortname": ":notebook_with_decorative_cover:",

    "category": "o",
    "emoji_order": "1874"
  },
  {
    "name": "closed_book",
    "unicode": "\u{1f4d5}",
    // "shortname": ":closed_book:",

    "category": "o",
    "emoji_order": "1875"
  },
  {
    "name": "book",
    "unicode": "\u{1f4d6}",
    // "shortname": ":book:",

    "category": "o",
    "emoji_order": "1876"
  },
  {
    "name": "green_book",
    "unicode": "\u{1f4d7}",
    // "shortname": ":green_book:",

    "category": "o",
    "emoji_order": "1877"
  },
  {
    "name": "blue_book",
    "unicode": "\u{1f4d8}",
    // "shortname": ":blue_book:",

    "category": "o",
    "emoji_order": "1878"
  },
  {
    "name": "orange_book",
    "unicode": "\u{1f4d9}",
    // "shortname": ":orange_book:",

    "category": "o",
    "emoji_order": "1879"
  },
  {
    "name": "books",
    "unicode": "\u{1f4da}",
    // "shortname": ":books:",

    "category": "o",
    "emoji_order": "1880"
  },
  {
    "name": "notebook",
    "unicode": "\u{1f4d3}",
    // "shortname": ":notebook:",

    "category": "o",
    "emoji_order": "1881"
  },
  {
    "name": "ledger",
    "unicode": "\u{1f4d2}",
    // "shortname": ":ledger:",

    "category": "o",
    "emoji_order": "1882"
  },
  {
    "name": "page_with_curl",
    "unicode": "\u{1f4c3}",
    // "shortname": ":page_with_curl:",

    "category": "o",
    "emoji_order": "1883"
  },
  {
    "name": "scroll",
    "unicode": "\u{1f4dc}",
    // "shortname": ":scroll:",

    "category": "o",
    "emoji_order": "1884"
  },
  {
    "name": "page_facing_up",
    "unicode": "\u{1f4c4}",
    // "shortname": ":page_facing_up:",

    "category": "o",
    "emoji_order": "1885"
  },
  {
    "name": "newspaper",
    "unicode": "\u{1f4f0}",
    // "shortname": ":newspaper:",

    "category": "o",
    "emoji_order": "1886"
  },
  {
    "name": "rolled_up_newspaper",
    "unicode": "\u{1f5de}",
    // "shortname": ":newspaper2:",

    "category": "o",
    "emoji_order": "1887"
  },
  {
    "name": "bookmark_tabs",
    "unicode": "\u{1f4d1}",
    // "shortname": ":bookmark_tabs:",

    "category": "o",
    "emoji_order": "1888"
  },
  {
    "name": "bookmark",
    "unicode": "\u{1f516}",
    // "shortname": ":bookmark:",

    "category": "o",
    "emoji_order": "1889"
  },
  {
    "name": "label",
    "unicode": "\u{1f3f7}",
    // "shortname": ":label:",

    "category": "o",
    "emoji_order": "1890"
  },
  {
    "name": "moneybag",
    "unicode": "\u{1f4b0}",
    // "shortname": ":moneybag:",

    "category": "o",
    "emoji_order": "1891"
  },
  {
    "name": "yen",
    "unicode": "\u{1f4b4}",
    // "shortname": ":yen:",

    "category": "o",
    "emoji_order": "1892"
  },
  {
    "name": "dollar",
    "unicode": "\u{1f4b5}",
    // "shortname": ":dollar:",

    "category": "o",
    "emoji_order": "1893"
  },
  {
    "name": "euro",
    "unicode": "\u{1f4b6}",
    // "shortname": ":euro:",

    "category": "o",
    "emoji_order": "1894"
  },
  {
    "name": "pound",
    "unicode": "\u{1f4b7}",
    // "shortname": ":pound:",

    "category": "o",
    "emoji_order": "1895"
  },
  {
    "name": "money_with_wings",
    "unicode": "\u{1f4b8}",
    // "shortname": ":money_with_wings:",

    "category": "o",
    "emoji_order": "1896"
  },
  {
    "name": "credit_card",
    "unicode": "\u{1f4b3}",
    // "shortname": ":credit_card:",

    "category": "o",
    "emoji_order": "1897"
  },
  {
    "name": "chart",
    "unicode": "\u{1f4b9}",
    // "shortname": ":chart:",

    "category": "s",
    "emoji_order": "1898"
  },
  {
    "name": "currency_exchange",
    "unicode": "\u{1f4b1}",
    // "shortname": ":currency_exchange:",

    "category": "s",
    "emoji_order": "1899"
  },
  {
    "name": "heavy_dollar_sign",
    "unicode": "\u{1f4b2}",
    // "shortname": ":heavy_dollar_sign:",

    "category": "s",
    "emoji_order": "1900"
  },
  {
    "name": "envelope",
    "unicode": "\u{2709}",
    // "shortname": ":envelope:",

    "category": "o",
    "emoji_order": "1901"
  },
  {
    "name": "e-mail",
    "unicode": "\u{1f4e7}",
    // "shortname": ":e-mail:",

    "category": "o",
    "emoji_order": "1902"
  },
  {
    "name": "incoming_envelope",
    "unicode": "\u{1f4e8}",
    // "shortname": ":incoming_envelope:",

    "category": "o",
    "emoji_order": "1903"
  },
  {
    "name": "envelope_with_arrow",
    "unicode": "\u{1f4e9}",
    // "shortname": ":envelope_with_arrow:",

    "category": "o",
    "emoji_order": "1904"
  },
  {
    "name": "outbox_tray",
    "unicode": "\u{1f4e4}",
    // "shortname": ":outbox_tray:",

    "category": "o",
    "emoji_order": "1905"
  },
  {
    "name": "inbox_tray",
    "unicode": "\u{1f4e5}",
    // "shortname": ":inbox_tray:",

    "category": "o",
    "emoji_order": "1906"
  },
  {
    "name": "package",
    "unicode": "\u{1f4e6}",
    // "shortname": ":package:",

    "category": "o",
    "emoji_order": "1907"
  },
  {
    "name": "mailbox",
    "unicode": "\u{1f4eb}",
    // "shortname": ":mailbox:",

    "category": "o",
    "emoji_order": "1908"
  },
  {
    "name": "mailbox_closed",
    "unicode": "\u{1f4ea}",
    // "shortname": ":mailbox_closed:",

    "category": "o",
    "emoji_order": "1909"
  },
  {
    "name": "mailbox_with_mail",
    "unicode": "\u{1f4ec}",
    // "shortname": ":mailbox_with_mail:",

    "category": "o",
    "emoji_order": "1910"
  },
  {
    "name": "mailbox_with_no_mail",
    "unicode": "\u{1f4ed}",
    // "shortname": ":mailbox_with_no_mail:",

    "category": "o",
    "emoji_order": "1911"
  },
  {
    "name": "postbox",
    "unicode": "\u{1f4ee}",
    // "shortname": ":postbox:",

    "category": "o",
    "emoji_order": "1912"
  },
  {
    "name": "ballot_box_with_ballot",
    "unicode": "\u{1f5f3}",
    // "shortname": ":ballot_box:",

    "category": "o",
    "emoji_order": "1913"
  },
  {
    "name": "pencil2",
    "unicode": "\u{270f}",
    // "shortname": ":pencil2:",

    "category": "o",
    "emoji_order": "1914"
  },
  {
    "name": "black_nib",
    "unicode": "\u{2712}",
    // "shortname": ":black_nib:",

    "category": "o",
    "emoji_order": "1915"
  },
  {
    "name": "lower_left_fountain_pen",
    "unicode": "\u{1f58b}",
    // "shortname": ":pen_fountain:",

    "category": "o",
    "emoji_order": "1916"
  },
  {
    "name": "lower_left_ballpoint_pen",
    "unicode": "\u{1f58a}",
    // "shortname": ":pen_ballpoint:",

    "category": "o",
    "emoji_order": "1917"
  },
  {
    "name": "lower_left_paintbrush",
    "unicode": "\u{1f58c}",
    // "shortname": ":paintbrush:",

    "category": "o",
    "emoji_order": "1918"
  },
  {
    "name": "lower_left_crayon",
    "unicode": "\u{1f58d}",
    // "shortname": ":crayon:",

    "category": "o",
    "emoji_order": "1919"
  },
  {
    "name": "memo",
    "unicode": "\u{1f4dd}",
    // "shortname": ":pencil:",

    "category": "o",
    "emoji_order": "1920"
  },
  {
    "name": "briefcase",
    "unicode": "\u{1f4bc}",
    // "shortname": ":briefcase:",

    "category": "p",
    "emoji_order": "1921"
  },
  {
    "name": "file_folder",
    "unicode": "\u{1f4c1}",
    // "shortname": ":file_folder:",

    "category": "o",
    "emoji_order": "1922"
  },
  {
    "name": "open_file_folder",
    "unicode": "\u{1f4c2}",
    // "shortname": ":open_file_folder:",

    "category": "o",
    "emoji_order": "1923"
  },
  {
    "name": "card_index_dividers",
    "unicode": "\u{1f5c2}",
    // "shortname": ":dividers:",

    "category": "o",
    "emoji_order": "1924"
  },
  {
    "name": "date",
    "unicode": "\u{1f4c5}",
    // "shortname": ":date:",

    "category": "o",
    "emoji_order": "1925"
  },
  {
    "name": "calendar",
    "unicode": "\u{1f4c6}",
    // "shortname": ":calendar:",

    "category": "o",
    "emoji_order": "1926"
  },
  {
    "name": "spiral_note_pad",
    "unicode": "\u{1f5d2}",
    // "shortname": ":notepad_spiral:",

    "category": "o",
    "emoji_order": "1927"
  },
  {
    "name": "spiral_calendar_pad",
    "unicode": "\u{1f5d3}",
    // "shortname": ":calendar_spiral:",

    "category": "o",
    "emoji_order": "1928"
  },
  {
    "name": "card_index",
    "unicode": "\u{1f4c7}",
    // "shortname": ":card_index:",

    "category": "o",
    "emoji_order": "1929"
  },
  {
    "name": "chart_with_upwards_trend",
    "unicode": "\u{1f4c8}",
    // "shortname": ":chart_with_upwards_trend:",

    "category": "o",
    "emoji_order": "1930"
  },
  {
    "name": "chart_with_downwards_trend",
    "unicode": "\u{1f4c9}",
    // "shortname": ":chart_with_downwards_trend:",

    "category": "o",
    "emoji_order": "1931"
  },
  {
    "name": "bar_chart",
    "unicode": "\u{1f4ca}",
    // "shortname": ":bar_chart:",

    "category": "o",
    "emoji_order": "1932"
  },
  {
    "name": "clipboard",
    "unicode": "\u{1f4cb}",
    // "shortname": ":clipboard:",

    "category": "o",
    "emoji_order": "1933"
  },
  {
    "name": "pushpin",
    "unicode": "\u{1f4cc}",
    // "shortname": ":pushpin:",

    "category": "o",
    "emoji_order": "1934"
  },
  {
    "name": "round_pushpin",
    "unicode": "\u{1f4cd}",
    // "shortname": ":round_pushpin:",

    "category": "o",
    "emoji_order": "1935"
  },
  {
    "name": "paperclip",
    "unicode": "\u{1f4ce}",
    // "shortname": ":paperclip:",

    "category": "o",
    "emoji_order": "1936"
  },
  {
    "name": "linked_paperclips",
    "unicode": "\u{1f587}",
    // "shortname": ":paperclips:",

    "category": "o",
    "emoji_order": "1937"
  },
  {
    "name": "straight_ruler",
    "unicode": "\u{1f4cf}",
    // "shortname": ":straight_ruler:",

    "category": "o",
    "emoji_order": "1938"
  },
  {
    "name": "triangular_ruler",
    "unicode": "\u{1f4d0}",
    // "shortname": ":triangular_ruler:",

    "category": "o",
    "emoji_order": "1939"
  },
  {
    "name": "scissors",
    "unicode": "\u{2702}",
    // "shortname": ":scissors:",

    "category": "o",
    "emoji_order": "1940"
  },
  {
    "name": "card_file_box",
    "unicode": "\u{1f5c3}",
    // "shortname": ":card_box:",

    "category": "o",
    "emoji_order": "1941"
  },
  {
    "name": "file_cabinet",
    "unicode": "\u{1f5c4}",
    // "shortname": ":file_cabinet:",

    "category": "o",
    "emoji_order": "1942"
  },
  {
    "name": "wastebasket",
    "unicode": "\u{1f5d1}",
    // "shortname": ":wastebasket:",

    "category": "o",
    "emoji_order": "1943"
  },
  {
    "name": "lock",
    "unicode": "\u{1f512}",
    // "shortname": ":lock:",

    "category": "o",
    "emoji_order": "1944"
  },
  {
    "name": "unlock",
    "unicode": "\u{1f513}",
    // "shortname": ":unlock:",

    "category": "o",
    "emoji_order": "1945"
  },
  {
    "name": "lock_with_ink_pen",
    "unicode": "\u{1f50f}",
    // "shortname": ":lock_with_ink_pen:",

    "category": "o",
    "emoji_order": "1946"
  },
  {
    "name": "closed_lock_with_key",
    "unicode": "\u{1f510}",
    // "shortname": ":closed_lock_with_key:",

    "category": "o",
    "emoji_order": "1947"
  },
  {
    "name": "key",
    "unicode": "\u{1f511}",
    // "shortname": ":key:",

    "category": "o",
    "emoji_order": "1948"
  },
  {
    "name": "old_key",
    "unicode": "\u{1f5dd}",
    // "shortname": ":key2:",

    "category": "o",
    "emoji_order": "1949"
  },
  {
    "name": "hammer",
    "unicode": "\u{1f528}",
    // "shortname": ":hammer:",

    "category": "o",
    "emoji_order": "1950"
  },
  {
    "name": "pick",
    "unicode": "\u{26cf}",
    // "shortname": ":pick:",

    "category": "o",
    "emoji_order": "1951"
  },
  {
    "name": "hammer_and_pick",
    "unicode": "\u{2692}",
    // "shortname": ":hammer_pick:",

    "category": "o",
    "emoji_order": "1952"
  },
  {
    "name": "hammer_and_wrench",
    "unicode": "\u{1f6e0}",
    // "shortname": ":tools:",

    "category": "o",
    "emoji_order": "1953"
  },
  {
    "name": "dagger_knife",
    "unicode": "\u{1f5e1}",
    // "shortname": ":dagger:",

    "category": "o",
    "emoji_order": "1954"
  },
  {
    "name": "crossed_swords",
    "unicode": "\u{2694}",
    // "shortname": ":crossed_swords:",

    "category": "o",
    "emoji_order": "1955"
  },
  {
    "name": "gun",
    "unicode": "\u{1f52b}",
    // "shortname": ":gun:",

    "category": "o",
    "emoji_order": "1956"
  },
  {
    "name": "bow_and_arrow",
    "unicode": "\u{1f3f9}",
    // "shortname": ":bow_and_arrow:",

    "category": "a",
    "emoji_order": "1957"
  },
  {
    "name": "shield",
    "unicode": "\u{1f6e1}",
    // "shortname": ":shield:",

    "category": "o",
    "emoji_order": "1958"
  },
  {
    "name": "wrench",
    "unicode": "\u{1f527}",
    // "shortname": ":wrench:",

    "category": "o",
    "emoji_order": "1959"
  },
  {
    "name": "nut_and_bolt",
    "unicode": "\u{1f529}",
    // "shortname": ":nut_and_bolt:",

    "category": "o",
    "emoji_order": "1960"
  },
  {
    "name": "gear",
    "unicode": "\u{2699}",
    // "shortname": ":gear:",

    "category": "o",
    "emoji_order": "1961"
  },
  {
    "name": "compression",
    "unicode": "\u{1f5dc}",
    // "shortname": ":compression:",

    "category": "o",
    "emoji_order": "1962"
  },
  {
    "name": "alembic",
    "unicode": "\u{2697}",
    // "shortname": ":alembic:",

    "category": "o",
    "emoji_order": "1963"
  },
  {
    "name": "scales",
    "unicode": "\u{2696}",
    // "shortname": ":scales:",

    "category": "o",
    "emoji_order": "1964"
  },
  {
    "name": "link",
    "unicode": "\u{1f517}",
    // "shortname": ":link:",

    "category": "o",
    "emoji_order": "1965"
  },
  {
    "name": "chains",
    "unicode": "\u{26d3}",
    // "shortname": ":chains:",

    "category": "o",
    "emoji_order": "1966"
  },
  {
    "name": "syringe",
    "unicode": "\u{1f489}",
    // "shortname": ":syringe:",

    "category": "o",
    "emoji_order": "1967"
  },
  {
    "name": "pill",
    "unicode": "\u{1f48a}",
    // "shortname": ":pill:",

    "category": "o",
    "emoji_order": "1968"
  },
  {
    "name": "smoking",
    "unicode": "\u{1f6ac}",
    // "shortname": ":smoking:",

    "category": "o",
    "emoji_order": "1969"
  },
  {
    "name": "coffin",
    "unicode": "\u{26b0}",
    // "shortname": ":coffin:",

    "category": "o",
    "emoji_order": "1970"
  },
  {
    "name": "funeral_urn",
    "unicode": "\u{26b1}",
    // "shortname": ":urn:",

    "category": "o",
    "emoji_order": "1971"
  },
  {
    "name": "moyai",
    "unicode": "\u{1f5ff}",
    // "shortname": ":moyai:",

    "category": "o",
    "emoji_order": "1972"
  },
  {
    "name": "oil_drum",
    "unicode": "\u{1f6e2}",
    // "shortname": ":oil:",

    "category": "o",
    "emoji_order": "1973"
  },
  {
    "name": "crystal_ball",
    "unicode": "\u{1f52e}",
    // "shortname": ":crystal_ball:",

    "category": "o",
    "emoji_order": "1974"
  },
  {
    "name": "shopping_cart",
    "unicode": "\u{1f6d2}",
    // "shortname": ":shopping_cart:",

    "category": "o",
    "emoji_order": "1975"
  },
  {
    "name": "atm",
    "unicode": "\u{1f3e7}",
    // "shortname": ":atm:",

    "category": "s",
    "emoji_order": "1976"
  },
  {
    "name": "put_litter_in_its_place",
    "unicode": "\u{1f6ae}",
    // "shortname": ":put_litter_in_its_place:",

    "category": "s",
    "emoji_order": "1977"
  },
  {
    "name": "potable_water",
    "unicode": "\u{1f6b0}",
    // "shortname": ":potable_water:",

    "category": "s",
    "emoji_order": "1978"
  },
  {
    "name": "wheelchair",
    "unicode": "\u{267f}",
    // "shortname": ":wheelchair:",

    "category": "s",
    "emoji_order": "1979"
  },
  {
    "name": "mens",
    "unicode": "\u{1f6b9}",
    // "shortname": ":mens:",

    "category": "s",
    "emoji_order": "1980"
  },
  {
    "name": "womens",
    "unicode": "\u{1f6ba}",
    // "shortname": ":womens:",

    "category": "s",
    "emoji_order": "1981"
  },
  {
    "name": "restroom",
    "unicode": "\u{1f6bb}",
    // "shortname": ":restroom:",

    "category": "s",
    "emoji_order": "1982"
  },
  {
    "name": "baby_symbol",
    "unicode": "\u{1f6bc}",
    // "shortname": ":baby_symbol:",

    "category": "s",
    "emoji_order": "1983"
  },
  {
    "name": "wc",
    "unicode": "\u{1f6be}",
    // "shortname": ":wc:",

    "category": "s",
    "emoji_order": "1984"
  },
  {
    "name": "passport_control",
    "unicode": "\u{1f6c2}",
    // "shortname": ":passport_control:",

    "category": "s",
    "emoji_order": "1985"
  },
  {
    "name": "customs",
    "unicode": "\u{1f6c3}",
    // "shortname": ":customs:",

    "category": "s",
    "emoji_order": "1986"
  },
  {
    "name": "baggage_claim",
    "unicode": "\u{1f6c4}",
    // "shortname": ":baggage_claim:",

    "category": "s",
    "emoji_order": "1987"
  },
  {
    "name": "left_luggage",
    "unicode": "\u{1f6c5}",
    // "shortname": ":left_luggage:",

    "category": "s",
    "emoji_order": "1988"
  },
  {
    "name": "warning",
    "unicode": "\u{26a0}",
    // "shortname": ":warning:",

    "category": "s",
    "emoji_order": "1989"
  },
  {
    "name": "children_crossing",
    "unicode": "\u{1f6b8}",
    // "shortname": ":children_crossing:",

    "category": "s",
    "emoji_order": "1990"
  },
  {
    "name": "no_entry",
    "unicode": "\u{26d4}",
    // "shortname": ":no_entry:",

    "category": "s",
    "emoji_order": "1991"
  },
  {
    "name": "no_entry_sign",
    "unicode": "\u{1f6ab}",
    // "shortname": ":no_entry_sign:",

    "category": "s",
    "emoji_order": "1992"
  },
  {
    "name": "no_bicycles",
    "unicode": "\u{1f6b3}",
    // "shortname": ":no_bicycles:",

    "category": "s",
    "emoji_order": "1993"
  },
  {
    "name": "no_smoking",
    "unicode": "\u{1f6ad}",
    // "shortname": ":no_smoking:",

    "category": "s",
    "emoji_order": "1994"
  },
  {
    "name": "do_not_litter",
    "unicode": "\u{1f6af}",
    // "shortname": ":do_not_litter:",

    "category": "s",
    "emoji_order": "1995"
  },
  {
    "name": "non-potable_water",
    "unicode": "\u{1f6b1}",
    // "shortname": ":non-potable_water:",

    "category": "s",
    "emoji_order": "1996"
  },
  {
    "name": "no_pedestrians",
    "unicode": "\u{1f6b7}",
    // "shortname": ":no_pedestrians:",

    "category": "s",
    "emoji_order": "1997"
  },
  {
    "name": "no_mobile_phones",
    "unicode": "\u{1f4f5}",
    // "shortname": ":no_mobile_phones:",

    "category": "s",
    "emoji_order": "1998"
  },
  {
    "name": "underage",
    "unicode": "\u{1f51e}",
    // "shortname": ":underage:",

    "category": "s",
    "emoji_order": "1999"
  },
  {
    "name": "radioactive",
    "unicode": "\u{2622}",
    // "shortname": ":radioactive:",

    "category": "s",
    "emoji_order": "2000"
  },
  {
    "name": "biohazard",
    "unicode": "\u{2623}",
    // "shortname": ":biohazard:",

    "category": "s",
    "emoji_order": "2001"
  },
  {
    "name": "arrow_up",
    "unicode": "\u{2b06}",
    // "shortname": ":arrow_up:",

    "category": "s",
    "emoji_order": "2002"
  },
  {
    "name": "arrow_upper_right",
    "unicode": "\u{2197}",
    // "shortname": ":arrow_upper_right:",

    "category": "s",
    "emoji_order": "2003"
  },
  {
    "name": "arrow_right",
    "unicode": "\u{27a1}",
    // "shortname": ":arrow_right:",

    "category": "s",
    "emoji_order": "2004"
  },
  {
    "name": "arrow_lower_right",
    "unicode": "\u{2198}",
    // "shortname": ":arrow_lower_right:",

    "category": "s",
    "emoji_order": "2005"
  },
  {
    "name": "arrow_down",
    "unicode": "\u{2b07}",
    // "shortname": ":arrow_down:",

    "category": "s",
    "emoji_order": "2006"
  },
  {
    "name": "arrow_lower_left",
    "unicode": "\u{2199}",
    // "shortname": ":arrow_lower_left:",

    "category": "s",
    "emoji_order": "2007"
  },
  {
    "name": "arrow_left",
    "unicode": "\u{2b05}",
    // "shortname": ":arrow_left:",

    "category": "s",
    "emoji_order": "2008"
  },
  {
    "name": "arrow_upper_left",
    "unicode": "\u{2196}",
    // "shortname": ":arrow_upper_left:",

    "category": "s",
    "emoji_order": "2009"
  },
  {
    "name": "arrow_up_down",
    "unicode": "\u{2195}",
    // "shortname": ":arrow_up_down:",

    "category": "s",
    "emoji_order": "2010"
  },
  {
    "name": "left_right_arrow",
    "unicode": "\u{2194}",
    // "shortname": ":left_right_arrow:",

    "category": "s",
    "emoji_order": "2011"
  },
  {
    "name": "leftwards_arrow_with_hook",
    "unicode": "\u{21a9}",
    // "shortname": ":leftwards_arrow_with_hook:",

    "category": "s",
    "emoji_order": "2012"
  },
  {
    "name": "arrow_right_hook",
    "unicode": "\u{21aa}",
    // "shortname": ":arrow_right_hook:",

    "category": "s",
    "emoji_order": "2013"
  },
  {
    "name": "arrow_heading_up",
    "unicode": "\u{2934}",
    // "shortname": ":arrow_heading_up:",

    "category": "s",
    "emoji_order": "2014"
  },
  {
    "name": "arrow_heading_down",
    "unicode": "\u{2935}",
    // "shortname": ":arrow_heading_down:",

    "category": "s",
    "emoji_order": "2015"
  },
  {
    "name": "arrows_clockwise",
    "unicode": "\u{1f503}",
    // "shortname": ":arrows_clockwise:",

    "category": "s",
    "emoji_order": "2016"
  },
  {
    "name": "arrows_counterclockwise",
    "unicode": "\u{1f504}",
    // "shortname": ":arrows_counterclockwise:",

    "category": "s",
    "emoji_order": "2017"
  },
  {
    "name": "back",
    "unicode": "\u{1f519}",
    // "shortname": ":back:",

    "category": "s",
    "emoji_order": "2018"
  },
  {
    "name": "end",
    "unicode": "\u{1f51a}",
    // "shortname": ":end:",

    "category": "s",
    "emoji_order": "2019"
  },
  {
    "name": "on",
    "unicode": "\u{1f51b}",
    // "shortname": ":on:",

    "category": "s",
    "emoji_order": "2020"
  },
  {
    "name": "soon",
    "unicode": "\u{1f51c}",
    // "shortname": ":soon:",

    "category": "s",
    "emoji_order": "2021"
  },
  {
    "name": "top",
    "unicode": "\u{1f51d}",
    // "shortname": ":top:",

    "category": "s",
    "emoji_order": "2022"
  },
  {
    "name": "place_of_worship",
    "unicode": "\u{1f6d0}",
    // "shortname": ":place_of_worship:",

    "category": "s",
    "emoji_order": "2023"
  },
  {
    "name": "atom_symbol",
    "unicode": "\u{269b}",
    // "shortname": ":atom:",

    "category": "s",
    "emoji_order": "2024"
  },
  {
    "name": "om_symbol",
    "unicode": "\u{1f549}",
    // "shortname": ":om_symbol:",

    "category": "s",
    "emoji_order": "2025"
  },
  {
    "name": "star_of_david",
    "unicode": "\u{2721}",
    // "shortname": ":star_of_david:",

    "category": "s",
    "emoji_order": "2026"
  },
  {
    "name": "wheel_of_dharma",
    "unicode": "\u{2638}",
    // "shortname": ":wheel_of_dharma:",

    "category": "s",
    "emoji_order": "2027"
  },
  {
    "name": "yin_yang",
    "unicode": "\u{262f}",
    // "shortname": ":yin_yang:",

    "category": "s",
    "emoji_order": "2028"
  },
  {
    "name": "latin_cross",
    "unicode": "\u{271d}",
    // "shortname": ":cross:",

    "category": "s",
    "emoji_order": "2029"
  },
  {
    "name": "orthodox_cross",
    "unicode": "\u{2626}",
    // "shortname": ":orthodox_cross:",

    "category": "s",
    "emoji_order": "2030"
  },
  {
    "name": "star_and_crescent",
    "unicode": "\u{262a}",
    // "shortname": ":star_and_crescent:",

    "category": "s",
    "emoji_order": "2031"
  },
  {
    "name": "peace_symbol",
    "unicode": "\u{262e}",
    // "shortname": ":peace:",

    "category": "s",
    "emoji_order": "2032"
  },
  {
    "name": "menorah_with_nine_branches",
    "unicode": "\u{1f54e}",
    // "shortname": ":menorah:",

    "category": "s",
    "emoji_order": "2033"
  },
  {
    "name": "six_pointed_star",
    "unicode": "\u{1f52f}",
    // "shortname": ":six_pointed_star:",

    "category": "s",
    "emoji_order": "2034"
  },
  {
    "name": "aries",
    "unicode": "\u{2648}",
    // "shortname": ":aries:",

    "category": "s",
    "emoji_order": "2035"
  },
  {
    "name": "taurus",
    "unicode": "\u{2649}",
    // "shortname": ":taurus:",

    "category": "s",
    "emoji_order": "2036"
  },
  {
    "name": "gemini",
    "unicode": "\u{264a}",
    // "shortname": ":gemini:",

    "category": "s",
    "emoji_order": "2037"
  },
  {
    "name": "cancer",
    "unicode": "\u{264b}",
    // "shortname": ":cancer:",

    "category": "s",
    "emoji_order": "2038"
  },
  {
    "name": "leo",
    "unicode": "\u{264c}",
    // "shortname": ":leo:",

    "category": "s",
    "emoji_order": "2039"
  },
  {
    "name": "virgo",
    "unicode": "\u{264d}",
    // "shortname": ":virgo:",

    "category": "s",
    "emoji_order": "2040"
  },
  {
    "name": "libra",
    "unicode": "\u{264e}",
    // "shortname": ":libra:",

    "category": "s",
    "emoji_order": "2041"
  },
  {
    "name": "scorpius",
    "unicode": "\u{264f}",
    // "shortname": ":scorpius:",

    "category": "s",
    "emoji_order": "2042"
  },
  {
    "name": "sagittarius",
    "unicode": "\u{2650}",
    // "shortname": ":sagittarius:",

    "category": "s",
    "emoji_order": "2043"
  },
  {
    "name": "capricorn",
    "unicode": "\u{2651}",
    // "shortname": ":capricorn:",

    "category": "s",
    "emoji_order": "2044"
  },
  {
    "name": "aquarius",
    "unicode": "\u{2652}",
    // "shortname": ":aquarius:",

    "category": "s",
    "emoji_order": "2045"
  },
  {
    "name": "pisces",
    "unicode": "\u{2653}",
    // "shortname": ":pisces:",

    "category": "s",
    "emoji_order": "2046"
  },
  {
    "name": "ophiuchus",
    "unicode": "\u{26ce}",
    // "shortname": ":ophiuchus:",

    "category": "s",
    "emoji_order": "2047"
  },
  {
    "name": "twisted_rightwards_arrows",
    "unicode": "\u{1f500}",
    // "shortname": ":twisted_rightwards_arrows:",

    "category": "s",
    "emoji_order": "2048"
  },
  {
    "name": "repeat",
    "unicode": "\u{1f501}",
    // "shortname": ":repeat:",

    "category": "s",
    "emoji_order": "2049"
  },
  {
    "name": "repeat_one",
    "unicode": "\u{1f502}",
    // "shortname": ":repeat_one:",

    "category": "s",
    "emoji_order": "2050"
  },
  {
    "name": "arrow_forward",
    "unicode": "\u{25b6}",
    // "shortname": ":arrow_forward:",

    "category": "s",
    "emoji_order": "2051"
  },
  {
    "name": "fast_forward",
    "unicode": "\u{23e9}",
    // "shortname": ":fast_forward:",

    "category": "s",
    "emoji_order": "2052"
  },
  {
    "name": "black_right_pointing_double_triangle_with_vertical_bar",
    "unicode": "\u{23ed}",
    // "shortname": ":track_next:",

    "category": "s",
    "emoji_order": "2053"
  },
  {
    "name": "black_right_pointing_triangle_with_double_vertical_bar",
    "unicode": "\u{23ef}",
    // "shortname": ":play_pause:",

    "category": "s",
    "emoji_order": "2054"
  },
  {
    "name": "arrow_backward",
    "unicode": "\u{25c0}",
    // "shortname": ":arrow_backward:",

    "category": "s",
    "emoji_order": "2055"
  },
  {
    "name": "rewind",
    "unicode": "\u{23ea}",
    // "shortname": ":rewind:",

    "category": "s",
    "emoji_order": "2056"
  },
  {
    "name": "black_left_pointing_double_triangle_with_vertical_bar",
    "unicode": "\u{23ee}",
    // "shortname": ":track_previous:",

    "category": "s",
    "emoji_order": "2057"
  },
  {
    "name": "arrow_up_small",
    "unicode": "\u{1f53c}",
    // "shortname": ":arrow_up_small:",

    "category": "s",
    "emoji_order": "2058"
  },
  {
    "name": "arrow_double_up",
    "unicode": "\u{23eb}",
    // "shortname": ":arrow_double_up:",

    "category": "s",
    "emoji_order": "2059"
  },
  {
    "name": "arrow_down_small",
    "unicode": "\u{1f53d}",
    // "shortname": ":arrow_down_small:",

    "category": "s",
    "emoji_order": "2060"
  },
  {
    "name": "arrow_double_down",
    "unicode": "\u{23ec}",
    // "shortname": ":arrow_double_down:",

    "category": "s",
    "emoji_order": "2061"
  },
  {
    "name": "double_vertical_bar",
    "unicode": "\u{23f8}",
    // "shortname": ":pause_button:",

    "category": "s",
    "emoji_order": "2062"
  },
  {
    "name": "black_square_for_stop",
    "unicode": "\u{23f9}",
    // "shortname": ":stop_button:",

    "category": "s",
    "emoji_order": "2063"
  },
  {
    "name": "black_circle_for_record",
    "unicode": "\u{23fa}",
    // "shortname": ":record_button:",

    "category": "s",
    "emoji_order": "2064"
  },
  {
    "name": "eject",
    "unicode": "\u{23cf}",
    // "shortname": ":eject:",

    "category": "s",
    "emoji_order": "2065"
  },
  {
    "name": "cinema",
    "unicode": "\u{1f3a6}",
    // "shortname": ":cinema:",

    "category": "s",
    "emoji_order": "2066"
  },
  {
    "name": "low_brightness",
    "unicode": "\u{1f505}",
    // "shortname": ":low_brightness:",

    "category": "s",
    "emoji_order": "2067"
  },
  {
    "name": "high_brightness",
    "unicode": "\u{1f506}",
    // "shortname": ":high_brightness:",

    "category": "s",
    "emoji_order": "2068"
  },
  {
    "name": "signal_strength",
    "unicode": "\u{1f4f6}",
    // "shortname": ":signal_strength:",

    "category": "s",
    "emoji_order": "2069"
  },
  {
    "name": "vibration_mode",
    "unicode": "\u{1f4f3}",
    // "shortname": ":vibration_mode:",

    "category": "s",
    "emoji_order": "2070"
  },
  {
    "name": "mobile_phone_off",
    "unicode": "\u{1f4f4}",
    // "shortname": ":mobile_phone_off:",

    "category": "s",
    "emoji_order": "2071"
  },
  {
    "name": "recycle",
    "unicode": "\u{267b}",
    // "shortname": ":recycle:",

    "category": "s",
    "emoji_order": "2072"
  },
  {
    "name": "name_badge",
    "unicode": "\u{1f4db}",
    // "shortname": ":name_badge:",

    "category": "s",
    "emoji_order": "2073"
  },
  {
    "name": "fleur_de_lis",
    "unicode": "\u{269c}",
    // "shortname": ":fleur-de-lis:",

    "category": "s",
    "emoji_order": "2074"
  },
  {
    "name": "beginner",
    "unicode": "\u{1f530}",
    // "shortname": ":beginner:",

    "category": "s",
    "emoji_order": "2075"
  },
  {
    "name": "trident",
    "unicode": "\u{1f531}",
    // "shortname": ":trident:",

    "category": "s",
    "emoji_order": "2076"
  },
  {
    "name": "o",
    "unicode": "\u{2b55}",
    // "shortname": ":o:",

    "category": "s",
    "emoji_order": "2077"
  },
  {
    "name": "white_check_mark",
    "unicode": "\u{2705}",
    // "shortname": ":white_check_mark:",

    "category": "s",
    "emoji_order": "2078"
  },
  {
    "name": "ballot_box_with_check",
    "unicode": "\u{2611}",
    // "shortname": ":ballot_box_with_check:",

    "category": "s",
    "emoji_order": "2079"
  },
  {
    "name": "heavy_check_mark",
    "unicode": "\u{2714}",
    // "shortname": ":heavy_check_mark:",

    "category": "s",
    "emoji_order": "2080"
  },
  {
    "name": "heavy_multiplication_x",
    "unicode": "\u{2716}",
    // "shortname": ":heavy_multiplication_x:",

    "category": "s",
    "emoji_order": "2081"
  },
  {
    "name": "x",
    "unicode": "\u{274c}",
    // "shortname": ":x:",

    "category": "s",
    "emoji_order": "2082"
  },
  {
    "name": "negative_squared_cross_mark",
    "unicode": "\u{274e}",
    // "shortname": ":negative_squared_cross_mark:",

    "category": "s",
    "emoji_order": "2083"
  },
  {
    "name": "heavy_plus_sign",
    "unicode": "\u{2795}",
    // "shortname": ":heavy_plus_sign:",

    "category": "s",
    "emoji_order": "2084"
  },
  {
    "name": "heavy_minus_sign",
    "unicode": "\u{2796}",
    // "shortname": ":heavy_minus_sign:",

    "category": "s",
    "emoji_order": "2088"
  },
  {
    "name": "heavy_division_sign",
    "unicode": "\u{2797}",
    // "shortname": ":heavy_division_sign:",

    "category": "s",
    "emoji_order": "2089"
  },
  {
    "name": "curly_loop",
    "unicode": "\u{27b0}",
    // "shortname": ":curly_loop:",

    "category": "s",
    "emoji_order": "2090"
  },
  {
    "name": "loop",
    "unicode": "\u{27bf}",
    // "shortname": ":loop:",

    "category": "s",
    "emoji_order": "2091"
  },
  {
    "name": "part_alternation_mark",
    "unicode": "\u{303d}",
    // "shortname": ":part_alternation_mark:",

    "category": "s",
    "emoji_order": "2092"
  },
  {
    "name": "eight_spoked_asterisk",
    "unicode": "\u{2733}",
    // "shortname": ":eight_spoked_asterisk:",

    "category": "s",
    "emoji_order": "2093"
  },
  {
    "name": "eight_pointed_black_star",
    "unicode": "\u{2734}",
    // "shortname": ":eight_pointed_black_star:",

    "category": "s",
    "emoji_order": "2094"
  },
  {
    "name": "sparkle",
    "unicode": "\u{2747}",
    // "shortname": ":sparkle:",

    "category": "s",
    "emoji_order": "2095"
  },
  {
    "name": "bangbang",
    "unicode": "\u{203c}",
    // "shortname": ":bangbang:",

    "category": "s",
    "emoji_order": "2096"
  },
  {
    "name": "interrobang",
    "unicode": "\u{2049}",
    // "shortname": ":interrobang:",

    "category": "s",
    "emoji_order": "2097"
  },
  {
    "name": "question",
    "unicode": "\u{2753}",
    // "shortname": ":question:",

    "category": "s",
    "emoji_order": "2098"
  },
  {
    "name": "grey_question",
    "unicode": "\u{2754}",
    // "shortname": ":grey_question:",

    "category": "s",
    "emoji_order": "2099"
  },
  {
    "name": "grey_exclamation",
    "unicode": "\u{2755}",
    // "shortname": ":grey_exclamation:",

    "category": "s",
    "emoji_order": "2100"
  },
  {
    "name": "exclamation",
    "unicode": "\u{2757}",
    // "shortname": ":exclamation:",

    "category": "s",
    "emoji_order": "2101"
  },
  {
    "name": "wavy_dash",
    "unicode": "\u{3030}",
    // "shortname": ":wavy_dash:",

    "category": "s",
    "emoji_order": "2102"
  },
  {
    "name": "copyright",
    "unicode": "\u{00a9}",
    // "shortname": ":copyright:",

    "category": "s",
    "emoji_order": "2103"
  },
  {
    "name": "registered",
    "unicode": "\u{00ae}",
    // "shortname": ":registered:",

    "category": "s",
    "emoji_order": "2104"
  },
  {
    "name": "tm",
    "unicode": "\u{2122}",
    // "shortname": ":tm:",

    "category": "s",
    "emoji_order": "2105"
  },
  {
    "name": "hash",
    "unicode": "0023-fe0f-20e3",
    // "shortname": ":hash:",

    "category": "s",
    "emoji_order": "2106"
  },
  {
    "name": "keycap_star",
    "unicode": "002a-fe0f-20e3",
    // "shortname": ":asterisk:",

    "category": "s",
    "emoji_order": "2107"
  },
  {
    "name": "zero",
    "unicode": "0030-fe0f-20e3",
    // "shortname": ":zero:",

    "category": "s",
    "emoji_order": "2108"
  },
  {
    "name": "one",
    "unicode": "0031-fe0f-20e3",
    // "shortname": ":one:",

    "category": "s",
    "emoji_order": "2109"
  },
  {
    "name": "two",
    "unicode": "0032-fe0f-20e3",
    // "shortname": ":two:",

    "category": "s",
    "emoji_order": "2110"
  },
  {
    "name": "three",
    "unicode": "0033-fe0f-20e3",
    // "shortname": ":three:",

    "category": "s",
    "emoji_order": "2111"
  },
  {
    "name": "four",
    "unicode": "0034-fe0f-20e3",
    // "shortname": ":four:",

    "category": "s",
    "emoji_order": "2112"
  },
  {
    "name": "five",
    "unicode": "0035-fe0f-20e3",
    // "shortname": ":five:",

    "category": "s",
    "emoji_order": "2113"
  },
  {
    "name": "six",
    "unicode": "0036-fe0f-20e3",
    // "shortname": ":six:",

    "category": "s",
    "emoji_order": "2114"
  },
  {
    "name": "seven",
    "unicode": "0037-fe0f-20e3",
    // "shortname": ":seven:",

    "category": "s",
    "emoji_order": "2115"
  },
  {
    "name": "eight",
    "unicode": "0038-fe0f-20e3",
    // "shortname": ":eight:",

    "category": "s",
    "emoji_order": "2116"
  },
  {
    "name": "nine",
    "unicode": "0039-fe0f-20e3",
    // "shortname": ":nine:",

    "category": "s",
    "emoji_order": "2117"
  },
  {
    "name": "keycap_ten",
    "unicode": "\u{1f51f}",
    // "shortname": ":keycap_ten:",

    "category": "s",
    "emoji_order": "2118"
  },
  {
    "name": "capital_abcd",
    "unicode": "\u{1f520}",
    // "shortname": ":capital_abcd:",

    "category": "s",
    "emoji_order": "2120"
  },
  {
    "name": "abcd",
    "unicode": "\u{1f521}",
    // "shortname": ":abcd:",

    "category": "s",
    "emoji_order": "2121"
  },
  {
    "name": "s",
    "unicode": "\u{1f523}",
    // "shortname": ":s:",

    "category": "s",
    "emoji_order": "2123"
  },
  {
    "name": "abc",
    "unicode": "\u{1f524}",
    // "shortname": ":abc:",

    "category": "s",
    "emoji_order": "2124"
  },
  {
    "name": "a",
    "unicode": "\u{1f170}",
    // "shortname": ":a:",

    "category": "s",
    "emoji_order": "2125"
  },
  {
    "name": "ab",
    "unicode": "\u{1f18e}",
    // "shortname": ":ab:",

    "category": "s",
    "emoji_order": "2126"
  },
  {
    "name": "b",
    "unicode": "\u{1f171}",
    // "shortname": ":b:",

    "category": "s",
    "emoji_order": "2127"
  },
  {
    "name": "cl",
    "unicode": "\u{1f191}",
    // "shortname": ":cl:",

    "category": "s",
    "emoji_order": "2128"
  },
  {
    "name": "cool",
    "unicode": "\u{1f192}",
    // "shortname": ":cool:",

    "category": "s",
    "emoji_order": "2129"
  },
  {
    "name": "free",
    "unicode": "\u{1f193}",
    // "shortname": ":free:",

    "category": "s",
    "emoji_order": "2130"
  },
  {
    "name": "information_source",
    "unicode": "\u{2139}",
    // "shortname": ":information_source:",

    "category": "s",
    "emoji_order": "2131"
  },
  {
    "name": "id",
    "unicode": "\u{1f194}",
    // "shortname": ":id:",

    "category": "s",
    "emoji_order": "2132"
  },
  {
    "name": "m",
    "unicode": "\u{24c2}",
    // "shortname": ":m:",

    "category": "s",
    "emoji_order": "2133"
  },
  {
    "name": "new",
    "unicode": "\u{1f195}",
    // "shortname": ":new:",

    "category": "s",
    "emoji_order": "2134"
  },
  {
    "name": "ng",
    "unicode": "\u{1f196}",
    // "shortname": ":ng:",

    "category": "s",
    "emoji_order": "2135"
  },
  {
    "name": "o2",
    "unicode": "\u{1f17e}",
    // "shortname": ":o2:",

    "category": "s",
    "emoji_order": "2136"
  },
  {
    "name": "ok",
    "unicode": "\u{1f197}",
    // "shortname": ":ok:",

    "category": "s",
    "emoji_order": "2137"
  },
  {
    "name": "parking",
    "unicode": "\u{1f17f}",
    // "shortname": ":parking:",

    "category": "s",
    "emoji_order": "2138"
  },
  {
    "name": "sos",
    "unicode": "\u{1f198}",
    // "shortname": ":sos:",

    "category": "s",
    "emoji_order": "2139"
  },
  {
    "name": "up",
    "unicode": "\u{1f199}",
    // "shortname": ":up:",

    "category": "s",
    "emoji_order": "2140"
  },
  {
    "name": "vs",
    "unicode": "\u{1f19a}",
    // "shortname": ":vs:",

    "category": "s",
    "emoji_order": "2141"
  },
  {
    "name": "koko",
    "unicode": "\u{1f201}",
    // "shortname": ":koko:",

    "category": "s",
    "emoji_order": "2142"
  },
  {
    "name": "sa",
    "unicode": "\u{1f202}",
    // "shortname": ":sa:",

    "category": "s",
    "emoji_order": "2143"
  },
  {
    "name": "u6708",
    "unicode": "\u{1f237}",
    // "shortname": ":u6708:",

    "category": "s",
    "emoji_order": "2144"
  },
  {
    "name": "u6709",
    "unicode": "\u{1f236}",
    // "shortname": ":u6709:",

    "category": "s",
    "emoji_order": "2145"
  },
  {
    "name": "u6307",
    "unicode": "\u{1f22f}",
    // "shortname": ":u6307:",

    "category": "s",
    "emoji_order": "2146"
  },
  {
    "name": "ideograph_advantage",
    "unicode": "\u{1f250}",
    // "shortname": ":ideograph_advantage:",

    "category": "s",
    "emoji_order": "2147"
  },
  {
    "name": "u5272",
    "unicode": "\u{1f239}",
    // "shortname": ":u5272:",

    "category": "s",
    "emoji_order": "2148"
  },
  {
    "name": "u7121",
    "unicode": "\u{1f21a}",
    // "shortname": ":u7121:",

    "category": "s",
    "emoji_order": "2149"
  },
  {
    "name": "u7981",
    "unicode": "\u{1f232}",
    // "shortname": ":u7981:",

    "category": "s",
    "emoji_order": "2150"
  },
  {
    "name": "accept",
    "unicode": "\u{1f251}",
    // "shortname": ":accept:",

    "category": "s",
    "emoji_order": "2151"
  },
  {
    "name": "u7533",
    "unicode": "\u{1f238}",
    // "shortname": ":u7533:",

    "category": "s",
    "emoji_order": "2152"
  },
  {
    "name": "u5408",
    "unicode": "\u{1f234}",
    // "shortname": ":u5408:",

    "category": "s",
    "emoji_order": "2153"
  },
  {
    "name": "u7a7a",
    "unicode": "\u{1f233}",
    // "shortname": ":u7a7a:",

    "category": "s",
    "emoji_order": "2154"
  },
  {
    "name": "congratulations",
    "unicode": "\u{3297}",
    // "shortname": ":congratulations:",

    "category": "s",
    "emoji_order": "2155"
  },
  {
    "name": "secret",
    "unicode": "\u{3299}",
    // "shortname": ":secret:",

    "category": "s",
    "emoji_order": "2156"
  },
  {
    "name": "u55b6",
    "unicode": "\u{1f23a}",
    // "shortname": ":u55b6:",

    "category": "s",
    "emoji_order": "2157"
  },
  {
    "name": "u6e80",
    "unicode": "\u{1f235}",
    // "shortname": ":u6e80:",

    "category": "s",
    "emoji_order": "2158"
  },
  {
    "name": "black_small_square",
    "unicode": "\u{25aa}",
    // "shortname": ":black_small_square:",

    "category": "s",
    "emoji_order": "2159"
  },
  {
    "name": "white_small_square",
    "unicode": "\u{25ab}",
    // "shortname": ":white_small_square:",

    "category": "s",
    "emoji_order": "2160"
  },
  {
    "name": "white_medium_square",
    "unicode": "\u{25fb}",
    // "shortname": ":white_medium_square:",

    "category": "s",
    "emoji_order": "2161"
  },
  {
    "name": "black_medium_square",
    "unicode": "\u{25fc}",
    // "shortname": ":black_medium_square:",

    "category": "s",
    "emoji_order": "2162"
  },
  {
    "name": "white_medium_small_square",
    "unicode": "\u{25fd}",
    // "shortname": ":white_medium_small_square:",

    "category": "s",
    "emoji_order": "2163"
  },
  {
    "name": "black_medium_small_square",
    "unicode": "\u{25fe}",
    // "shortname": ":black_medium_small_square:",

    "category": "s",
    "emoji_order": "2164"
  },
  {
    "name": "black_large_square",
    "unicode": "\u{2b1b}",
    // "shortname": ":black_large_square:",

    "category": "s",
    "emoji_order": "2165"
  },
  {
    "name": "white_large_square",
    "unicode": "\u{2b1c}",
    // "shortname": ":white_large_square:",

    "category": "s",
    "emoji_order": "2166"
  },
  {
    "name": "large_orange_diamond",
    "unicode": "\u{1f536}",
    // "shortname": ":large_orange_diamond:",

    "category": "s",
    "emoji_order": "2167"
  },
  {
    "name": "large_blue_diamond",
    "unicode": "\u{1f537}",
    // "shortname": ":large_blue_diamond:",

    "category": "s",
    "emoji_order": "2168"
  },
  {
    "name": "small_orange_diamond",
    "unicode": "\u{1f538}",
    // "shortname": ":small_orange_diamond:",

    "category": "s",
    "emoji_order": "2169"
  },
  {
    "name": "small_blue_diamond",
    "unicode": "\u{1f539}",
    // "shortname": ":small_blue_diamond:",

    "category": "s",
    "emoji_order": "2170"
  },
  {
    "name": "small_red_triangle",
    "unicode": "\u{1f53a}",
    // "shortname": ":small_red_triangle:",

    "category": "s",
    "emoji_order": "2171"
  },
  {
    "name": "small_red_triangle_down",
    "unicode": "\u{1f53b}",
    // "shortname": ":small_red_triangle_down:",

    "category": "s",
    "emoji_order": "2172"
  },
  {
    "name": "diamond_shape_with_a_dot_inside",
    "unicode": "\u{1f4a0}",
    // "shortname": ":diamond_shape_with_a_dot_inside:",

    "category": "s",
    "emoji_order": "2173"
  },
  {
    "name": "radio_button",
    "unicode": "\u{1f518}",
    // "shortname": ":radio_button:",

    "category": "s",
    "emoji_order": "2174"
  },
  {
    "name": "black_square_button",
    "unicode": "\u{1f532}",
    // "shortname": ":black_square_button:",

    "category": "s",
    "emoji_order": "2175"
  },
  {
    "name": "white_square_button",
    "unicode": "\u{1f533}",
    // "shortname": ":white_square_button:",

    "category": "s",
    "emoji_order": "2176"
  },
  {
    "name": "white_circle",
    "unicode": "\u{26aa}",
    // "shortname": ":white_circle:",

    "category": "s",
    "emoji_order": "2177"
  },
  {
    "name": "black_circle",
    "unicode": "\u{26ab}",
    // "shortname": ":black_circle:",

    "category": "s",
    "emoji_order": "2178"
  },
  {
    "name": "red_circle",
    "unicode": "\u{1f534}",
    // "shortname": ":red_circle:",

    "category": "s",
    "emoji_order": "2179"
  },
  {
    "name": "large_blue_circle",
    "unicode": "\u{1f535}",
    // "shortname": ":blue_circle:",

    "category": "s",
    "emoji_order": "2180"
  },
  {
    "name": "checkered_flag",
    "unicode": "\u{1f3c1}",
    // "shortname": ":checkered_flag:",

    "category": "t",
    "emoji_order": "2181"
  },
  {
    "name": "triangular_flag_on_post",
    "unicode": "\u{1f6a9}",
    // "shortname": ":triangular_flag_on_post:",

    "category": "o",
    "emoji_order": "2182"
  },
  {
    "name": "crossed_flags",
    "unicode": "\u{1f38c}",
    // "shortname": ":crossed_flags:",

    "category": "o",
    "emoji_order": "2183"
  },
  {
    "name": "waving_black_flag",
    "unicode": "\u{1f3f4}",
    // "shortname": ":flag_black:",

    "category": "o",
    "emoji_order": "2184"
  },
  {
    "name": "waving_white_flag",
    "unicode": "\u{1f3f3}",
    // "shortname": ":flag_white:",

    "category": "o",
    "emoji_order": "2185"
  },
  {
    "name": "flag-ac",
    "unicode": "1f1e6-1f1e8",
    // "shortname": ":flag_ac:",

    "category": "f",
    "emoji_order": "2187"
  },
  {
    "name": "flag-ad",
    "unicode": "1f1e6-1f1e9",
    // "shortname": ":flag_ad:",

    "category": "f",
    "emoji_order": "2188"
  },
  {
    "name": "flag-ae",
    "unicode": "1f1e6-1f1ea",
    // "shortname": ":flag_ae:",

    "category": "f",
    "emoji_order": "2189"
  },
  {
    "name": "flag-af",
    "unicode": "1f1e6-1f1eb",
    // "shortname": ":flag_af:",

    "category": "f",
    "emoji_order": "2190"
  },
  {
    "name": "flag-ag",
    "unicode": "1f1e6-1f1ec",
    // "shortname": ":flag_ag:",

    "category": "f",
    "emoji_order": "2191"
  },
  {
    "name": "flag-ai",
    "unicode": "1f1e6-1f1ee",
    // "shortname": ":flag_ai:",

    "category": "f",
    "emoji_order": "2192"
  },
  {
    "name": "flag-al",
    "unicode": "1f1e6-1f1f1",
    // "shortname": ":flag_al:",

    "category": "f",
    "emoji_order": "2193"
  },
  {
    "name": "flag-am",
    "unicode": "1f1e6-1f1f2",
    // "shortname": ":flag_am:",

    "category": "f",
    "emoji_order": "2194"
  },
  {
    "name": "flag-ao",
    "unicode": "1f1e6-1f1f4",
    // "shortname": ":flag-ao:",

    "category": "f",
    "emoji_order": "2195"
  },
  {
    "name": "flag-aq",
    "unicode": "1f1e6-1f1f6",
    // "shortname": ":flag-aq:",

    "category": "f",
    "emoji_order": "2196"
  },
  {
    "name": "flag-ar",
    "unicode": "1f1e6-1f1f7",
    // "shortname": ":flag-ar:",

    "category": "f",
    "emoji_order": "2197"
  },
  {
    "name": "flag-as",
    "unicode": "1f1e6-1f1f8",
    // "shortname": ":flag-as:",

    "category": "f",
    "emoji_order": "2198"
  },
  {
    "name": "flag-at",
    "unicode": "1f1e6-1f1f9",
    // "shortname": ":flag-at:",

    "category": "f",
    "emoji_order": "2199"
  },
  {
    "name": "flag-au",
    "unicode": "1f1e6-1f1fa",
    // "shortname": ":flag-au:",

    "category": "f",
    "emoji_order": "2200"
  },
  {
    "name": "flag-aw",
    "unicode": "1f1e6-1f1fc",
    // "shortname": ":flag-aw:",

    "category": "f",
    "emoji_order": "2201"
  },
  {
    "name": "flag-ax",
    "unicode": "1f1e6-1f1fd",
    // "shortname": ":flag-ax:",

    "category": "f",
    "emoji_order": "2202"
  },
  {
    "name": "flag-az",
    "unicode": "1f1e6-1f1ff",
    // "shortname": ":flag-az:",

    "category": "f",
    "emoji_order": "2203"
  },
  {
    "name": "flag-ba",
    "unicode": "1f1e7-1f1e6",
    // "shortname": ":flag-ba:",

    "category": "f",
    "emoji_order": "2204"
  },
  {
    "name": "flag-bb",
    "unicode": "1f1e7-1f1e7",
    // "shortname": ":flag-bb:",

    "category": "f",
    "emoji_order": "2205"
  },
  {
    "name": "flag-bd",
    "unicode": "1f1e7-1f1e9",
    // "shortname": ":flag-bd:",

    "category": "f",
    "emoji_order": "2206"
  },
  {
    "name": "flag-be",
    "unicode": "1f1e7-1f1ea",
    // "shortname": ":flag-be:",

    "category": "f",
    "emoji_order": "2207"
  },
  {
    "name": "flag-bf",
    "unicode": "1f1e7-1f1eb",
    // "shortname": ":flag-bf:",

    "category": "f",
    "emoji_order": "2208"
  },
  {
    "name": "flag-bg",
    "unicode": "1f1e7-1f1ec",
    // "shortname": ":flag-bg:",

    "category": "f",
    "emoji_order": "2209"
  },
  {
    "name": "flag-bh",
    "unicode": "1f1e7-1f1ed",
    // "shortname": ":flag-bh:",

    "category": "f",
    "emoji_order": "2210"
  },
  {
    "name": "flag-bi",
    "unicode": "1f1e7-1f1ee",
    // "shortname": ":flag-bi:",

    "category": "f",
    "emoji_order": "2211"
  },
  {
    "name": "flag-bj",
    "unicode": "1f1e7-1f1ef",
    // "shortname": ":flag-bj:",

    "category": "f",
    "emoji_order": "2212"
  },
  {
    "name": "flag-bl",
    "unicode": "1f1e7-1f1f1",
    // "shortname": ":flag-bl:",

    "category": "f",
    "emoji_order": "2213"
  },
  {
    "name": "flag-bm",
    "unicode": "1f1e7-1f1f2",
    // "shortname": ":flag-bm:",

    "category": "f",
    "emoji_order": "2214"
  },
  {
    "name": "flag-bn",
    "unicode": "1f1e7-1f1f3",
    // "shortname": ":flag-bn:",

    "category": "f",
    "emoji_order": "2215"
  },
  {
    "name": "flag-bo",
    "unicode": "1f1e7-1f1f4",
    // "shortname": ":flag-bo:",

    "category": "f",
    "emoji_order": "2216"
  },
  {
    "name": "flag-bq",
    "unicode": "1f1e7-1f1f6",
    // "shortname": ":flag-bq:",

    "category": "f",
    "emoji_order": "2217"
  },
  {
    "name": "flag-br",
    "unicode": "1f1e7-1f1f7",
    // "shortname": ":flag-br:",

    "category": "f",
    "emoji_order": "2218"
  },
  {
    "name": "flag-bs",
    "unicode": "1f1e7-1f1f8",
    // "shortname": ":flag-bs:",

    "category": "f",
    "emoji_order": "2219"
  },
  {
    "name": "flag-bt",
    "unicode": "1f1e7-1f1f9",
    // "shortname": ":flag-bt:",

    "category": "f",
    "emoji_order": "2220"
  },
  {
    "name": "flag-bv",
    "unicode": "1f1e7-1f1fb",
    // "shortname": ":flag-bv:",

    "category": "f",
    "emoji_order": "2221"
  },
  {
    "name": "flag-bw",
    "unicode": "1f1e7-1f1fc",
    // "shortname": ":flag-bw:",

    "category": "f",
    "emoji_order": "2222"
  },
  {
    "name": "flag-by",
    "unicode": "1f1e7-1f1fe",
    // "shortname": ":flag-by:",

    "category": "f",
    "emoji_order": "2223"
  },
  {
    "name": "flag-bz",
    "unicode": "1f1e7-1f1ff",
    // "shortname": ":flag-bz:",

    "category": "f",
    "emoji_order": "2224"
  },
  {
    "name": "flag-ca",
    "unicode": "1f1e8-1f1e6",
    // "shortname": ":flag-ca:",

    "category": "f",
    "emoji_order": "2225"
  },
  {
    "name": "flag-cc",
    "unicode": "1f1e8-1f1e8",
    // "shortname": ":flag-cc:",

    "category": "f",
    "emoji_order": "2226"
  },
  {
    "name": "flag-cd",
    "unicode": "1f1e8-1f1e9",
    // "shortname": ":flag-cd:",

    "category": "f",
    "emoji_order": "2227"
  },
  {
    "name": "flag-cf",
    "unicode": "1f1e8-1f1eb",
    // "shortname": ":flag-cf:",

    "category": "f",
    "emoji_order": "2228"
  },
  {
    "name": "flag-cg",
    "unicode": "1f1e8-1f1ec",
    // "shortname": ":flag-cg:",

    "category": "f",
    "emoji_order": "2229"
  },
  {
    "name": "flag-ch",
    "unicode": "1f1e8-1f1ed",
    // "shortname": ":flag-ch:",

    "category": "f",
    "emoji_order": "2230"
  },
  {
    "name": "flag-ci",
    "unicode": "1f1e8-1f1ee",
    // "shortname": ":flag-ci:",

    "category": "f",
    "emoji_order": "2231"
  },
  {
    "name": "flag-ck",
    "unicode": "1f1e8-1f1f0",
    // "shortname": ":flag-ck:",

    "category": "f",
    "emoji_order": "2232"
  },
  {
    "name": "flag-cl",
    "unicode": "1f1e8-1f1f1",
    // "shortname": ":flag-cl:",

    "category": "f",
    "emoji_order": "2233"
  },
  {
    "name": "flag-cm",
    "unicode": "1f1e8-1f1f2",
    // "shortname": ":flag-cm:",

    "category": "f",
    "emoji_order": "2234"
  },
  {
    "name": "flag-cn",
    "unicode": "1f1e8-1f1f3",
    // "shortname": ":flag-cn:",

    "category": "f",
    "emoji_order": "2235"
  },
  {
    "name": "flag-co",
    "unicode": "1f1e8-1f1f4",
    // "shortname": ":flag-co:",

    "category": "f",
    "emoji_order": "2236"
  },
  {
    "name": "flag-cp",
    "unicode": "1f1e8-1f1f5",
    // "shortname": ":flag-cp:",

    "category": "f",
    "emoji_order": "2237"
  },
  {
    "name": "flag-cr",
    "unicode": "1f1e8-1f1f7",
    // "shortname": ":flag-cr:",

    "category": "f",
    "emoji_order": "2238"
  },
  {
    "name": "flag-cu",
    "unicode": "1f1e8-1f1fa",
    // "shortname": ":flag-cu:",

    "category": "f",
    "emoji_order": "2239"
  },
  {
    "name": "flag-cv",
    "unicode": "1f1e8-1f1fb",
    // "shortname": ":flag-cv:",

    "category": "f",
    "emoji_order": "2240"
  },
  {
    "name": "flag-cw",
    "unicode": "1f1e8-1f1fc",
    // "shortname": ":flag-cw:",

    "category": "f",
    "emoji_order": "2241"
  },
  {
    "name": "flag-cx",
    "unicode": "1f1e8-1f1fd",
    // "shortname": ":flag-cx:",

    "category": "f",
    "emoji_order": "2242"
  },
  {
    "name": "flag-cy",
    "unicode": "1f1e8-1f1fe",
    // "shortname": ":flag-cy:",

    "category": "f",
    "emoji_order": "2243"
  },
  {
    "name": "flag-cz",
    "unicode": "1f1e8-1f1ff",
    // "shortname": ":flag-cz:",

    "category": "f",
    "emoji_order": "2244"
  },
  {
    "name": "flag-de",
    "unicode": "1f1e9-1f1ea",
    // "shortname": ":flag-de:",

    "category": "f",
    "emoji_order": "2245"
  },
  {
    "name": "flag-dg",
    "unicode": "1f1e9-1f1ec",
    // "shortname": ":flag-dg:",

    "category": "f",
    "emoji_order": "2246"
  },
  {
    "name": "flag-dj",
    "unicode": "1f1e9-1f1ef",
    // "shortname": ":flag-dj:",

    "category": "f",
    "emoji_order": "2247"
  },
  {
    "name": "flag-dk",
    "unicode": "1f1e9-1f1f0",
    // "shortname": ":flag-dk:",

    "category": "f",
    "emoji_order": "2248"
  },
  {
    "name": "flag-dm",
    "unicode": "1f1e9-1f1f2",
    // "shortname": ":flag-dm:",

    "category": "f",
    "emoji_order": "2249"
  },
  {
    "name": "flag-do",
    "unicode": "1f1e9-1f1f4",
    // "shortname": ":flag-do:",

    "category": "f",
    "emoji_order": "2250"
  },
  {
    "name": "flag-dz",
    "unicode": "1f1e9-1f1ff",
    // "shortname": ":flag-dz:",

    "category": "f",
    "emoji_order": "2251"
  },
  {
    "name": "flag-ea",
    "unicode": "1f1ea-1f1e6",
    // "shortname": ":flag-ea:",

    "category": "f",
    "emoji_order": "2252"
  },
  {
    "name": "flag-ec",
    "unicode": "1f1ea-1f1e8",
    // "shortname": ":flag-ec:",

    "category": "f",
    "emoji_order": "2253"
  },
  {
    "name": "flag-ee",
    "unicode": "1f1ea-1f1ea",
    // "shortname": ":flag-ee:",

    "category": "f",
    "emoji_order": "2254"
  },
  {
    "name": "flag-eg",
    "unicode": "1f1ea-1f1ec",
    // "shortname": ":flag-eg:",

    "category": "f",
    "emoji_order": "2255"
  },
  {
    "name": "flag-eh",
    "unicode": "1f1ea-1f1ed",
    // "shortname": ":flag-eh:",

    "category": "f",
    "emoji_order": "2256"
  },
  {
    "name": "flag-er",
    "unicode": "1f1ea-1f1f7",
    // "shortname": ":flag-er:",

    "category": "f",
    "emoji_order": "2257"
  },
  {
    "name": "flag-es",
    "unicode": "1f1ea-1f1f8",
    // "shortname": ":flag-es:",

    "category": "f",
    "emoji_order": "2258"
  },
  {
    "name": "flag-et",
    "unicode": "1f1ea-1f1f9",
    // "shortname": ":flag-et:",

    "category": "f",
    "emoji_order": "2259"
  },
  {
    "name": "flag-eu",
    "unicode": "1f1ea-1f1fa",
    // "shortname": ":flag-eu:",

    "category": "f",
    "emoji_order": "2260"
  },
  {
    "name": "flag-fi",
    "unicode": "1f1eb-1f1ee",
    // "shortname": ":flag-fi:",

    "category": "f",
    "emoji_order": "2261"
  },
  {
    "name": "flag-fj",
    "unicode": "1f1eb-1f1ef",
    // "shortname": ":flag-fj:",

    "category": "f",
    "emoji_order": "2262"
  },
  {
    "name": "flag-fk",
    "unicode": "1f1eb-1f1f0",
    // "shortname": ":flag-fk:",

    "category": "f",
    "emoji_order": "2263"
  },
  {
    "name": "flag-fm",
    "unicode": "1f1eb-1f1f2",
    // "shortname": ":flag-fm:",

    "category": "f",
    "emoji_order": "2264"
  },
  {
    "name": "flag-fo",
    "unicode": "1f1eb-1f1f4",
    // "shortname": ":flag-fo:",

    "category": "f",
    "emoji_order": "2265"
  },
  {
    "name": "flag-fr",
    "unicode": "1f1eb-1f1f7",
    // "shortname": ":flag-fr:",

    "category": "f",
    "emoji_order": "2266"
  },
  {
    "name": "flag-ga",
    "unicode": "1f1ec-1f1e6",
    // "shortname": ":flag-ga:",

    "category": "f",
    "emoji_order": "2267"
  },
  {
    "name": "flag-gb",
    "unicode": "1f1ec-1f1e7",
    // "shortname": ":flag-gb:",

    "category": "f",
    "emoji_order": "2268"
  },
  {
    "name": "flag-gd",
    "unicode": "1f1ec-1f1e9",
    // "shortname": ":flag-gd:",

    "category": "f",
    "emoji_order": "2269"
  },
  {
    "name": "flag-ge",
    "unicode": "1f1ec-1f1ea",
    // "shortname": ":flag-ge:",

    "category": "f",
    "emoji_order": "2270"
  },
  {
    "name": "flag-gf",
    "unicode": "1f1ec-1f1eb",
    // "shortname": ":flag-gf:",

    "category": "f",
    "emoji_order": "2271"
  },
  {
    "name": "flag-gg",
    "unicode": "1f1ec-1f1ec",
    // "shortname": ":flag-gg:",

    "category": "f",
    "emoji_order": "2272"
  },
  {
    "name": "flag-gh",
    "unicode": "1f1ec-1f1ed",
    // "shortname": ":flag-gh:",

    "category": "f",
    "emoji_order": "2273"
  },
  {
    "name": "flag-gi",
    "unicode": "1f1ec-1f1ee",
    // "shortname": ":flag-gi:",

    "category": "f",
    "emoji_order": "2274"
  },
  {
    "name": "flag-gl",
    "unicode": "1f1ec-1f1f1",
    // "shortname": ":flag-gl:",

    "category": "f",
    "emoji_order": "2275"
  },
  {
    "name": "flag-gm",
    "unicode": "1f1ec-1f1f2",
    // "shortname": ":flag-gm:",

    "category": "f",
    "emoji_order": "2276"
  },
  {
    "name": "flag-gn",
    "unicode": "1f1ec-1f1f3",
    // "shortname": ":flag-gn:",

    "category": "f",
    "emoji_order": "2277"
  },
  {
    "name": "flag-gp",
    "unicode": "1f1ec-1f1f5",
    // "shortname": ":flag-gp:",

    "category": "f",
    "emoji_order": "2278"
  },
  {
    "name": "flag-gq",
    "unicode": "1f1ec-1f1f6",
    // "shortname": ":flag-gq:",

    "category": "f",
    "emoji_order": "2279"
  },
  {
    "name": "flag-gr",
    "unicode": "1f1ec-1f1f7",
    // "shortname": ":flag-gr:",

    "category": "f",
    "emoji_order": "2280"
  },
  {
    "name": "flag-gs",
    "unicode": "1f1ec-1f1f8",
    // "shortname": ":flag-gs:",

    "category": "f",
    "emoji_order": "2281"
  },
  {
    "name": "flag-gt",
    "unicode": "1f1ec-1f1f9",
    // "shortname": ":flag-gt:",

    "category": "f",
    "emoji_order": "2282"
  },
  {
    "name": "flag-gu",
    "unicode": "1f1ec-1f1fa",
    // "shortname": ":flag-gu:",

    "category": "f",
    "emoji_order": "2283"
  },
  {
    "name": "flag-gw",
    "unicode": "1f1ec-1f1fc",
    // "shortname": ":flag-gw:",

    "category": "f",
    "emoji_order": "2284"
  },
  {
    "name": "flag-gy",
    "unicode": "1f1ec-1f1fe",
    // "shortname": ":flag-gy:",

    "category": "f",
    "emoji_order": "2285"
  },
  {
    "name": "flag-hk",
    "unicode": "1f1ed-1f1f0",
    // "shortname": ":flag-hk:",

    "category": "f",
    "emoji_order": "2286"
  },
  {
    "name": "flag-hm",
    "unicode": "1f1ed-1f1f2",
    // "shortname": ":flag-hm:",

    "category": "f",
    "emoji_order": "2287"
  },
  {
    "name": "flag-hn",
    "unicode": "1f1ed-1f1f3",
    // "shortname": ":flag-hn:",

    "category": "f",
    "emoji_order": "2288"
  },
  {
    "name": "flag-hr",
    "unicode": "1f1ed-1f1f7",
    // "shortname": ":flag-hr:",

    "category": "f",
    "emoji_order": "2289"
  },
  {
    "name": "flag-ht",
    "unicode": "1f1ed-1f1f9",
    // "shortname": ":flag-ht:",

    "category": "f",
    "emoji_order": "2290"
  },
  {
    "name": "flag-hu",
    "unicode": "1f1ed-1f1fa",
    // "shortname": ":flag-hu:",

    "category": "f",
    "emoji_order": "2291"
  },
  {
    "name": "flag-ic",
    "unicode": "1f1ee-1f1e8",
    // "shortname": ":flag-ic:",

    "category": "f",
    "emoji_order": "2292"
  },
  {
    "name": "flag-id",
    "unicode": "1f1ee-1f1e9",
    // "shortname": ":flag-id:",

    "category": "f",
    "emoji_order": "2293"
  },
  {
    "name": "flag-ie",
    "unicode": "1f1ee-1f1ea",
    // "shortname": ":flag-ie:",

    "category": "f",
    "emoji_order": "2294"
  },
  {
    "name": "flag-il",
    "unicode": "1f1ee-1f1f1",
    // "shortname": ":flag-il:",

    "category": "f",
    "emoji_order": "2295"
  },



  {
    "name": "flag-im",
    "unicode": "1f1ee-1f1f2",
    // "shortname": ":flag-im:",

    "category": "f",
    "emoji_order": "2296"
  },
  {
    "name": "flag-in",
    "unicode": "1f1ee-1f1f3",
    // "shortname": ":flag-in:",

    "category": "f",
    "emoji_order": "2297"
  },
  {
    "name": "flag-io",
    "unicode": "1f1ee-1f1f4",
    // "shortname": ":flag-io:",

    "category": "f",
    "emoji_order": "2298"
  },
  {
    "name": "flag-iq",
    "unicode": "1f1ee-1f1f6",
    // "shortname": ":flag-iq:",

    "category": "f",
    "emoji_order": "2299"
  },
  {
    "name": "flag-ir",
    "unicode": "1f1ee-1f1f7",
    // "shortname": ":flag-ir:",

    "category": "f",
    "emoji_order": "2300"
  },
  {
    "name": "flag-is",
    "unicode": "1f1ee-1f1f8",
    // "shortname": ":flag-is:",

    "category": "f",
    "emoji_order": "2301"
  },
  {
    "name": "flag-it",
    "unicode": "1f1ee-1f1f9",
    // "shortname": ":flag-it:",

    "category": "f",
    "emoji_order": "2302"
  },
  {
    "name": "flag-je",
    "unicode": "1f1ef-1f1ea",
    // "shortname": ":flag-je:",

    "category": "f",
    "emoji_order": "2303"
  },
  {
    "name": "flag-jm",
    "unicode": "1f1ef-1f1f2",
    // "shortname": ":flag-jm:",

    "category": "f",
    "emoji_order": "2304"
  },
  {
    "name": "flag-jo",
    "unicode": "1f1ef-1f1f4",
    // "shortname": ":flag-jo:",

    "category": "f",
    "emoji_order": "2305"
  },
  {
    "name": "flag-jp",
    "unicode": "1f1ef-1f1f5",
    // "shortname": ":flag-jp:",

    "category": "f",
    "emoji_order": "2306"
  },
  {
    "name": "flag-ke",
    "unicode": "1f1f0-1f1ea",
    // "shortname": ":flag-ke:",

    "category": "f",
    "emoji_order": "2307"
  },
  {
    "name": "flag-kg",
    "unicode": "1f1f0-1f1ec",
    // "shortname": ":flag-kg:",

    "category": "f",
    "emoji_order": "2308"
  },
  {
    "name": "flag-kh",
    "unicode": "1f1f0-1f1ed",
    // "shortname": ":flag-kh:",

    "category": "f",
    "emoji_order": "2309"
  },
  {
    "name": "flag-ki",
    "unicode": "1f1f0-1f1ee",
    // "shortname": ":flag-ki:",

    "category": "f",
    "emoji_order": "2310"
  },
  {
    "name": "flag-km",
    "unicode": "1f1f0-1f1f2",
    // "shortname": ":flag-km:",

    "category": "f",
    "emoji_order": "2311"
  },
  {
    "name": "flag-kn",
    "unicode": "1f1f0-1f1f3",
    // "shortname": ":flag-kn:",

    "category": "f",
    "emoji_order": "2312"
  },
  {
    "name": "flag-kp",
    "unicode": "1f1f0-1f1f5",
    // "shortname": ":flag-kp:",

    "category": "f",
    "emoji_order": "2313"
  },
  {
    "name": "flag-kr",
    "unicode": "1f1f0-1f1f7",
    // "shortname": ":flag-kr:",

    "category": "f",
    "emoji_order": "2314"
  },
  {
    "name": "flag-kw",
    "unicode": "1f1f0-1f1fc",
    // "shortname": ":flag-kw:",

    "category": "f",
    "emoji_order": "2315"
  },
  {
    "name": "flag-ky",
    "unicode": "1f1f0-1f1fe",
    // "shortname": ":flag-ky:",

    "category": "f",
    "emoji_order": "2316"
  },
  {
    "name": "flag-kz",
    "unicode": "1f1f0-1f1ff",
    // "shortname": ":flag-kz:",

    "category": "f",
    "emoji_order": "2317"
  },
  {
    "name": "flag-la",
    "unicode": "1f1f1-1f1e6",
    // "shortname": ":flag-la:",

    "category": "f",
    "emoji_order": "2318"
  },
  {
    "name": "flag-lb",
    "unicode": "1f1f1-1f1e7",
    // "shortname": ":flag-lb:",

    "category": "f",
    "emoji_order": "2319"
  },
  {
    "name": "flag-lc",
    "unicode": "1f1f1-1f1e8",
    // "shortname": ":flag-lc:",

    "category": "f",
    "emoji_order": "2320"
  },
  {
    "name": "flag-li",
    "unicode": "1f1f1-1f1ee",
    // "shortname": ":flag-li:",

    "category": "f",
    "emoji_order": "2321"
  },
  {
    "name": "flag-lk",
    "unicode": "1f1f1-1f1f0",
    // "shortname": ":flag-lk:",

    "category": "f",
    "emoji_order": "2322"
  },
  {
    "name": "flag-lr",
    "unicode": "1f1f1-1f1f7",
    // "shortname": ":flag-lr:",

    "category": "f",
    "emoji_order": "2323"
  },
  {
    "name": "flag-ls",
    "unicode": "1f1f1-1f1f8",
    // "shortname": ":flag-ls:",

    "category": "f",
    "emoji_order": "2324"
  },
  {
    "name": "flag-lt",
    "unicode": "1f1f1-1f1f9",
    // "shortname": ":flag-lt:",

    "category": "f",
    "emoji_order": "2325"
  },
  {
    "name": "flag-lu",
    "unicode": "1f1f1-1f1fa",
    // "shortname": ":flag-lu:",

    "category": "f",
    "emoji_order": "2326"
  },
  {
    "name": "flag-lv",
    "unicode": "1f1f1-1f1fb",
    // "shortname": ":flag-lv:",

    "category": "f",
    "emoji_order": "2327"
  },
  {
    "name": "flag-ly",
    "unicode": "1f1f1-1f1fe",
    // "shortname": ":flag-ly:",

    "category": "f",
    "emoji_order": "2328"
  },
  {
    "name": "flag-ma",
    "unicode": "1f1f2-1f1e6",
    // "shortname": ":flag-ma:",

    "category": "f",
    "emoji_order": "2329"
  },
  {
    "name": "flag-mc",
    "unicode": "1f1f2-1f1e8",
    // "shortname": ":flag-mc:",

    "category": "f",
    "emoji_order": "2330"
  },
  {
    "name": "flag-md",
    "unicode": "1f1f2-1f1e9",
    // "shortname": ":flag-md:",

    "category": "f",
    "emoji_order": "2331"
  },
  {
    "name": "flag-me",
    "unicode": "1f1f2-1f1ea",
    // "shortname": ":flag-me:",

    "category": "f",
    "emoji_order": "2332"
  },
  {
    "name": "flag-mf",
    "unicode": "1f1f2-1f1eb",
    // "shortname": ":flag-mf:",

    "category": "f",
    "emoji_order": "2333"
  },
  {
    "name": "flag-mg",
    "unicode": "1f1f2-1f1ec",
    // "shortname": ":flag-mg:",

    "category": "f",
    "emoji_order": "2334"
  },
  {
    "name": "flag-mh",
    "unicode": "1f1f2-1f1ed",
    // "shortname": ":flag-mh:",

    "category": "f",
    "emoji_order": "2335"
  },
  {
    "name": "flag-mk",
    "unicode": "1f1f2-1f1f0",
    // "shortname": ":flag-mk:",

    "category": "f",
    "emoji_order": "2336"
  },
  {
    "name": "flag-ml",
    "unicode": "1f1f2-1f1f1",
    // "shortname": ":flag-ml:",

    "category": "f",
    "emoji_order": "2337"
  },
  {
    "name": "flag-mm",
    "unicode": "1f1f2-1f1f2",
    // "shortname": ":flag-mm:",

    "category": "f",
    "emoji_order": "2338"
  },
  {
    "name": "flag-mn",
    "unicode": "1f1f2-1f1f3",
    // "shortname": ":flag-mn:",

    "category": "f",
    "emoji_order": "2339"
  },
  {
    "name": "flag-mo",
    "unicode": "1f1f2-1f1f4",
    // "shortname": ":flag-mo:",

    "category": "f",
    "emoji_order": "2340"
  },
  {
    "name": "flag-mp",
    "unicode": "1f1f2-1f1f5",
    // "shortname": ":flag-mp:",

    "category": "f",
    "emoji_order": "2341"
  },
  {
    "name": "flag-mq",
    "unicode": "1f1f2-1f1f6",
    // "shortname": ":flag-mq:",

    "category": "f",
    "emoji_order": "2342"
  },
  {
    "name": "flag-mr",
    "unicode": "1f1f2-1f1f7",
    // "shortname": ":flag-mr:",

    "category": "f",
    "emoji_order": "2343"
  },
  {
    "name": "flag-ms",
    "unicode": "1f1f2-1f1f8",
    // "shortname": ":flag-ms:",

    "category": "f",
    "emoji_order": "2344"
  },
  {
    "name": "flag-mt",
    "unicode": "1f1f2-1f1f9",
    // "shortname": ":flag-mt:",

    "category": "f",
    "emoji_order": "2345"
  },
  {
    "name": "flag-mu",
    "unicode": "1f1f2-1f1fa",
    // "shortname": ":flag-mu:",

    "category": "f",
    "emoji_order": "2346"
  },
  {
    "name": "flag-mv",
    "unicode": "1f1f2-1f1fb",
    // "shortname": ":flag-mv:",

    "category": "f",
    "emoji_order": "2347"
  },
  {
    "name": "flag-mw",
    "unicode": "1f1f2-1f1fc",
    // "shortname": ":flag-mw:",

    "category": "f",
    "emoji_order": "2348"
  },
  {
    "name": "flag-mx",
    "unicode": "1f1f2-1f1fd",
    // "shortname": ":flag-mx:",

    "category": "f",
    "emoji_order": "2349"
  },
  {
    "name": "flag-my",
    "unicode": "1f1f2-1f1fe",
    // "shortname": ":flag-my:",

    "category": "f",
    "emoji_order": "2350"
  },
  {
    "name": "flag-mz",
    "unicode": "1f1f2-1f1ff",
    // "shortname": ":flag-mz:",

    "category": "f",
    "emoji_order": "2351"
  },
  {
    "name": "flag-na",
    "unicode": "1f1f3-1f1e6",
    // "shortname": ":flag-na:",

    "category": "f",
    "emoji_order": "2352"
  },
  {
    "name": "flag-nc",
    "unicode": "1f1f3-1f1e8",
    // "shortname": ":flag-nc:",

    "category": "f",
    "emoji_order": "2353"
  },
  {
    "name": "flag-ne",
    "unicode": "1f1f3-1f1ea",
    // "shortname": ":flag-ne:",

    "category": "f",
    "emoji_order": "2354"
  },
  {
    "name": "flag-nf",
    "unicode": "1f1f3-1f1eb",
    // "shortname": ":flag-nf:",

    "category": "f",
    "emoji_order": "2355"
  },
  {
    "name": "flag-ng",
    "unicode": "1f1f3-1f1ec",
    // "shortname": ":flag-ng:",

    "category": "f",
    "emoji_order": "2356"
  },
  {
    "name": "flag-ni",
    "unicode": "1f1f3-1f1ee",
    // "shortname": ":flag-ni:",

    "category": "f",
    "emoji_order": "2357"
  },
  {
    "name": "flag-nl",
    "unicode": "1f1f3-1f1f1",
    // "shortname": ":flag-nl:",

    "category": "f",
    "emoji_order": "2358"
  },
  {
    "name": "flag-no",
    "unicode": "1f1f3-1f1f4",
    // "shortname": ":flag-no:",

    "category": "f",
    "emoji_order": "2359"
  },
  {
    "name": "flag-np",
    "unicode": "1f1f3-1f1f5",
    // "shortname": ":flag-np:",

    "category": "f",
    "emoji_order": "2360"
  },
  {
    "name": "flag-nr",
    "unicode": "1f1f3-1f1f7",
    // "shortname": ":flag-nr:",

    "category": "f",
    "emoji_order": "2361"
  },
  {
    "name": "flag-nu",
    "unicode": "1f1f3-1f1fa",
    // "shortname": ":flag-nu:",

    "category": "f",
    "emoji_order": "2362"
  },
  {
    "name": "flag-nz",
    "unicode": "1f1f3-1f1ff",
    // "shortname": ":flag-nz:",

    "category": "f",
    "emoji_order": "2363"
  },
  {
    "name": "flag-om",
    "unicode": "1f1f4-1f1f2",
    // "shortname": ":flag-om:",

    "category": "f",
    "emoji_order": "2364"
  },
  {
    "name": "flag-pa",
    "unicode": "1f1f5-1f1e6",
    // "shortname": ":flag-pa:",

    "category": "f",
    "emoji_order": "2365"
  },
  {
    "name": "flag-pe",
    "unicode": "1f1f5-1f1ea",
    // "shortname": ":flag-pe:",

    "category": "f",
    "emoji_order": "2366"
  },
  {
    "name": "flag-pf",
    "unicode": "1f1f5-1f1eb",
    // "shortname": ":flag-pf:",

    "category": "f",
    "emoji_order": "2367"
  },
  {
    "name": "flag-pg",
    "unicode": "1f1f5-1f1ec",
    // "shortname": ":flag-pg:",

    "category": "f",
    "emoji_order": "2368"
  },
  {
    "name": "flag-ph",
    "unicode": "1f1f5-1f1ed",
    // "shortname": ":flag-ph:",

    "category": "f",
    "emoji_order": "2369"
  },
  {
    "name": "flag-pk",
    "unicode": "1f1f5-1f1f0",
    // "shortname": ":flag-pk:",

    "category": "f",
    "emoji_order": "2370"
  },
  {
    "name": "flag-pl",
    "unicode": "1f1f5-1f1f1",
    // "shortname": ":flag-pl:",

    "category": "f",
    "emoji_order": "2371"
  },
  {
    "name": "flag-pm",
    "unicode": "1f1f5-1f1f2",
    // "shortname": ":flag-pm:",

    "category": "f",
    "emoji_order": "2372"
  },
  {
    "name": "flag-pn",
    "unicode": "1f1f5-1f1f3",
    // "shortname": ":flag-pn:",

    "category": "f",
    "emoji_order": "2373"
  },
  {
    "name": "flag-pr",
    "unicode": "1f1f5-1f1f7",
    // "shortname": ":flag-pr:",

    "category": "f",
    "emoji_order": "2374"
  },
  {
    "name": "flag-ps",
    "unicode": "1f1f5-1f1f8",
    // "shortname": ":flag-ps:",

    "category": "f",
    "emoji_order": "2375"
  },
  {
    "name": "flag-pt",
    "unicode": "1f1f5-1f1f9",
    // "shortname": ":flag-pt:",

    "category": "f",
    "emoji_order": "2376"
  },
  {
    "name": "flag-pw",
    "unicode": "1f1f5-1f1fc",
    // "shortname": ":flag-pw:",

    "category": "f",
    "emoji_order": "2377"
  },
  {
    "name": "flag-py",
    "unicode": "1f1f5-1f1fe",
    // "shortname": ":flag-py:",

    "category": "f",
    "emoji_order": "2378"
  },
  {
    "name": "flag-qa",
    "unicode": "1f1f6-1f1e6",
    // "shortname": ":flag-qa:",

    "category": "f",
    "emoji_order": "2379"
  },
  {
    "name": "flag-re",
    "unicode": "1f1f7-1f1ea",
    // "shortname": ":flag-re:",

    "category": "f",
    "emoji_order": "2380"
  },
  {
    "name": "flag-ro",
    "unicode": "1f1f7-1f1f4",
    // "shortname": ":flag-ro:",

    "category": "f",
    "emoji_order": "2381"
  },
  {
    "name": "flag-rs",
    "unicode": "1f1f7-1f1f8",
    // "shortname": ":flag-rs:",

    "category": "f",
    "emoji_order": "2382"
  },
  {
    "name": "flag-ru",
    "unicode": "1f1f7-1f1fa",
    // "shortname": ":flag-ru:",

    "category": "f",
    "emoji_order": "2383"
  },
  {
    "name": "flag-rw",
    "unicode": "1f1f7-1f1fc",
    // "shortname": ":flag-rw:",

    "category": "f",
    "emoji_order": "2384"
  },
  {
    "name": "flag-sa",
    "unicode": "1f1f8-1f1e6",
    // "shortname": ":flag-sa:",

    "category": "f",
    "emoji_order": "2385"
  },



  {
    "name": "flag-sb",
    "unicode": "1f1f8-1f1e7",
    // "shortname": ":flag-sb:",

    "category": "f",
    "emoji_order": "2386"
  },
  {
    "name": "flag-sc",
    "unicode": "1f1f8-1f1e8",
    // "shortname": ":flag-sc:",

    "category": "f",
    "emoji_order": "2387"
  },
  {
    "name": "flag-sd",
    "unicode": "1f1f8-1f1e9",
    // "shortname": ":flag-sd:",

    "category": "f",
    "emoji_order": "2388"
  },
  {
    "name": "flag-se",
    "unicode": "1f1f8-1f1ea",
    // "shortname": ":flag-se:",

    "category": "f",
    "emoji_order": "2389"
  },
  {
    "name": "flag-sg",
    "unicode": "1f1f8-1f1ec",
    // "shortname": ":flag-sg:",

    "category": "f",
    "emoji_order": "2390"
  },
  {
    "name": "flag-sh",
    "unicode": "1f1f8-1f1ed",
    // "shortname": ":flag-sh:",

    "category": "f",
    "emoji_order": "2391"
  },
  {
    "name": "flag-si",
    "unicode": "1f1f8-1f1ee",
    // "shortname": ":flag-si:",

    "category": "f",
    "emoji_order": "2392"
  },
  {
    "name": "flag-sj",
    "unicode": "1f1f8-1f1ef",
    // "shortname": ":flag-sj:",

    "category": "f",
    "emoji_order": "2393"
  },
  {
    "name": "flag-sk",
    "unicode": "1f1f8-1f1f0",
    // "shortname": ":flag-sk:",

    "category": "f",
    "emoji_order": "2394"
  },
  {
    "name": "flag-sl",
    "unicode": "1f1f8-1f1f1",
    // "shortname": ":flag-sl:",

    "category": "f",
    "emoji_order": "2395"
  },
  {
    "name": "flag-sm",
    "unicode": "1f1f8-1f1f2",
    // "shortname": ":flag-sm:",

    "category": "f",
    "emoji_order": "2396"
  },
  {
    "name": "flag-sn",
    "unicode": "1f1f8-1f1f3",
    // "shortname": ":flag-sn:",

    "category": "f",
    "emoji_order": "2397"
  },
  {
    "name": "flag-so",
    "unicode": "1f1f8-1f1f4",
    // "shortname": ":flag-so:",

    "category": "f",
    "emoji_order": "2398"
  },
  {
    "name": "flag-sr",
    "unicode": "1f1f8-1f1f7",
    // "shortname": ":flag-sr:",

    "category": "f",
    "emoji_order": "2399"
  },
  {
    "name": "flag-ss",
    "unicode": "1f1f8-1f1f8",
    // "shortname": ":flag-ss:",

    "category": "f",
    "emoji_order": "2400"
  },
  {
    "name": "flag-st",
    "unicode": "1f1f8-1f1f9",
    // "shortname": ":flag-st:",

    "category": "f",
    "emoji_order": "2401"
  },
  {
    "name": "flag-sv",
    "unicode": "1f1f8-1f1fb",
    // "shortname": ":flag-sv:",

    "category": "f",
    "emoji_order": "2402"
  },
  {
    "name": "flag-sx",
    "unicode": "1f1f8-1f1fd",
    // "shortname": ":flag-sx:",

    "category": "f",
    "emoji_order": "2403"
  },
  {
    "name": "flag-sy",
    "unicode": "1f1f8-1f1fe",
    // "shortname": ":flag-sy:",

    "category": "f",
    "emoji_order": "2404"
  },
  {
    "name": "flag-sz",
    "unicode": "1f1f8-1f1ff",
    // "shortname": ":flag-sz:",

    "category": "f",
    "emoji_order": "2405"
  },
  {
    "name": "flag-ta",
    "unicode": "1f1f9-1f1e6",
    // "shortname": ":flag-ta:",

    "category": "f",
    "emoji_order": "2406"
  },
  {
    "name": "flag-tc",
    "unicode": "1f1f9-1f1e8",
    // "shortname": ":flag-tc:",

    "category": "f",
    "emoji_order": "2407"
  },
  {
    "name": "flag-td",
    "unicode": "1f1f9-1f1e9",
    // "shortname": ":flag-td:",

    "category": "f",
    "emoji_order": "2408"
  },
  {
    "name": "flag-tf",
    "unicode": "1f1f9-1f1eb",
    // "shortname": ":flag-tf:",

    "category": "f",
    "emoji_order": "2409"
  },
  {
    "name": "flag-tg",
    "unicode": "1f1f9-1f1ec",
    // "shortname": ":flag-tg:",

    "category": "f",
    "emoji_order": "2410"
  },
  {
    "name": "flag-th",
    "unicode": "1f1f9-1f1ed",
    // "shortname": ":flag-th:",

    "category": "f",
    "emoji_order": "2411"
  },
  {
    "name": "flag-tj",
    "unicode": "1f1f9-1f1ef",
    // "shortname": ":flag-tj:",

    "category": "f",
    "emoji_order": "2412"
  },
  {
    "name": "flag-tk",
    "unicode": "1f1f9-1f1f0",
    // "shortname": ":flag-tk:",

    "category": "f",
    "emoji_order": "2413"
  },
  {
    "name": "flag-tl",
    "unicode": "1f1f9-1f1f1",
    // "shortname": ":flag-tl:",

    "category": "f",
    "emoji_order": "2414"
  },
  {
    "name": "flag-tm",
    "unicode": "1f1f9-1f1f2",
    // "shortname": ":flag-tm:",

    "category": "f",
    "emoji_order": "2415"
  },
  {
    "name": "flag-tn",
    "unicode": "1f1f9-1f1f3",
    // "shortname": ":flag-tn:",

    "category": "f",
    "emoji_order": "2416"
  },
  {
    "name": "flag-to",
    "unicode": "1f1f9-1f1f4",
    // "shortname": ":flag-to:",

    "category": "f",
    "emoji_order": "2417"
  },
  {
    "name": "flag-tr",
    "unicode": "1f1f9-1f1f7",
    // "shortname": ":flag-tr:",

    "category": "f",
    "emoji_order": "2418"
  },
  {
    "name": "flag-tt",
    "unicode": "1f1f9-1f1f9",
    // "shortname": ":flag-tt:",

    "category": "f",
    "emoji_order": "2419"
  },
  {
    "name": "flag-tv",
    "unicode": "1f1f9-1f1fb",
    // "shortname": ":flag-tv:",

    "category": "f",
    "emoji_order": "2420"
  },
  {
    "name": "flag-tw",
    "unicode": "1f1f9-1f1fc",
    // "shortname": ":flag-tw:",

    "category": "f",
    "emoji_order": "2421"
  },
  {
    "name": "flag-tz",
    "unicode": "1f1f9-1f1ff",
    // "shortname": ":flag-tz:",

    "category": "f",
    "emoji_order": "2422"
  },
  {
    "name": "flag-ua",
    "unicode": "1f1fa-1f1e6",
    // "shortname": ":flag-ua:",

    "category": "f",
    "emoji_order": "2423"
  },
  {
    "name": "flag-ug",
    "unicode": "1f1fa-1f1ec",
    // "shortname": ":flag-ug:",

    "category": "f",
    "emoji_order": "2424"
  },
  {
    "name": "flag-um",
    "unicode": "1f1fa-1f1f2",
    // "shortname": ":flag-um:",

    "category": "f",
    "emoji_order": "2425"
  },
  {
    "name": "flag-us",
    "unicode": "1f1fa-1f1f8",
    // "shortname": ":flag-us:",

    "category": "f",
    "emoji_order": "2427"
  },
  {
    "name": "flag-uy",
    "unicode": "1f1fa-1f1fe",
    // "shortname": ":flag-uy:",

    "category": "f",
    "emoji_order": "2428"
  },
  {
    "name": "flag-uz",
    "unicode": "1f1fa-1f1ff",
    // "shortname": ":flag-uz:",

    "category": "f",
    "emoji_order": "2429"
  },
  {
    "name": "flag-va",
    "unicode": "1f1fb-1f1e6",
    // "shortname": ":flag-va:",

    "category": "f",
    "emoji_order": "2430"
  },
  {
    "name": "flag-vc",
    "unicode": "1f1fb-1f1e8",
    // "shortname": ":flag-vc:",

    "category": "f",
    "emoji_order": "2431"
  },
  {
    "name": "flag-ve",
    "unicode": "1f1fb-1f1ea",
    // "shortname": ":flag-ve:",

    "category": "f",
    "emoji_order": "2432"
  },
  {
    "name": "flag-vg",
    "unicode": "1f1fb-1f1ec",
    // "shortname": ":flag-vg:",

    "category": "f",
    "emoji_order": "2433"
  },
  {
    "name": "flag-vi",
    "unicode": "1f1fb-1f1ee",
    // "shortname": ":flag-vi:",

    "category": "f",
    "emoji_order": "2434"
  },
  {
    "name": "flag-vn",
    "unicode": "1f1fb-1f1f3",
    // "shortname": ":flag-vn:",

    "category": "f",
    "emoji_order": "2435"
  },

  {
    "name": "flag-vu",
    "unicode": "1f1fb-1f1fa",
    // "shortname": ":flag_vu:",

    "category": "f",
    "emoji_order": "2436"
  },
  {
    "name": "flag-wf",
    "unicode": "1f1fc-1f1eb",
    // "shortname": ":flag_wf:",

    "category": "f",
    "emoji_order": "2437"
  },
  {
    "name": "flag-ws",
    "unicode": "1f1fc-1f1f8",
    // "shortname": ":flag_ws:",

    "category": "f",
    "emoji_order": "2438"
  },
  {
    "name": "flag-xk",
    "unicode": "1f1fd-1f1f0",
    // "shortname": ":flag_xk:",

    "category": "f",
    "emoji_order": "2439"
  },
  {
    "name": "flag-ye",
    "unicode": "1f1fe-1f1ea",
    // "shortname": ":flag_ye:",

    "category": "f",
    "emoji_order": "2440"
  },
  {
    "name": "flag-yt",
    "unicode": "1f1fe-1f1f9",
    // "shortname": ":flag_yt:",

    "category": "f",
    "emoji_order": "2441"
  },
  {
    "name": "flag-za",
    "unicode": "1f1ff-1f1e6",
    // "shortname": ":flag_za:",

    "category": "f",
    "emoji_order": "2442"
  },
  {
    "name": "flag-zm",
    "unicode": "1f1ff-1f1f2",
    // "shortname": ":flag_zm:",

    "category": "f",
    "emoji_order": "2443"
  },
  {
    "name": "flag-zw",
    "unicode": "1f1ff-1f1fc",
    // "shortname": ":flag_zw:",

    "category": "f",
    "emoji_order": "2444"
  },
  {
    "name": "speech",
    "unicode": "\u{1f600}",
    // "shortname": ":speech:",

    "category": "p",
    "emoji_order": "1"
  }
];

export default emojiList;
